<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="d-flex flex-wrap align-items-center justify-content-between mb-4">
                    <div style="flex: 1;">
                        <h4 class="mb-2">{{ title }}</h4>
                        <p class="mb-2" style="font-size: 0.9rem;">
                            해당 메뉴는 1688 등 해외 공급처로부터 상품을 구매하여 요청하신 지정지(센터/물류창고/매장 등)로 직납하는 기능입니다.<br>
                            <span style="font-size: 0.85rem;">현재 1688을 통한 공급이 가능하며, (기타 소싱처는 문의) 상품 등록 후 견적서 제공, 예치금 선입금 및 발주 확정 절차가 진행됩니다.</span>
                        </p>

                        <div class="row" style="font-size: 0.85rem;">
                            <div class="col-md-4 mb-2">
                                <div class="p-2 border rounded" style="background-color: #f8f9fa;">
                                    <strong style="color: #0066cc;">📦 쿠패스통합통관</strong>
                                    <div class="mt-1" style="font-size: 0.8rem; line-height: 1.4;">
                                        • (주)쿠패스 매입·통관<br>
                                        • 도매 공급 (공급가 + 부가세 10%)<br>
                                        • 전자세금계산서 발행
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                                <div class="p-2 border rounded" style="background-color: #f8f9fa;">
                                    <strong style="color: #28a745;">🚚 사업자단독통관</strong>
                                    <div class="mt-1" style="font-size: 0.8rem; line-height: 1.4;">
                                        • 신청 사업자 통관<br>
                                        • 구매대행 방식 (수수료 3%)<br>
                                        • 관부가세, 해운비, 통관비 등 별도
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-4 mb-2">
                            </div>
                        </div>
                    </div>
                    <div class="ml-4 text-center">
                        <a href="http://pf.kakao.com/_AxcWvxj" target="_blank" class="btn btn-primary btn-lg" style="white-space: nowrap; padding: 12px 24px; font-size: 1rem; font-weight: bold;">
                            <i class="ri-customer-service-2-line mr-2"></i>쿠패스 전용 채널톡
                        </a>
                        <!-- 환율 정보 표시 -->
                        <div v-if="exchangeRate" class="mt-2" style="font-size: 0.8rem; color: #888; line-height: 1.4;">
                            <div>단독통관 : <span style="color: #333;">{{ exchangeRate.cashBuyValue }}원/위안</span></div>
                            <div>통합통관 : <span style="color: #333;">{{ integratedExchangeRate }}원/위안</span></div>
                        </div>
                    </div>
                </div>
                <!-- <div class="d-flex float-right"><button type="button" class="btn btn-primary mr-2" v-b-modal.modal-2>견적서</button></div> -->

                <b-modal id="modal-2" size="xl" title="견적서" ok-only>
                    <div class="text-center">
                        <h3 class="mb-2">적용 회원등급 : {{ $store.state.user.grade.toUpperCase() }}</h3>
                        <img style="max-width:100%;" :src="require('../../../assets/images/small/견적서.jpg')">
                    </div>
                </b-modal>

                <tab-nav :tabs="true" id="myTab-1">
                    <tab-nav-items :active="true" id="req-tab" ariaControls="req" role="tab" :ariaSelected="true"
                        title="구매요청" />
                    <tab-nav-items :active="false" id="list-tab" ariaControls="list" role="tab" :ariaSelected="false">
                        <template v-slot:title>구매요청내역
                            <span v-if="$store.state.sseNotifications.quotation_created > 0" style="display:inline-block;width:8px;height:8px;background:#dc3545;border-radius:50%;margin-left:4px;vertical-align:middle;"></span>
                        </template>
                    </tab-nav-items>
                </tab-nav>

                <tab-content id="myTabContent">
                    <tab-content-item :active="true" id="req" aria-labelled-by="req-tab">

                        <div class="row" v-if="showlist">
                            <div class="col-12">
                                <div class="table-responsive">
                                    <table id="datatable" class="table data-table table-striped dataTable">
                                        <thead>
                                            <tr class="ligth ligth-data">
                                                <th>
                                                    <div class="checkbox d-inline-block">
                                                        <input type="checkbox" class="checkbox-input" id="checkbox1"
                                                            v-model="allchecked" @change="allchecklist(allchecked)">
                                                        <label for="checkbox1" class="mb-0"></label>
                                                    </div>
                                                </th>
                                                <th style="min-width:200px;">제품정보</th>
                                                <th>상품매칭</th>
                                                <th style="max-width:300px;overflow:hidden;text-overflow: ellipsis;">
                                                    구매링크</th>
                                                <th>옵션1_중국어</th>
                                                <th>옵션2_중국어</th>
                                                <!-- <th>구매가격</th> -->
                                                <th>구매재고</th>
                                                <th>요청사항</th>
                                                <th>구매요청수량</th>
                                                <th>Actions</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(list, index) in lists" :key="index">
                                                <td>
                                                    <div class="checkbox d-inline-block">
                                                        <input type="checkbox" class="checkbox-input" id="checkbox2"
                                                            v-model="list.checked">
                                                        <label for="checkbox2" class="mb-0"></label>
                                                    </div>
                                                </td>
                                                <!-- <td>{{list.SKUID}}</td> -->

                                                <td style="min-width:200px;">
                                                    <div class="d-flex align-items-center">
                                                        <!-- <div class="d-flex align-items-center" @click="clickProductName(list)"> -->
                                                        <img :src="list.등록이미지" class="img-fluid rounded avatar-80 mr-3"
                                                            alt="image" v-if="list.등록이미지">
                                                        <div v-if="list.상품명">
                                                            {{ list.상품명 }}
                                                            <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                        </div>
                                                        <div v-else>
                                                            <input type="text" class="form-control" placeholder="상품명입력"
                                                                v-model="list.상품명init" @change="addProductName(list)">
                                                            <p class="mb-0"><small>{{ list.바코드 }}</small></p>
                                                        </div>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div :class="matchclass(list.매칭상태)">{{ list.매칭상태 }}</div>
                                                </td>
                                                <td style="max-width:300px;overflow:hidden;text-overflow: ellipsis;">
                                                    <div v-if="list.구매링크 !== undefined">
                                                        <a :href="list.구매링크" target="_blank">{{ list.구매링크 }}</a>
                                                        <div v-if="list.showspinner">
                                                            <img style="width:20%;"
                                                                :src="require('../../../assets/images/small/loading.gif')">
                                                        </div>
                                                    </div>
                                                    <div v-else>
                                                        <input type="text" class="form-control" placeholder="구매링크입력"
                                                            v-model="list.구매링크init"
                                                            @change="matchoption1(index, list.구매링크init)">
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="list.옵션이미지 !== undefined">
                                                        <img :src="list.옵션이미지" class="img-fluid rounded avatar-80 mr-3"
                                                            alt="image">
                                                    </div>
                                                    <div v-if="list.옵션1_중국어 !== undefined">
                                                        {{ list.옵션1_중국어 }}
                                                    </div>
                                                    <div v-else>
                                                        <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                            variant="link" toggle-class="text-decoration-none" no-caret>
                                                            <template #button-content>
                                                                &#x1f50d;<span class="sr-only">Search</span>
                                                            </template>
                                                            <b-dropdown-item href="#" v-for="a, i in list.상품매칭.옵션1_중국어"
                                                                :key="i" @click="option1matching(a, list)">
                                                                <div class="d-flex align-items-center">
                                                                    <img v-if="a.imageUrl.length > 0" :src="a.imageUrl"
                                                                        class="img-fluid rounded avatar-80 mr-3"
                                                                        alt="image">
                                                                    <div>
                                                                        {{ a.name }}
                                                                    </div>
                                                                </div>
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div v-if="list.옵션2_중국어 !== undefined">
                                                        {{ list.옵션2_중국어 }}
                                                    </div>
                                                    <div v-else>
                                                        <b-dropdown menu-class="my-dropdown-class" size="lg"
                                                            variant="link" toggle-class="text-decoration-none" no-caret>
                                                            <template #button-content>
                                                                &#x1f50d;<span class="sr-only">Search</span>
                                                            </template>
                                                            <b-dropdown-item href="#" v-for="a, i in list.상품매칭.옵션2_중국어"
                                                                :key="i" @click="option2matching(a, list)">
                                                                <div class="d-flex align-items-center">
                                                                    <img v-if="a.imageUrl.length > 0" :src="a.imageUrl"
                                                                        class="img-fluid rounded avatar-80 mr-3"
                                                                        alt="image">
                                                                    <div>
                                                                        {{ a.name }}
                                                                    </div>
                                                                </div>
                                                            </b-dropdown-item>
                                                        </b-dropdown>
                                                    </div>
                                                </td>
                                                <!-- <td>
                                                        {{list.구매가격}}
                                                        <small>({{list.이전구매가격}})</small>
                                                    </td> -->
                                                <td>{{ list.구매재고 }}</td>
                                                <td>
                                                    <div :class="reqclass(list.요청사항)" @click="regrequest(list, index)">
                                                        {{ list.요청사항 }}</div>

                                                    <b-modal :id="'modalreq' + index" size="xl" title="구매요청사항"
                                                        ok-title="요청저장" cancel-title="취소"
                                                        @ok="savereq($event, list, index)" scrollable>
                                                        <div class="reqpo-purchase-request-form">
                                                            <div class="row">
                                                                <!-- Row 1: Items 1-2 -->
                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">1. 구매요청수량</div>
                                                                        <div class="reqpo-input-wrapper">
                                                                            <div class="d-flex align-items-center">
                                                                                <input type="number" :min="0"
                                                                                    class="form-control text-center"
                                                                                    style="width: 120px;"
                                                                                    :disabled="qtyLocked(list)" v-model="list.구매요청수량"
                                                                                    @keyup.enter="validateQuantity(list)">
<small v-if="qtyLocked(list)" class="text-danger ml-2">已进入采购流程，不能修改，请联系客服(구매전이 아니라 수정 불가 · 문의해 주세요)</small>
                                                                                <div class="reqpo-stock-info ml-3">
                                                                                    <span
                                                                                        class="reqpo-info-label">최소주문:</span>
                                                                                    <span class="reqpo-info-value">{{
                                                                                        getMinOrderQuantity(list)
                                                                                        }}개</span>
                                                                                    <span
                                                                                        class="reqpo-separator">/</span>
                                                                                    <span
                                                                                        class="reqpo-info-label">재고:</span>
                                                                                    <span class="reqpo-info-value">{{
                                                                                        getAvailableStock(list)
                                                                                        }}개</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">2. 판매구성수량</div>
                                                                        <div class="reqpo-input-wrapper">
                                                                            <input type="number" :min="0"
                                                                                class="form-control"
                                                                                style="width: 120px;"
                                                                                :disabled="qtyLocked(list)" v-model="list.판매구성수량"
                                                                                v-b-tooltip.hover="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">
<small v-if="qtyLocked(list)" class="text-danger ml-2">已进入采购流程，不能修改，请联系客服(구매전이 아니라 수정 불가 · 문의해 주세요)</small>
                                                                        </div>
                                                                    </div>

                                                                </div>

                                                                <!-- Row 2: Items 3-4 -->
                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">3. A-B번들 묶음구성여부
                                                                        </div>
                                                                        <div class="bundle-options">
                                                                            <div
                                                                                class="custom-control custom-switch d-inline-block">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'bundleSwitch' + index"
                                                                                    v-model="list.묶음구성여부"
                                                                                    @change="confirmBarcode(list)">
                                                                                <label class="custom-control-label"
                                                                                    :for="'bundleSwitch' + index">묶음구성</label>
                                                                            </div>
                                                                            <div v-if="list.묶음구성여부"
                                                                                class="bundle-count mt-2">
                                                                                <input type="number" :min="0"
                                                                                    class="form-control"
                                                                                    style="width: 120px;"
                                                                                    placeholder="종류갯수"
                                                                                    v-model="list.묶음구성수량"
                                                                                    v-b-tooltip.hover="'3종의 제품을 묶음 구성하는 경우 3으로 작성'">
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">4. 도착지</div>
                                                                        <div class="destination-options">
                                                                            <div class="btn-group w-100">
                                                                                <button type="button" class="btn"
                                                                                    :class="{ 'btn-primary': list.요청내역.destination === 'coupang', 'btn-outline-primary': list.요청내역.destination !== 'coupang' }"
                                                                                    @click="list.요청내역.destination = 'coupang'">
                                                                                    쿠팡센터
                                                                                </button>
                                                                                <button type="button" class="btn"
                                                                                    :class="{ 'btn-primary': list.요청내역.destination === 'customer', 'btn-outline-primary': list.요청내역.destination !== 'customer' }"
                                                                                    @click="list.요청내역.destination = 'customer'">
                                                                                    화주
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <!-- Row 3: Items 5-7 -->
                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">5. 출고형태</div>
                                                                        <div class="export-options">
                                                                            <div
                                                                                class="custom-control custom-radio mb-2">
                                                                                <input type="radio"
                                                                                    :id="'exportBox' + index"
                                                                                    name="exportType"
                                                                                    class="custom-control-input"
                                                                                    v-model="list.요청내역.exportType"
                                                                                    value="box">
                                                                                <label class="custom-control-label"
                                                                                    :for="'exportBox' + index">
                                                                                    <span
                                                                                        v-if="!list.요청내역.destination || list.요청내역.destination === 'coupang'">
                                                                                        밀크런 택배
                                                                                    </span>
                                                                                    <span v-else>택배</span>
                                                                                </label>
                                                                            </div>
                                                                            <div class="custom-control custom-radio">
                                                                                <input type="radio"
                                                                                    :id="'exportPallet' + index"
                                                                                    name="exportType"
                                                                                    class="custom-control-input"
                                                                                    v-model="list.요청내역.exportType"
                                                                                    value="pallet">
                                                                                <label class="custom-control-label"
                                                                                    :for="'exportPallet' + index">
                                                                                    <span
                                                                                        v-if="!list.요청내역.destination || list.요청내역.destination === 'coupang'">
                                                                                        밀크런 파렛트 <small
                                                                                            class="reqpo-text-muted">(￦35,000/pallet)</small>
                                                                                    </span>
                                                                                    <span v-else>
                                                                                        파렛트 <small
                                                                                            class="reqpo-text-muted">(￦20,000/pallet)</small>
                                                                                    </span>
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                    <!-- </div>

                                                                <div class="col-md-6"> -->
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">6. 통관정보</div>
                                                                        <div class="row">
                                                                            <div class="col-12 mb-3">
                                                                                <div class="form-group">
                                                                                    <label>신고영문명</label>
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) shoes"
                                                                                        v-model="list.신고영문명">
                                                                                </div>
                                                                            </div>
                                                                            <div class="col-12">
                                                                                <div class="form-group">
                                                                                    <label>HS-CODE</label>
                                                                                    <div class="d-flex">
                                                                                        <input type="text"
                                                                                            class="form-control"
                                                                                            placeholder="예) 6401.10-1000"
                                                                                            v-model="list.HSCODE">
                                                                                        <div
                                                                                            class="w-25 d-flex align-items-center">
                                                                                            <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                                                target="_blank"
                                                                                                class="btn btn-outline-secondary ml-2">
                                                                                                검색
                                                                                            </a></div>
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">7. 통관형태</div>
                                                                        <div class="customs-options">
                                                                            <div class="reqpo-custom-radio-card mb-2"
                                                                                :class="{ 'active': list.요청내역.customsType === 'integrated' }"
                                                                                @click="list.요청내역.customsType = 'integrated'">
                                                                                <div class="reqpo-card-title">쿠패스통합통관
                                                                                </div>
                                                                                <div class="reqpo-card-desc">위안화x290,
                                                                                    검수/포장비용 제외 모든비용 포함</div>
                                                                            </div>
                                                                            <div class="reqpo-custom-radio-card mb-2"
                                                                                :class="{ 'active': list.요청내역.customsType === 'client' }"
                                                                                @click="list.요청내역.customsType = 'client'">
                                                                                <div class="reqpo-card-title">화주단독통관
                                                                                </div>
                                                                                <div class="reqpo-card-desc">구매대행수수료3%,
                                                                                    자재, 관부가세, 해운비, 통관비, 통관서류 비용 등 별도
                                                                                </div>
                                                                            </div>
                                                                            <div class="reqpo-custom-radio-card"
                                                                                :class="{ 'active': list.요청내역.customsType === 'kupass' }"
                                                                                @click="list.요청내역.customsType = 'kupass'">
                                                                                <div class="reqpo-card-title">쿠패스단독통관
                                                                                </div>
                                                                                <div class="reqpo-card-desc">식검제품만 신청가능,
                                                                                    구매대행수수료3%, 자재, 관부가세, 해운비, 통관비, 통관서류
                                                                                    비용 등 별도
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <!-- Full width sections -->
                                                                <div class="col-md-6">
                                                                    <!-- 검수 및 포장 섹션 -->
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">8. 검수 및 포장
                                                                        </div>
                                                                        <div class="inspection-options">

                                                                            <!-- 패키징 옵션 -->
                                                                            <div v-if="list.요청내역.default"
                                                                                class="packaging-options mb-3">
                                                                                <div class="reqpo-option-title mb-2">포장
                                                                                    방법 선택:</div>
                                                                                <div
                                                                                    class="custom-control custom-radio mb-2">
                                                                                    <input type="radio"
                                                                                        :id="'packageAuto' + index"
                                                                                        name="packageMethod"
                                                                                        class="custom-control-input"
                                                                                        value="auto"
                                                                                        v-model="packageMethod"
                                                                                        @change="changePackage(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'packageAuto' + index">
                                                                                        포장 방법 위임
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-radio mb-2">
                                                                                    <input type="radio"
                                                                                        :id="'packageNo' + index"
                                                                                        name="packageMethod"
                                                                                        class="custom-control-input"
                                                                                        value="noPackage"
                                                                                        v-model="packageMethod"
                                                                                        @change="changePackage(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'packageNo' + index">
                                                                                        재포장 생략
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-radio mb-2">
                                                                                    <input type="radio"
                                                                                        :id="'packageOPP' + index"
                                                                                        name="packageMethod"
                                                                                        class="custom-control-input"
                                                                                        value="opp"
                                                                                        v-model="packageMethod"
                                                                                        @change="changePackage(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'packageOPP' + index">
                                                                                        투명 OPP 봉투 포장 (무료)
                                                                                    </label>
                                                                                </div>
                                                                                <div
                                                                                    class="custom-control custom-radio">
                                                                                    <input type="radio"
                                                                                        :id="'packageLDPE' + index"
                                                                                        name="packageMethod"
                                                                                        class="custom-control-input"
                                                                                        value="LDPE"
                                                                                        v-model="packageMethod"
                                                                                        @change="changePackage(list)">
                                                                                    <label class="custom-control-label"
                                                                                        :for="'packageLDPE' + index">
                                                                                        불투명 LDPE 봉투 포장 (무료)
                                                                                    </label>
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <div class="reqpo-option-group mb-3">
                                                                            <div class="custom-control custom-switch">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'defaultCheck' + index"
                                                                                    v-model="list.요청내역.default">
                                                                                <label class="custom-control-label"
                                                                                    :for="'defaultCheck' + index">
                                                                                    기본검수/분류/포장/포장자재 (￦200)
                                                                                </label>
                                                                            </div>
                                                                        </div>
                                                                        <!-- 라벨링 옵션 -->
                                                                        <div class="labeling-options mb-3">
                                                                            <div
                                                                                class="custom-control custom-switch mb-2">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'barcodeCheck' + index"
                                                                                    v-model="list.요청내역.barcode"
                                                                                    @change="changeBarcode(list)">
                                                                                <label class="custom-control-label"
                                                                                    :for="'barcodeCheck' + index">
                                                                                    바코드라벨 (Made in China,한글표시사항 기본포함)
                                                                                    (￦100)
                                                                                </label>
                                                                            </div>

                                                                            <div v-if="!list.요청내역.barcode"
                                                                                class="custom-control custom-switch">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'stickerCheck' + index"
                                                                                    v-model="list.요청내역.sticker">
                                                                                <label class="custom-control-label"
                                                                                    :for="'stickerCheck' + index">
                                                                                    원산지스티커 (￦100)
                                                                                </label>
                                                                            </div>
                                                                        </div>

                                                                        <!-- 추가 작업 옵션 -->
                                                                        <div class="additional-options">
                                                                            <div
                                                                                class="custom-control custom-switch mb-2">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'maskingCheck' + index"
                                                                                    v-model="list.요청내역.masking">
                                                                                <label class="custom-control-label"
                                                                                    :for="'maskingCheck' + index">
                                                                                    중국어 마스킹 (무료)
                                                                                </label>
                                                                            </div>

                                                                            <div
                                                                                class="custom-control custom-switch mb-2">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'airpackingCheck' + index"
                                                                                    v-model="list.요청내역.airpacking">
                                                                                <label class="custom-control-label"
                                                                                    :for="'airpackingCheck' + index">
                                                                                    에어캡 포장 (실비)
                                                                                </label>
                                                                            </div>
                                                                            <div
                                                                                class="custom-control custom-switch mb-2">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'sewingCheck' + index"
                                                                                    v-model="list.요청내역.sewing">
                                                                                <label class="custom-control-label"
                                                                                    :for="'sewingCheck' + index">
                                                                                    원산지라벨 봉제 (6000원/시간)
                                                                                </label>
                                                                                <div class="reqpo-warning-text">* 의류 수입
                                                                                    시 원산지 라벨봉제는 필수 사항입니다.</div>
                                                                            </div>

                                                                            <div
                                                                                class="custom-control custom-switch mb-2">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'stampCheck' + index"
                                                                                    v-model="list.요청내역.stamp">
                                                                                <label class="custom-control-label"
                                                                                    :for="'stampCheck' + index">
                                                                                    원산지 도장 (6000원/시간)
                                                                                </label>
                                                                                <div class="reqpo-warning-text">* 신발류 수입
                                                                                    시 제품에 원산지 라벨봉제 또는 원산지 도장은 필수 사항입니다.
                                                                                </div>
                                                                            </div>

                                                                            <div class="custom-control custom-switch">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input"
                                                                                    :id="'tagCheck' + index"
                                                                                    v-model="list.요청내역.tag">
                                                                                <label class="custom-control-label"
                                                                                    :for="'tagCheck' + index">
                                                                                    원산지 택(태그) (6000원/시간)
                                                                                </label>
                                                                                <div class="reqpo-warning-text">* 가방류 수입
                                                                                    시 원산지 라벨봉제 또는 원산지 택 표기가 필수 사항입니다.
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>


                                                                <div class="col-md-6">

                                                                    <!-- 한글표시사항 섹션 -->
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">9. 한글표시사항</div>

                                                                        <!-- 바코드라벨 미부착 시 경고 -->
                                                                        <div v-if="!list.요청내역.barcode"
                                                                            class="reqpo-warning-box mb-3">
                                                                            <div class="warning-content">
                                                                                <div class="warning-title">※ 바코드라벨을 부착하지
                                                                                    않는 경우,</div>
                                                                                <div class="reqpo-warning-text"
                                                                                    v-if="list.요청내역.destination === 'coupang'">
                                                                                    쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가
                                                                                    부착되거나 새겨져 있어야 합니다.
                                                                                </div>
                                                                                <div class="reqpo-warning-text"
                                                                                    v-if="list.요청내역.destination === 'customer'">
                                                                                    반드시 원산지표시가 되어 있어야 합니다.
                                                                                </div>
                                                                            </div>
                                                                        </div>

                                                                        <!-- 한글표시사항 입력 폼 -->
                                                                        <div v-if="list.요청내역.barcode"
                                                                            class="korean-label-form">
                                                                            <!-- 바코드 -->
                                                                            <div class="form-group mb-1">
                                                                                <label
                                                                                    class="col-form-label">바코드번호</label>
                                                                                <input type="text" class="form-control"
                                                                                    placeholder="예) S00012341234"
                                                                                    v-model="list.바코드">
                                                                                <small class="reqpo-warning-text">* 바코드는
                                                                                    쿠팡에 등록한 바코드번호를 입력해주세요</small>
                                                                            </div>

                                                                            <!-- 제품명 (별도 상단 배치) -->
                                                                            <div class="form-group mb-1">
                                                                                <label>제품명</label>
                                                                                <input type="text" class="form-control"
                                                                                    placeholder="예) 쿠플러스 예쁜접시, 10인치"
                                                                                    v-model="list.상품명">
                                                                                <small class="reqpo-warning-text">* 쿠팡에
                                                                                    등록한 상품명 + 옵션명을 같이 입력해주세요</small>
                                                                            </div>

                                                                            <!-- 기타 한글표시사항 -->
                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">수입원/판매원</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 쿠플러스"
                                                                                        v-model="list.한글표시사항['수입원/판매원']">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">제조원</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 중국OEM"
                                                                                        v-model="list.한글표시사항.제조원">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">제조국</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 중국"
                                                                                        v-model="list.한글표시사항.제조국">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">내용량</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 300ml"
                                                                                        v-model="list.한글표시사항.내용량">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-01">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">원료명및성분명(재질)</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 도자기제"
                                                                                        v-model="list.한글표시사항['원료명및성분명(재질)']">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">상품유형</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 주방용품"
                                                                                        v-model="list.한글표시사항.상품유형">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">사용시주의사항</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 용도 이외에 사용금지"
                                                                                        v-model="list.한글표시사항.사용시주의사항">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row mb-0">
                                                                                <label
                                                                                    class="col-sm-3 col-form-label">사용기준</label>
                                                                                <div class="col-sm-9">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        placeholder="예) 14세 이상"
                                                                                        v-model="list.한글표시사항.사용기준">
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">

                                                                    <!-- 기존 판매자 협의 금액 섹션 -->
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">10. 기존 판매자 협의
                                                                            금액 (선택)</div>
                                                                        <div class="price-info-form">
                                                                            <div class="form-group row">
                                                                                <label
                                                                                    class="col-sm-4 col-form-label">협의단가(CNY)</label>
                                                                                <div class="col-sm-8">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control"
                                                                                        v-model="list.협의단가">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row">
                                                                                <label class="col-sm-4 col-form-label">
                                                                                    총금액(CNY)<br>
                                                                                    <small>(중국 내륙배송비 포함 전체 결제금액)</small>
                                                                                </label>
                                                                                <div class="col-sm-8">
                                                                                    <input type="number" :min="0"
                                                                                        class="form-control"
                                                                                        v-model="list.협의총금액">
                                                                                </div>
                                                                            </div>

                                                                            <div class="form-group row">
                                                                                <label
                                                                                    class="col-sm-4 col-form-label">협의1688
                                                                                    ID</label>
                                                                                <div class="col-sm-8">
                                                                                    <input type="text"
                                                                                        class="form-control"
                                                                                        v-model="list.협의ID">
                                                                                </div>
                                                                            </div>

                                                                            <!-- <div class="form-group row">
                                                                                <label
                                                                                    class="col-sm-4 col-form-label">협의상세내용</label>
                                                                                <div class="col-sm-8">
                                                                                    <textarea class="form-control"
                                                                                        rows="3"
                                                                                        v-model="list.협의내용">
                                                                                    </textarea>
                                                                                </div>
                                                                            </div> -->
                                                                        </div>
                                                                    </div>
                                                                </div>

                                                                <div class="col-md-6">
                                                                    <!-- 기타요청사항 섹션 -->
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">
                                                                            <div>기타요청사항 - 배대지 작업요청사항</div>
                                                                            <small class="reqpo-text-muted ml-3">
                                                                                (예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용, 실사,
                                                                                사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                                                                OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의 작업은
                                                                                6000/시간의 작업비 발생)
                                                                            </small>
                                                                        </div>
                                                                        <textarea class="form-control mt-3" rows="3"
                                                                            v-model="list.요청내역.reqcontent">
                                                                        </textarea>
                                                                    </div>
                                                                    <div class="reqpo-form-section">
                                                                        <div class="reqpo-section-title">
                                                                            <div>기타요청사항 - 1688판매자와의 협의 사항</div>
                                                                        </div>
                                                                        <textarea class="form-control mt-3" rows="3"
                                                                            v-model="list.요청내역.reqcontentPurchase">
                                                                        </textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </b-modal>



                                                </td>
                                                <td>{{ list.구매요청수량 }}</td>
                                                <td>
                                                    <div class="d-flex align-items-center list-action">
                                                        <a class="badge badge-primary mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="요청복사" href="javascript:void(0)"
                                                            @click="copyReq(list)">
                                                            <i class="ri-file-copy-line mr-0"></i>
                                                        </a>
                                                        <a class="badge bg-success mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="옵션재매칭" href="javascript:void(0)"
                                                            @click="rematching(list, index)">
                                                            <i class="ri-pencil-line mr-0"></i>
                                                        </a>
                                                        <a class="badge badge-info mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="Reset" href="javascript:void(0)"
                                                            @click="reset(list)">
                                                            <i class="ri-eye-line mr-0"></i>
                                                        </a>
                                                        <a class="badge bg-warning mr-2" data-toggle="tooltip"
                                                            v-b-tooltip.top title="삭제" href="javascript:void(0)"
                                                            @click="deleteitem(index)">
                                                            <i class="ri-delete-bin-line mr-0"></i>
                                                        </a>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td class="text-center">
                                                    <b-button @click="addlists" variant="outline-primary"
                                                        class="text-center">+</b-button>
                                                </td>
                                                <td colspan="2"><input type="text" class="form-control"
                                                        placeholder="바코드 번호 (없으면 생략)" @keyup.enter="addlists"
                                                        v-model="추가바코드"></td>
                                                <td></td>
                                                <td>

                                                </td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div class="col-12 mb-4">
                                <button type="button" class="btn btn-primary mr-2"
                                    v-b-modal.modal-scrollable>구매요청</button>
                                <!-- <button type="button" class="btn btn-secondary mr-2" @click="saveproductdb">상품DB에 저장</button>    -->
                                <button type="button" class="btn btn-success mr-2" @click="savereqlist">현재상태저장</button>
                                <button type="button" class="btn btn-warning mr-2" v-b-modal.excelupload>대량주문</button>

                                <b-modal size="md" id="excelupload" scrollable title="대량 주문 업로드" ok-only>
                                    <div class="row">
                                        <div class="col-md-12">
                                            <!-- <p><b style="color:red">1688을 통해 구매하지 않거나, 별도 재고로 관리하는 사입제품의 경우, 구매링크를 '사입'이라고 표시해 주세요</b></p>
                                                <p>신규상품, 발주상태 등 상품 내역에 변경사항이 있을 경우 서플라이어에 접속한 후 <u v-b-modal.modal-3>크롬확장프로그램</u>으로 SKU 리스트를 먼저 수집해 주세요</p> -->
                                            <p>[업로드 방법]</p>
                                            <p>1. 엑셀업로드 포맷 다운로드<br>
                                                → <u>엑셀 파일에서 바코드/구매요청수량 업데이트</u> <br>
                                                → 2. 업데이트된 엑셀 파일 업로드 순으로 진행해 주세요.</p>

                                        </div>
                                        <div class="col-md-12 mt-4">
                                            <div class="form-group">
                                                <label>1. 엑셀업로드 포맷</label>
                                                <div>
                                                    <button type="reset" @click="excelDownFunc"
                                                        class="btn btn-primary mr-2">Download</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-md-12">
                                            <div class="form-group">
                                                <label for="Code">2. 업데이트된 구매요청양식 업로드</label>
                                                <div class="custom-file">
                                                    <input ref="pdbupload" type="file" @change="uploadfile"
                                                        class="custom-file-input" id="inputGroupFile02">
                                                    <label class="custom-file-label"
                                                        for="inputGroupFile02">{{ uploadstatus }}</label>
                                                </div>
                                                <div class="col-md-12" v-if="showuploadspinner">
                                                    <div>
                                                        <img style="width:5%;"
                                                            :src="require('../../../assets/images/small/loading.gif')">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </b-modal>




                                <!-- <div class="custom-control custom-switch custom-control-inline ml-5">
                                        <input type="checkbox" class="custom-control-input" id="customSwitch11" v-model="checkstock">
                                        <label class="custom-control-label" for="customSwitch11" v-b-tooltip.right="'구매할 제품의 재고 및 옵션상태를 확인하면서 등록합니다.'">구매재고확인등록</label>
                                    </div>              -->
                            </div>
                        </div>



                        <!-- <div class="card d-none">
                            <div class="card-header">
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio15" name="customRadio-4" class="custom-control-input" v-model="reqtype" value="로켓배송">
                                    <label class="custom-control-label" for="customRadio15">로켓배송</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio16" name="customRadio-4" class="custom-control-input" v-model="reqtype" value="제트배송">
                                    <label class="custom-control-label" for="customRadio16">제트배송</label>
                                </div>
                                <div class="custom-control custom-radio custom-control-inline">
                                    <input type="radio" id="customRadio17" name="customRadio-4" class="custom-control-input" v-model="reqtype" value="일반LCL">
                                    <label class="custom-control-label" for="customRadio17">일반LCL</label>
                                </div>
                            </div>
                            <div class="card-body">
                                <div class="row">


                                    <div class="col-md-12 mt-2">
                                        <p class="mb-0" @click="confirmexcelDownFunc"><u variant="link" style="color:blue;">구매대행 요청 양식 다운로드</u></p>
                                    </div>
                                    <div class="col-md-12 mt-2">
                                        <b-button variant="primary" v-b-modal.modal-scrollable>파일 업로드</b-button> -->

                        <b-modal id="modal-scrollable" scrollable size="xl" title="도매구매 및 직납 거래 계약" ok-title="동의"
                            cancel-title="거부" @ok="requestpurchase">
                            <div class="p-3">
                                <h5 class="fw-bold mb-4">[ 로켓그로스 도매구매 및 로켓직납 신청 ]</h5>

                                <div class="alert alert-info mb-3">
                                    <div class="mt-2">
                                        <strong style="color: #0066cc;">쿠패스통합통관:</strong> (주)쿠패스가 수입자로 매입·통관 후 도매 공급 (공급가 + 부가세 10%)<br>
                                        <strong style="color: #28a745;">사업자단독통관:</strong> 신청 사업자가 수입자로 통관 진행 (구매대행 수수료 3% + 관부가세·해운비·통관비 등 별도)
                                    </div>
                                </div>

                                <h6 class="fw-bold mt-4 mb-2" style="color: #0066cc;">■ 공통 사항</h6>

                                <p class="mb-2">
                                    • 상품 발주를 위해 예치금(입금액)을 선결제해야 하며, 통화 변동 등으로 인한 환산금액 차이가 발생할 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 공급처 재고 부족, 발송 지연 등으로 구매가 불가한 경우 해당 금액은 예치금에서 차감·정산되며, 환급 시 발생하는 수수료는 제외됩니다.
                                </p>

                                <p class="mb-2">
                                    • 신청서 기재 내용의 오류·누락·허위로 인해 발생하는 통관 지연, 과태료, 반송·폐기, 비용 발생 등 모든 책임은 신청자에게 있습니다.<br>
                                    (제품명/수량/단가/HS코드/용도/브랜드/인증요건 포함)
                                </p>

                                <p class="mb-2">
                                    • KC/식검/전기·생활안전/화학물질 등 법령상 인증·허가 여부 검토 책임은 신청자에게 있습니다.<br>
                                    무인증·지재권 침해 물품 등으로 인한 비용 및 불이익은 신청자 부담입니다.
                                </p>

                                <p class="mb-2">
                                    • 플랫폼에 제출된 정보는 세관 신고자료로 활용되며, 허위·오입력 시 통관 불가 및 처벌 대상이 될 수 있습니다.<br>
                                    (관련 과태료 약 16만원 이상)
                                </p>

                                <p class="mb-2">
                                    • 트래킹번호 단위로 묶음 처리되며, 그룹 해지·분리 요청 시 난이도에 따라 추가 비용이 발생할 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 기본 실사는 입고·도착 확인 수준이며, 수량/파손/오염/오배송 등 상세 검수는 포함되지 않습니다.<br>
                                    상세 확인이 필요한 경우 별도 검수를 요청해야 합니다.
                                </p>

                                <p class="mb-2">
                                    • 판매자가 발송하지 않거나 지연되는 경우, 신청자 요청에 따라 확인·촉구를 지원하나, 공급처 귀책에 대한 책임은 지지 않습니다.
                                </p>

                                <p class="mb-2">
                                    • 지재권 침해/수입금지 품목(가품/디즈니·레고 등)의 경우 통관 중단 및 폐기되며, 이와 관련한 비용은 신청자 부담입니다.
                                </p>

                                <p class="mb-2">
                                    • 제품 분리/나눔/특수 포장 요청 시 추가 비용이 발생할 수 있으며, 작업이 불가한 경우가 있을 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 검수 완료 후 고객 요청으로 절차 변경·재검수·반품을 요청할 경우 작업 불가 또는 추가 비용이 발생할 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 인건비 증가 또는 포장·작업 난이도에 따라 합포장/보완포장 등은 추가 비용이 발생할 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 대형/과체적 제품은 배송 제한 또는 반송될 수 있으며, 이 경우 발생하는 비용은 신청자 부담입니다.
                                </p>

                                <p class="mb-2">
                                    • 예치금과 실제 공급금액, 입금자명 불일치 시 정산 또는 입금확인이 지연될 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 보관기간이 15일을 초과할 경우 보관료가 발생합니다. (10,000원/CBM/월)
                                </p>

                                <p class="mb-2">
                                    • 입금 확인은 오전/오후 일괄 처리되며 실시간 반영이 아닐 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 국제운송 특성상 국내 수령 후 파손 발생 시 기본적으로 보상이 어렵습니다.<br>
                                    파손 위험이 있는 경우 에어캡·특수 포장 요청을 권장합니다. (비용 발생)
                                </p>

                                <p class="mb-2">
                                    • 포워더/물류사의 보상 기준을 따르며, 해외 판매자 귀책 불량·육안확인 불가 불량 등은 보상이 제한될 수 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 도색 차이/톤 차이 등 육안 식별이 어려운 제품은 상세 검수를 요청하지 않으면 오배송·회송 시 비용 보상이 어렵습니다.
                                </p>

                                <p class="mb-2">
                                    • 신청서 작성 후 7일간 선결제가 없을 경우 신청서는 자동 취소됩니다.
                                </p>

                                <h6 class="fw-bold mt-4 mb-2" style="color: #0066cc;">■ 쿠패스통합통관 선택 시</h6>

                                <p class="mb-2">
                                    • (주)쿠패스가 수입자로 매입·통관하여 도매 공급하는 방식입니다.
                                </p>

                                <p class="mb-2">
                                    • 최종 공급가 및 물류비 확정 후, 공급가 + 부가세 10%를 완납해야 하며, 완납 기준으로 전자세금계산서가 발행됩니다.
                                </p>

                                <p class="mb-2">
                                    • 본 서비스는 사업자 간 도매거래로, 품질·정품·사용적합성 보증은 해당 제조사 및 판매자 정책을 따릅니다.<br>
                                    쿠패스는 해외 공급처 제품의 품질을 보증하지 않습니다.
                                </p>

                                <h6 class="fw-bold mt-4 mb-2" style="color: #28a745;">■ 사업자단독통관 선택 시</h6>

                                <p class="mb-2">
                                    • 신청 사업자가 수입자로 통관하는 구매대행 방식입니다.
                                </p>

                                <p class="mb-2">
                                    • 구매대행 수수료 3%가 적용되며, 자재비, 관부가세, 해운비, 통관비, 통관서류 비용 등이 별도로 발생합니다.
                                </p>

                                <p class="mb-2">
                                    • 통관 및 수입 관련 모든 법적 책임은 신청 사업자(수입자)에게 있습니다.
                                </p>

                                <p class="mb-2">
                                    • 본 서비스는 구매대행으로, 제품의 정품/인증 여부, 파손, 오염 여부 등에 대하여 보장하지 않습니다.
                                </p>
                            </div>
                        </b-modal>

                        <!--
                                    </div>
                                    <div class="col-md-12 d-none">
                                        <div class="form-group">
                                            <div class="custom-file">
                                            <input ref="pdbupload" type="file" @change="uploadfile" class="custom-file-input" id="inputGroupFile02">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->

                    </tab-content-item>



                    <tab-content-item :active="false" id="list" aria-labelled-by="list-tab">
                        <card>
                            <div class="p-3">
                                <form @submit.prevent="submit">
                                    <div class="row">

                                        <div class="col-md-12">
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio7" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="today"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio7">오늘</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio8" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="week"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio8">최근7일</label>
                                            </div>
                                            <div class="custom-control custom-radio custom-control-inline">
                                                <input type="radio" id="customRadio9" name="customRadio-2"
                                                    class="custom-control-input" v-model="selectdate" value="month"
                                                    @change="changedate()">
                                                <label class="custom-control-label" for="customRadio9">최근1개월</label>
                                            </div>
                                            <!-- <div class="custom-control custom-switch custom-control-inline">
                                                <input type="checkbox" class="custom-control-input" id="customSwitch2" v-model="checksstock">
                                                <label class="custom-control-label" for="customSwitch2">사입제품 포함 발주서만 보기</label>
                                            </div> -->
                                        </div>
                                        <div class="col-md-12 mt-2">
                                            <b-input-group>
                                                <select class="custom-select col-md-2" style="height:40px"
                                                    v-model="selectoption">
                                                    <option>요청일</option>
                                                </select>
                                                <b-form-datepicker id="example-datepicker1" size="sm"
                                                    v-model="startdate" class="mb-2"></b-form-datepicker>
                                                <p>~</p>
                                                <b-form-datepicker id="example-datepicker2" size="sm" v-model="enddate"
                                                    class="mb-2"></b-form-datepicker>

                                            </b-input-group>
                                        </div>
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="상품명" v-model="상품명">
                                            </div>
                                        </div>
                                        <!-- <div class="col-md-4">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="SKU ID" v-model="SKUID">
                                            </div>
                                        </div> -->
                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <input type="text" class="form-control" placeholder="바코드" v-model="바코드">
                                            </div>
                                        </div>
                                    </div>
                                    <button type="button" class="btn btn-primary mr-2 mt-1" @click="search">검색</button>
                                    <img v-if="showspinner" style="max-width:100%;"
                                        :src="require('../../../assets/images/small/spinner.gif')">
                                </form>
                            </div>
                        </card>
                        <div class="col-lg-12" v-if="showreqlist">
                            <!-- 전체 건수 -->
                            <div class="mb-2" style="font-size:0.9rem;">
                                <a @click="showtotal" style="cursor:pointer;"><b>📋 전체 {{ total }}건</b></a>
                            </div>
                            <div class="reqpo-status mb-4">
                                <!-- 💰 입금요청 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">💰 입금요청</div>
                                    <div class="reqpo-status-txt">
                                        <!-- 「상품대금」은 화면에만 있던 말이다 — 상담 이력 실측상 고객 2턴·담당자 0턴.
                                             담당자가 매번 쓰는 말은 "대표님 구매대행건 견적서 전달드립니다"(16,950턴)라
                                             카카오로 받은 그 PDF 와 같은 것임이 바로 보이도록 이름을 맞춘다. -->
                                        <a @click="filterByStatus('입금요청')">구매대행 견적서
                                            <span class="badge bg-danger" v-if="$store.state.sseNotifications.quotation_created > 0" style="font-size: 0.65rem;">NEW</span>
                                        </a>
                                        <span :class="{ 'text-danger': 입금요청 > 0 }">{{ 입금요청 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByPaymentPending('중국물류')">중국물류</a>
                                        <span :class="{ 'text-danger': 중국물류입금요청 > 0 }">{{ 중국물류입금요청 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByPaymentPending('한국물류')">한국물류</a>
                                        <span :class="{ 'text-danger': 한국물류입금요청 > 0 }">{{ 한국물류입금요청 }}</span>
                                    </div>
                                    <div style="border-top:1px solid #ccced2; margin-top:4px; padding-top:4px;">
                                        <div class="reqpo-status-txt">
                                            <a @click="filterByStatus('입금완료')">입금완료</a>
                                            <span :class="{ 'text-success': 입금완료 > 0 }">{{ 입금완료 }}</span>
                                        </div>
                                    </div>
                                    <div style="border-top:1px solid #ccced2; margin-top:4px; padding-top:4px;">
                                        <div class="reqpo-status-txt">
                                            <a @click="openDepositHistoryModal" style="cursor:pointer;">💳 예치금</a>
                                            <span :class="{ 'text-primary': depositBalance > 0 }">₩{{ depositBalance.toLocaleString() }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- 🏪 1688구매 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">🏪 1688구매</div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('구매전')">구매전</a>
                                        <span>{{ 구매전 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <!-- 상담에서 제일 많이 오는 말이 "요청 넣었는데 견적서 언제 나오나요" 인데,
                                             그 답이 화면에는 「협상중」이라는 이름으로만 있어 셀러가 연결 짓지 못했다.
                                             실측상 92% 업체는 협상중 전부가 견적서 대기라 숫자를 두 번 쓰면 소음이 된다
                                             ⇒ 전부면 말만, 일부면 그 개수를 적는다. -->
                                        <a @click="filterByStatusMultiple(['협상중', '구매확인'])">협상중<small
                                                v-if="견적서대기 > 0" class="text-muted"> (견적서 대기{{ 견적서대기 === 협상중 ? '' : ' ' + 견적서대기 }})</small></a>
                                        <span :class="{ 'text-info': 협상중 > 0 }">{{ 협상중 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('구매완료')">구매완료</a>
                                        <span :class="{ 'text-success': 구매완료 > 0 }">{{ 구매완료 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('구매보류')">구매보류</a>
                                        <span :class="{ 'text-warning': 구매보류 > 0 }">{{ 구매보류 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('구매취소')">구매취소</a>
                                        <span :class="{ 'text-secondary': 구매취소 > 0 }">{{ 구매취소 }}</span>
                                    </div>
                                </div>

                                <!-- 📦 1688배송 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">📦 1688배송</div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatusMultiple(['배송중', '발송완료'])">배송중</a>
                                        <span>{{ 배송중 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('배송완료')">배송완료</a>
                                        <span :class="{ 'text-success': 배송완료 > 0 }">{{ 배송완료 }}</span>
                                    </div>
                                </div>

                                <!-- 🏭 쿠패스 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">🏭 쿠패스</div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('입고작업')">입고작업</a>
                                        <span :class="{ 'text-info': 입고작업 > 0 }">{{ 입고작업 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('출고요청')">📦출고요청</a>
                                        <span :class="{ 'text-warning': 출고요청 > 0 }">{{ 출고요청 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('출고대기')">출고대기</a>
                                        <span :class="{ 'text-primary': 출고대기 > 0 }">{{ 출고대기 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('출고완료')">출고완료</a>
                                        <span :class="{ 'text-success': 출고완료 > 0 }">{{ 출고완료 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('중국재고')">중국재고</a>
                                        <span :class="{ 'text-dark': 중국재고 > 0 }">{{ 중국재고 }}</span>
                                    </div>
                                    <!-- ⚠️ 입고오류 -->
                                    <div style="border-top:1px solid #ccced2; margin-top:4px; padding-top:4px;">
                                        <div class="reqpo-status-txt">
                                            <a @click="filterByStatusMultiple(['입고오류', '입고수량오류', '입고상품오류', '입고오류처리'])"><small>⚠️ 입고오류</small></a>
                                            <span :class="{ 'text-danger': 입고오류 > 0 }">{{ 입고오류 }}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- 🚢 쿠팡입고 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">🚢 쿠팡입고</div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('해외입고중')">해외입고중</a>
                                        <span>{{ 해외입고중 }}</span>
                                    </div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('국내입고중')">국내입고중</a>
                                        <span>{{ 국내입고중 }}</span>
                                    </div>
                                </div>

                                <!-- 🏭 국내창고 -->
                                <div class="reqpo-status-area">
                                    <div class="reqpo-status-tit">🏭 국내창고</div>
                                    <div class="reqpo-status-txt">
                                        <a @click="filterByStatus('국내창고입고중')">입고중</a>
                                        <span>{{ 국내창고입고중 }}</span>
                                    </div>
                                </div>
                            </div>
                            <!-- 입금완료처리 버튼 -->
                            <div class="mb-3" v-if="tableSelectedItem.length > 0">
                                <b-button variant="success" @click="openPaymentModal">
                                    <i class="ri-money-dollar-circle-line mr-1"></i>
                                    입금완료처리 ({{ tableSelectedItem.length }}건)
                                </b-button>
                            </div>
                            <CDataTable
                                storage-key="nomadreqpo" :headers="headers" :items="reqlists" v-model="tableSelectedItem"
                                :show-select="true" itemKey="_id">
                                <template v-slot:요청일="{ item }">
                                    <div>{{ getdate(item.요청일) }}</div>
                                </template>
                                <template v-slot:묶음구성여부="{ item }">
                                    {{ item.묶음구성여부 ? item.묶음구성수량 + '개' : "" }}<br><small>{{ item.묶음구성여부 ? '(' + item.바코드 +
                                        ")" : ""}}</small>
                                </template>
                                <template v-slot:상품명="{ item }">
                                    <div class="d-flex align-items-center" style="padding: 20px">
                                        <img :src="item.등록이미지" class="img-fluid rounded avatar-80 mr-3" alt="image">
                                        <div>
                                            {{ item.상품명 }}
                                            <p class="mb-0"><small>{{ item.SKUID }}</small></p>
                                            <p class="mb-0"><small>{{ item.바코드 }}</small></p>
                                        </div>
                                    </div>
                                </template>
                                <template v-slot:진행현황="{ item }">
                                    <!-- 선적이 있으면 상태 하나가 아니라 수량 분포로 보인다(정본 §4).
                                         없으면 지금까지 쓰던 뱃지 그대로 — 대다수가 여기다. -->
                                    <div v-if="distOf(item)" style="cursor: pointer;"
                                        @click="openProcessHistoryModal(item)"
                                        v-b-tooltip.hover title="클릭하여 변경 이력 보기">
                                        <ProgressDistribution :dist="distOf(item)" />
                                    </div>
                                    <b-badge v-else :variant="getProcessStatusVariant(item.processStatus || item.진행현황)"
                                        style="cursor: pointer;"
                                        @click="openProcessHistoryModal(item)"
                                        v-b-tooltip.hover title="클릭하여 변경 이력 보기">
                                        {{ item.processStatus || item.진행현황 || '구매전' }}
                                    </b-badge>
                                    <div v-if="(item.processStatus || item.진행현황) === '입고오류' && item.입고오류상세" class="mt-1">
                                        <a href="javascript:void(0)" class="small text-danger" @click.stop="openErrorDetailModal(item)">⚠️ 오류상세</a>
                                    </div>
                                    <div v-if="item.입고사진 && item.입고사진.length" class="mt-1">
                                        <a href="javascript:void(0)" class="small" @click.stop="openImportPhotoModal(item)">📷 입고사진 {{ item.입고사진.length }}</a>
                                    </div>
                                </template>
                                <template v-slot:구매링크="{ item }">
                                    <a :href="item.구매링크" target="_blank"><b-icon icon="link" scale="2"
                                            variant="secondary"></b-icon></a>
                                </template>
                                <template v-slot:견적서="{ item }">
                                    <b-badge v-if="item.견적서_1688구매금액"
                                        :variant="(item.processStatus || item.진행현황) !== '입금요청' ? 'success' : 'warning'"
                                        style="cursor:pointer"
                                        @click="openQuotationDetailModal(item)">
                                        견적서
                                    </b-badge>
                                    <span v-else class="text-muted">-</span>
                                </template>
                                <template v-slot:action="{ item, index }">
                                    <div class="d-flex align-items-center list-action">
                                        <a class="badge badge-primary mr-2 reqpo-action-button" data-toggle="tooltip"
                                            v-b-tooltip.top title="요청복사" href="javascript:void(0)"
                                            @click="copyRequest(item)">
                                            <i class="ri-file-copy-line mr-0"></i>
                                        </a>
                                        <!-- 한국물류비 입력 버튼 — 화물이 중국창고를 떠난 뒤면 열어준다.
                                             국내창고는 자기 창고가 있는 소수만 거치는데 조건이 그 두 상태뿐이라
                                             쿠팡센터 직납 화주는 관세사비·LCL 을 입력할 화면에 도달조차 못 했다.
                                             쿠패스 화면(logisreqpurchaseV0.vue:861)이 이미 쓰는 것과 같은 조건이다. -->
                                        <a v-if="['출고완료', '해외입고중', '국내입고중', '국내창고입고중', '국내창고입고완료', '쿠팡센터입고완료'].includes(item.processStatus || item.진행현황)"
                                            class="badge bg-info mr-2 reqpo-action-button" data-toggle="tooltip"
                                            v-b-tooltip.top title="한국물류비 입력" href="javascript:void(0)"
                                            @click="openKoreaLogisticsModal(item)">
                                            <i class="ri-truck-line mr-0"></i>
                                        </a>
                                        <!-- 중국물류비 paymentStatus 뱃지 -->
                                        <span v-if="item.견적서_중국물류비?.paymentStatus === '입금완료'" class="badge badge-success mr-2" v-b-tooltip.top title="중국물류비 입금완료">
                                            💰¥{{ item.견적서_중국물류비.총금액?.toLocaleString() || '완료' }}
                                        </span>
                                        <span v-else-if="item.견적서_중국물류비?.paymentStatus === '입금요청'" class="badge badge-warning mr-2" style="cursor:pointer" v-b-tooltip.top title="클릭하여 중국물류비 입금완료 처리" @click="completeLogisticsPayment(item, '중국물류비')">
                                            📨¥{{ item.견적서_중국물류비.총금액?.toLocaleString() || '입금요청' }}
                                        </span>
                                        <span v-else-if="item.견적서_중국물류비" class="badge badge-secondary mr-2" v-b-tooltip.top title="중국물류비 (입금요청 대기)">
                                            ¥{{ item.견적서_중국물류비.총금액?.toLocaleString() || '완료' }}
                                        </span>
                                        <!-- 한국물류비 paymentStatus 뱃지 -->
                                        <span v-if="item.견적서_한국물류비?.paymentStatus === '입금완료'" class="badge badge-success mr-2" v-b-tooltip.top title="한국물류비 입금완료">
                                            💰₩{{ item.견적서_한국물류비.총금액?.toLocaleString() || '완료' }}
                                        </span>
                                        <span v-else-if="item.견적서_한국물류비?.paymentStatus === '입금요청'" class="badge badge-warning mr-2" style="cursor:pointer" v-b-tooltip.top title="클릭하여 한국물류비 입금완료 처리" @click="completeLogisticsPayment(item, '한국물류비')">
                                            📨₩{{ item.견적서_한국물류비.총금액?.toLocaleString() || '입금요청' }}
                                        </span>
                                        <span v-else-if="item.견적서_한국물류비" class="badge badge-secondary mr-2" v-b-tooltip.top title="한국물류비 입력완료 (입금요청 대기)">
                                            ₩{{ item.견적서_한국물류비.총금액?.toLocaleString() || '완료' }}
                                        </span>
                                        <a class="badge bg-success mr-2 reqpo-action-button" data-toggle="tooltip"
                                            v-b-tooltip.top title="요청수정" href="javascript:void(0)"
                                            v-b-modal="modalID(item._id)">
                                            <i class="ri-pencil-line mr-0"></i>
                                        </a>


                                        <b-modal :id="'modal' + item._id" size="xl" title="구매요청사항"
                                            ok-title="Save Changes" cancel-title="Close" @ok="saverequest(item)"
                                            scrollable>

                                            <div class="reqpo-purchase-request-form">
                                                <div class="row">
                                                    <!-- Row 1: Items 1-2 -->
                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">1. 구매요청수량</div>
                                                            <div class="reqpo-input-wrapper">
                                                                <div class="d-flex align-items-center">
                                                                    <input type="number" :min="0"
                                                                        class="form-control text-center"
                                                                        style="width: 120px;" :disabled="qtyLocked(item)" v-model="item.구매요청수량"
                                                                        @keyup.enter="validateQuantity(item)">
<small v-if="qtyLocked(item)" class="text-danger ml-2">已进入采购流程，不能修改，请联系客服(구매전이 아니라 수정 불가 · 문의해 주세요)</small>
                                                                    <div class="reqpo-stock-info ml-3">
                                                                        <span class="reqpo-info-label">최소주문:</span>
                                                                        <span class="reqpo-info-value">{{
                                                                            getMinOrderQuantity(item) }}개</span>
                                                                        <span class="reqpo-separator">/</span>
                                                                        <span class="reqpo-info-label">재고:</span>
                                                                        <span class="reqpo-info-value">{{
                                                                            getAvailableStock(item) }}개</span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">2. 판매구성수량</div>
                                                            <div class="reqpo-input-wrapper">
                                                                <input type="number" :min="0" class="form-control"
                                                                    style="width: 120px;" :disabled="qtyLocked(item)" v-model="item.판매구성수량"
                                                                    v-b-tooltip.hover="'해당 SKU가 2p 구성일 경우에는 2라고 작성해 주세요'">
<small v-if="qtyLocked(item)" class="text-danger ml-2">已进入采购流程，不能修改，请联系客服(구매전이 아니라 수정 불가 · 문의해 주세요)</small>
                                                            </div>
                                                        </div>

                                                    </div>

                                                    <!-- Row 2: Items 3-4 -->
                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">3. A-B번들 묶음구성여부</div>
                                                            <div class="bundle-options">
                                                                <div
                                                                    class="custom-control custom-switch d-inline-block">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'bundleSwitch' + index"
                                                                        v-model="item.묶음구성여부"
                                                                        @change="confirmBarcode(item)">
                                                                    <label class="custom-control-label"
                                                                        :for="'bundleSwitch' + index">묶음구성</label>
                                                                </div>
                                                                <div v-if="item.묶음구성여부" class="bundle-count mt-2">
                                                                    <input type="number" :min="0" class="form-control"
                                                                        style="width: 120px;" placeholder="종류갯수"
                                                                        v-model="item.묶음구성수량"
                                                                        v-b-tooltip.hover="'3종의 제품을 묶음 구성하는 경우 3으로 작성'">
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">4. 도착지</div>
                                                            <div class="destination-options">
                                                                <div class="btn-group w-100">
                                                                    <button type="button" class="btn"
                                                                        :class="{ 'btn-primary': item.요청내역.destination === 'coupang', 'btn-outline-primary': item.요청내역.destination !== 'coupang' }"
                                                                        @click="item.요청내역.destination = 'coupang'">
                                                                        쿠팡센터
                                                                    </button>
                                                                    <button type="button" class="btn"
                                                                        :class="{ 'btn-primary': item.요청내역.destination === 'customer', 'btn-outline-primary': item.요청내역.destination !== 'customer' }"
                                                                        @click="item.요청내역.destination = 'customer'">
                                                                        화주
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Row 3: Items 5-7 -->
                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">5. 출고형태</div>
                                                            <div class="export-options">
                                                                <div class="custom-control custom-radio mb-2">
                                                                    <input type="radio" :id="'exportBox' + index"
                                                                        name="exportType" class="custom-control-input"
                                                                        v-model="item.요청내역.exportType" value="box">
                                                                    <label class="custom-control-label"
                                                                        :for="'exportBox' + index">
                                                                        <span
                                                                            v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                                            밀크런 택배
                                                                        </span>
                                                                        <span v-else>택배</span>
                                                                    </label>
                                                                </div>
                                                                <div class="custom-control custom-radio">
                                                                    <input type="radio" :id="'exportPallet' + index"
                                                                        name="exportType" class="custom-control-input"
                                                                        v-model="item.요청내역.exportType" value="pallet">
                                                                    <label class="custom-control-label"
                                                                        :for="'exportPallet' + index">
                                                                        <span
                                                                            v-if="!item.요청내역.destination || item.요청내역.destination === 'coupang'">
                                                                            밀크런 파렛트 <small
                                                                                class="reqpo-text-muted">(￦35,000/pallet)</small>
                                                                        </span>
                                                                        <span v-else>
                                                                            파렛트 <small
                                                                                class="reqpo-text-muted">(￦20,000/pallet)</small>
                                                                        </span>
                                                                    </label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <!-- </div>

                                                <div class="col-md-6"> -->
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">6. 통관정보</div>
                                                            <div class="row">
                                                                <div class="col-12 mb-3">
                                                                    <div class="form-group">
                                                                        <label>신고영문명</label>
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) shoes" v-model="item.신고영문명">
                                                                    </div>
                                                                </div>
                                                                <div class="col-12">
                                                                    <div class="form-group">
                                                                        <label>HS-CODE</label>
                                                                        <div class="d-flex">
                                                                            <input type="text" class="form-control"
                                                                                placeholder="예) 6401.10-1000"
                                                                                v-model="item.HSCODE">
                                                                            <div class="w-25 d-flex align-items-center">
                                                                                <a href="https://www.bandtrass.or.kr/hsnavi.do"
                                                                                    target="_blank"
                                                                                    class="btn btn-outline-secondary ml-2">
                                                                                    검색
                                                                                </a></div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">7. 통관형태</div>
                                                            <div class="customs-options">
                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                    :class="{ 'active': item.요청내역.customsType === 'integrated' }"
                                                                    @click="item.요청내역.customsType = 'integrated'">
                                                                    <div class="reqpo-card-title">쿠패스통합통관</div>
                                                                    <div class="reqpo-card-desc">위안화x290, 검수/포장비용 제외
                                                                        모든비용 포함</div>
                                                                </div>
                                                                <div class="reqpo-custom-radio-card mb-2"
                                                                    :class="{ 'active': item.요청내역.customsType === 'client' }"
                                                                    @click="item.요청내역.customsType = 'client'">
                                                                    <div class="reqpo-card-title">화주단독통관</div>
                                                                    <div class="reqpo-card-desc">구매대행수수료3%, 자재, 관부가세,
                                                                        해운비, 통관비, 통관서류 비용 등 별도</div>
                                                                </div>
                                                                <div class="reqpo-custom-radio-card"
                                                                    :class="{ 'active': item.요청내역.customsType === 'kupass' }"
                                                                    @click="item.요청내역.customsType = 'kupass'">
                                                                    <div class="reqpo-card-title">쿠패스단독통관</div>
                                                                    <div class="reqpo-card-desc">식검제품만 신청가능, 구매대행수수료3%,
                                                                        자재, 관부가세, 해운비, 통관비, 통관서류 비용 등 별도</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <!-- Full width sections -->
                                                    <div class="col-md-6">
                                                        <!-- 검수 및 포장 섹션 -->
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">8. 검수 및 포장</div>
                                                            <div class="inspection-options">

                                                                <!-- 패키징 옵션 -->
                                                                <div v-if="item.요청내역.default"
                                                                    class="packaging-options mb-3">
                                                                    <div class="reqpo-option-title mb-2">포장 방법 선택:</div>
                                                                    <div class="custom-control custom-radio mb-2">
                                                                        <input type="radio" :id="'packageAuto' + index"
                                                                            name="packageMethod"
                                                                            class="custom-control-input" value="auto"
                                                                            v-model="packageMethod"
                                                                            @change="changePackage(item)">
                                                                        <label class="custom-control-label"
                                                                            :for="'packageAuto' + index">
                                                                            포장 방법 위임
                                                                        </label>
                                                                    </div>
                                                                    <div class="custom-control custom-radio mb-2">
                                                                        <input type="radio" :id="'packageNo' + index"
                                                                            name="packageMethod"
                                                                            class="custom-control-input"
                                                                            value="noPackage" v-model="packageMethod"
                                                                            @change="changePackage(item)">
                                                                        <label class="custom-control-label"
                                                                            :for="'packageNo' + index">
                                                                            재포장 생략
                                                                        </label>
                                                                    </div>
                                                                    <div class="custom-control custom-radio mb-2">
                                                                        <input type="radio" :id="'packageOPP' + index"
                                                                            name="packageMethod"
                                                                            class="custom-control-input" value="opp"
                                                                            v-model="packageMethod"
                                                                            @change="changePackage(item)">
                                                                        <label class="custom-control-label"
                                                                            :for="'packageOPP' + index">
                                                                            투명 OPP 봉투 포장 (무료)
                                                                        </label>
                                                                    </div>
                                                                    <div class="custom-control custom-radio">
                                                                        <input type="radio" :id="'packageLDPE' + index"
                                                                            name="packageMethod"
                                                                            class="custom-control-input" value="LDPE"
                                                                            v-model="packageMethod"
                                                                            @change="changePackage(item)">
                                                                        <label class="custom-control-label"
                                                                            :for="'packageLDPE' + index">
                                                                            불투명 LDPE 봉투 포장 (무료)
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div class="reqpo-option-group mb-3">
                                                                <div class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'defaultCheck' + index"
                                                                        v-model="item.요청내역.default">
                                                                    <label class="custom-control-label"
                                                                        :for="'defaultCheck' + index">
                                                                        기본검수/분류/포장/포장자재 (￦200)
                                                                    </label>
                                                                </div>
                                                            </div>
                                                            <!-- 라벨링 옵션 -->
                                                            <div class="labeling-options mb-3">
                                                                <div class="custom-control custom-switch mb-2">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'barcodeCheck' + index"
                                                                        v-model="item.요청내역.barcode"
                                                                        @change="changeBarcode(item)">
                                                                    <label class="custom-control-label"
                                                                        :for="'barcodeCheck' + index">
                                                                        바코드라벨 (Made in China,한글표시사항 기본포함) (￦100)
                                                                    </label>
                                                                </div>

                                                                <div v-if="!item.요청내역.barcode"
                                                                    class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'stickerCheck' + index"
                                                                        v-model="item.요청내역.sticker">
                                                                    <label class="custom-control-label"
                                                                        :for="'stickerCheck' + index">
                                                                        원산지스티커 (￦100)
                                                                    </label>
                                                                </div>
                                                            </div>

                                                            <!-- 추가 작업 옵션 -->
                                                            <div class="additional-options">
                                                                <div class="custom-control custom-switch mb-2">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'maskingCheck' + index"
                                                                        v-model="item.요청내역.masking">
                                                                    <label class="custom-control-label"
                                                                        :for="'maskingCheck' + index">
                                                                        중국어 마스킹 (무료)
                                                                    </label>
                                                                </div>

                                                                <div class="custom-control custom-switch mb-2">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'airpackingCheck' + index"
                                                                        v-model="item.요청내역.airpacking">
                                                                    <label class="custom-control-label"
                                                                        :for="'airpackingCheck' + index">
                                                                        에어캡 포장 (실비)
                                                                    </label>
                                                                </div>
                                                                <div class="custom-control custom-switch mb-2">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'sewingCheck' + index"
                                                                        v-model="item.요청내역.sewing">
                                                                    <label class="custom-control-label"
                                                                        :for="'sewingCheck' + index">
                                                                        원산지라벨 봉제 (6000원/시간)
                                                                    </label>
                                                                    <div class="reqpo-warning-text">* 의류 수입 시 원산지 라벨봉제는
                                                                        필수 사항입니다.</div>
                                                                </div>

                                                                <div class="custom-control custom-switch mb-2">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'stampCheck' + index"
                                                                        v-model="item.요청내역.stamp">
                                                                    <label class="custom-control-label"
                                                                        :for="'stampCheck' + index">
                                                                        원산지 도장 (6000원/시간)
                                                                    </label>
                                                                    <div class="reqpo-warning-text">* 신발류 수입 시 제품에 원산지
                                                                        라벨봉제 또는 원산지 도장은 필수 사항입니다.</div>
                                                                </div>

                                                                <div class="custom-control custom-switch">
                                                                    <input type="checkbox" class="custom-control-input"
                                                                        :id="'tagCheck' + index"
                                                                        v-model="item.요청내역.tag">
                                                                    <label class="custom-control-label"
                                                                        :for="'tagCheck' + index">
                                                                        원산지 택(태그) (6000원/시간)
                                                                    </label>
                                                                    <div class="reqpo-warning-text">* 가방류 수입 시 원산지 라벨봉제
                                                                        또는 원산지 택 표기가 필수 사항입니다.</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>


                                                    <div class="col-md-6">

                                                        <!-- 한글표시사항 섹션 -->
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">9. 한글표시사항</div>

                                                            <!-- 바코드라벨 미부착 시 경고 -->
                                                            <div v-if="!item.요청내역.barcode"
                                                                class="reqpo-warning-box mb-3">
                                                                <div class="warning-content">
                                                                    <div class="warning-title">※ 바코드라벨을 부착하지 않는 경우,
                                                                    </div>
                                                                    <div class="reqpo-warning-text"
                                                                        v-if="item.요청내역.destination === 'coupang'">
                                                                        쿠팡센터 직납 시 사전에 제품패키지 겉에 반드시 바코드가 부착되거나 새겨져 있어야
                                                                        합니다.
                                                                    </div>
                                                                    <div class="reqpo-warning-text"
                                                                        v-if="item.요청내역.destination === 'customer'">
                                                                        반드시 원산지표시가 되어 있어야 합니다.
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <!-- 한글표시사항 입력 폼 -->
                                                            <div v-if="item.요청내역.barcode" class="korean-label-form">
                                                                <!-- 바코드 -->
                                                                <div class="form-group">
                                                                    <label class="col-form-label">바코드번호</label>
                                                                    <input type="text" class="form-control"
                                                                        placeholder="예) S00012341234"
                                                                        v-model="item.바코드">
                                                                </div>

                                                                <!-- 제품명 (별도 상단 배치) -->
                                                                <div class="form-group">
                                                                    <label>제품명</label>
                                                                    <input type="text" class="form-control"
                                                                        placeholder="예) 쿠플러스 예쁜접시, 10인치"
                                                                        v-model="item.상품명">
                                                                    <small class="reqpo-warning-text">* 쿠팡에 등록한 상품명 +
                                                                        옵션명을 같이 입력해주세요</small>
                                                                </div>

                                                                <!-- 기타 한글표시사항 -->
                                                                <div class="form-group row">
                                                                    <label
                                                                        class="col-sm-3 col-form-label">수입원/판매원</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 쿠플러스"
                                                                            v-model="item.한글표시사항['수입원/판매원']">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 col-form-label">제조원</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 중국OEM"
                                                                            v-model="item.한글표시사항.제조원">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 col-form-label">제조국</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 중국"
                                                                            v-model="item.한글표시사항.제조국">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 col-form-label">내용량</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 300ml"
                                                                            v-model="item.한글표시사항.내용량">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label
                                                                        class="col-sm-3 col-form-label">원료명및성분명(재질)</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 도자기제"
                                                                            v-model="item.한글표시사항['원료명및성분명(재질)']">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 col-form-label">상품유형</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 주방용품"
                                                                            v-model="item.한글표시사항.상품유형">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label
                                                                        class="col-sm-3 col-form-label">사용시주의사항</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 용도 이외에 사용금지"
                                                                            v-model="item.한글표시사항.사용시주의사항">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-3 col-form-label">사용기준</label>
                                                                    <div class="col-sm-9">
                                                                        <input type="text" class="form-control"
                                                                            placeholder="예) 14세 이상"
                                                                            v-model="item.한글표시사항.사용기준">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">

                                                        <!-- 기존 판매자 협의 금액 섹션 -->
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">10. 기존 판매자 협의 금액 (선택)</div>
                                                            <div class="price-info-form">
                                                                <div class="form-group row">
                                                                    <label
                                                                        class="col-sm-4 col-form-label">협의단가(CNY)</label>
                                                                    <div class="col-sm-8">
                                                                        <input type="number" :min="0"
                                                                            class="form-control" v-model="item.협의단가">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-4 col-form-label">
                                                                        총금액(CNY)<br>
                                                                        <small>(중국 내륙배송비 포함 전체 결제금액)</small>
                                                                    </label>
                                                                    <div class="col-sm-8">
                                                                        <input type="number" :min="0"
                                                                            class="form-control" v-model="item.협의총금액">
                                                                    </div>
                                                                </div>

                                                                <div class="form-group row">
                                                                    <label class="col-sm-4 col-form-label">협의1688
                                                                        ID</label>
                                                                    <div class="col-sm-8">
                                                                        <input type="text" class="form-control"
                                                                            v-model="item.협의ID">
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6">
                                                        <!-- 기타요청사항 섹션 -->
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">
                                                                <div>기타요청사항 - 배대지 작업요청사항</div>
                                                                <small class="reqpo-text-muted ml-3">
                                                                    (예: 1688제품 겉박스 중국어 있는부분 작업 요청 내용, 실사,
                                                                    사이즈, 무게, 센터 입고요청, 신발도장, 의류봉제 등,
                                                                    OPP/LDPE/뽁뽁이 일반검수/정밀검수, 시간이 걸리는 별도의 작업은
                                                                    6000/시간의 작업비 발생)
                                                                </small>
                                                            </div>
                                                            <textarea class="form-control mt-3" rows="3"
                                                                v-model="item.요청내역.reqcontent">
                                                            </textarea>
                                                        </div>
                                                        <div class="reqpo-form-section">
                                                            <div class="reqpo-section-title">
                                                                <div>기타요청사항 - 1688판매자와의 협의 사항</div>
                                                            </div>
                                                            <textarea class="form-control mt-3" rows="3"
                                                                v-model="item.요청내역.reqcontentPurchase">
                                                            </textarea>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </b-modal>

                                        <a class="badge bg-warning mr-2 reqpo-action-button" data-toggle="tooltip"
                                            v-b-tooltip.top title="삭제" href="javascript:void(0)"
                                            @click="deletelist(item)">
                                            <i class="ri-delete-bin-line mr-0"></i>
                                        </a>
                                    </div>
                                </template>
                            </CDataTable>
                        </div>
                        <div class="col-lg-12 mb-4" v-if="showreqlist">
                            <button type="button" class="btn btn-primary mr-2" @click="download">주문서 다운로드</button>
                        </div>
                    </tab-content-item>
                </tab-content>


            </div>
        </div>
        <b-modal v-model="isNotify" size="xl" title="공지" ok-title="오늘하루 보지 않기" cancel-title="닫기" @ok="todayModal()"
            @hide="isNotify = !isNotify">
            <div :style="{ whiteSpace: 'pre-line' }" v-html="notifyData?.content"></div>
        </b-modal>

        <!-- 💳 예치금 내역 모달 -->
        <b-modal v-model="showDepositHistoryModal" title="💳 예치금 내역" hide-footer size="lg">
            <div class="mb-3 p-3 border rounded bg-light text-center">
                <span style="font-size:1.1rem;">현재 잔액: <b class="text-primary">₩{{ depositBalance.toLocaleString() }}</b></span>
            </div>
            <div v-if="depositHistory.length === 0" class="text-center text-muted py-4">예치금 내역이 없습니다.</div>
            <table v-else class="table table-sm table-bordered" style="font-size:0.82rem;">
                <thead class="thead-light">
                    <tr><th>일시</th><th>유형</th><th>금액</th><th>사유</th><th>처리자</th></tr>
                </thead>
                <tbody>
                    <tr v-for="(h, idx) in depositHistory" :key="idx">
                        <td>{{ h.처리일 ? new Date(h.처리일).toLocaleString('ko-KR') : '-' }}</td>
                        <td>
                            <span :class="{'badge badge-success': h.type==='충전', 'badge badge-danger': h.type==='차감', 'badge badge-warning': h.type==='환불'}">{{ h.type }}</span>
                        </td>
                        <td :class="{'text-success': h.type==='충전', 'text-danger': h.type==='차감' || h.type==='환불'}">
                            {{ h.type==='충전' ? '+' : '-' }}₩{{ (h.금액 || 0).toLocaleString() }}
                        </td>
                        <td>{{ h.사유 || '-' }}</td>
                        <td>{{ h.처리자 || '-' }}</td>
                    </tr>
                </tbody>
            </table>
        </b-modal>

        <!-- 그룹 견적서 모달 -->
        <b-modal v-model="showQuotationDetailModal" title="견적서 (报价单)" hide-footer dialog-class="quotation-modal-90">
            <template v-if="quotationGroupItems.length > 0">
                <!-- 상단 정보 -->
                <div class="mb-3 p-3 border rounded bg-light" style="font-size:0.85rem;">
                    <div class="row mb-1">
                        <div class="col-4"><strong>화주주문번호:</strong> {{ quotationGroupInfo.화주주문번호 || '-' }}</div>
                        <div class="col-4"><strong>통관타입:</strong>
                            <b-badge :variant="quotationGroupInfo.customsType === 'integrated' ? 'primary' : quotationGroupInfo.customsType === 'kupass' ? 'success' : 'info'">
                                {{ {integrated: '통합통관', kupass: '쿠패스단독', client: '화주단독'}[quotationGroupInfo.customsType] || quotationGroupInfo.customsType }}
                            </b-badge>
                        </div>
                        <div class="col-4"><strong>적용환율:</strong> {{ quotationGroupInfo.적용환율 || '-' }}</div>
                    </div>
                    <div class="row">
                        <div class="col-4"><strong>사업자등록번호:</strong> {{ quotationGroupItems[0]?.입금정보?.사업자등록번호 || '-' }}</div>
                        <div class="col-4"><strong>대표자명:</strong> {{ quotationGroupItems[0]?.입금정보?.대표자명 || '-' }}</div>
                        <div class="col-4"><strong>이메일:</strong> {{ quotationGroupItems[0]?.입금정보?.이메일주소 || '-' }}</div>
                    </div>
                </div>

                <!-- 상품 테이블 (체크박스 포함) -->
                <div class="table-responsive">
                <table class="table table-bordered table-sm" style="font-size:0.75rem;">
                    <thead class="thead-light">
                        <tr>
                            <th rowspan="2" class="text-center align-middle" style="width:35px">
                                <input type="checkbox" :checked="quotationGroupSelected.length > 0 && quotationGroupSelected.length === quotationGroupItems.filter(i => i.견적서_1688구매금액 && (i.processStatus || i.진행현황) === '입금요청').length"
                                    @change="toggleAllQuotationGroup($event.target.checked)">
                            </th>
                            <th rowspan="2" class="align-middle text-center">상품명</th>
                            <th rowspan="2" class="align-middle text-center">옵션ID</th>
                            <th rowspan="2" class="align-middle text-center">바코드</th>
                            <th rowspan="2" class="align-middle text-center">수량</th>
                            <th rowspan="2" class="align-middle text-center">부가세(KRW)</th>
                            <th rowspan="2" class="align-middle text-center">총금액(KRW)</th>
                            <th rowspan="2" class="align-middle text-center" style="background:#d4edda;">중국물류비</th>
                            <th rowspan="2" class="align-middle text-center" style="background:#cce5ff;">공통배분</th>
                            <th rowspan="2" class="align-middle text-center" style="background:#d4edda;">한국물류비</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item, idx) in quotationGroupItemsProcessed" :key="idx"
                            :class="{ 'table-success': item.견적서_1688구매금액, 'table-light': !item.견적서_1688구매금액 }">
                            <td class="text-center">
                                <template v-if="item.견적서_1688구매금액 && (item.processStatus || item.진행현황) !== '입금요청'">
                                    <b-badge variant="success" size="sm">{{ item.processStatus || item.진행현황 }}</b-badge>
                                </template>
                                <input v-else-if="item.견적서_1688구매금액" type="checkbox"
                                    :checked="quotationGroupSelected.some(s => s._id === item._id)"
                                    @change="toggleQuotationGroupItem(item, $event.target.checked)">
                                <span v-else class="text-muted">-</span>
                            </td>
                            <td>{{ item.상품명 }}</td>
                            <td class="text-center">{{ item.SKUID || '-' }}</td>
                            <td class="text-center">{{ item.바코드 || '-' }}</td>
                            <td class="text-center">{{ item.구매요청수량 || 1 }}</td>
                            <td class="text-right">{{ item.견적서_1688구매금액 ? '₩' + (item.견적서_1688구매금액.부가세 || 0).toLocaleString() : '-' }}</td>
                            <td class="text-right font-weight-bold">{{ item.견적서_1688구매금액 ? '₩' + (item.견적서_1688구매금액.최종금액합계_KRW || 0).toLocaleString() : '-' }}</td>
                            <!-- 물류비 -->
                            <td class="text-right" style="background:#f0fff0;">{{ item._중국물류비 ? '₩' + item._중국물류비.toLocaleString() : '-' }}</td>
                            <td class="text-right" style="background:#f0f4ff;">{{ item._공통배분 ? '₩' + item._공통배분.toLocaleString() : '-' }}</td>
                            <td class="text-right" style="background:#f0fff0;">{{ item._한국물류비 ? '₩' + item._한국물류비.toLocaleString() : '-' }}</td>
                        </tr>
                    </tbody>
                    <tfoot class="table-secondary">
                        <tr>
                            <th colspan="6" class="text-right">선택 합계 ({{ quotationGroupSelected.length }}건)</th>
                            <th class="text-right">₩{{ quotationGroupSelectedTotal.toLocaleString() }}</th>
                            <th class="text-right">₩{{ quotationGroupItemsProcessed.reduce((s, i) => s + i._중국물류비, 0).toLocaleString() }}</th>
                            <th class="text-right">₩{{ quotationGroupItemsProcessed.reduce((s, i) => s + i._공통배분, 0).toLocaleString() }}</th>
                            <th class="text-right">₩{{ quotationGroupItemsProcessed.reduce((s, i) => s + i._한국물류비, 0).toLocaleString() }}</th>
                        </tr>
                    </tfoot>
                </table>
                </div>

                <!-- 공통물류비 원본 표시 -->
                <div v-if="quotationCommonLogistics" class="mt-3 p-3 border rounded" style="background:#f8f9ff; font-size:0.8rem;">
                    <div class="d-flex justify-content-between align-items-center mb-2">
                        <strong>📦 공통물류비 원본 (화주주문번호: {{ quotationGroupInfo.화주주문번호 }})</strong>
                        <b-badge :variant="quotationCommonLogistics.paymentStatus === '입금완료' ? 'success' : quotationCommonLogistics.paymentStatus === '입금요청' ? 'warning' : 'secondary'">
                            {{ quotationCommonLogistics.paymentStatus }}
                        </b-badge>
                    </div>
                    <table class="table table-sm table-bordered mb-1">
                        <tr v-for="(ci, idx) in quotationCommonLogistics.items" :key="idx">
                            <td>{{ ci.name }}</td>
                            <td class="text-right" style="width:120px;">₩{{ (ci.amount || 0).toLocaleString() }}</td>
                        </tr>
                        <tr class="table-info">
                            <td class="font-weight-bold">합계</td>
                            <td class="text-right font-weight-bold">₩{{ (quotationCommonLogistics.총금액 || 0).toLocaleString() }}</td>
                        </tr>
                    </table>
                    <small class="text-muted">배분기준: 수량×부피 (부피정보 없는 상품은 수량 기준)</small>
                    <div v-if="quotationCommonLogistics.메모" class="mt-1"><small>📝 {{ quotationCommonLogistics.메모 }}</small></div>
                </div>

                <!-- 엑셀 / PDF 다운로드 버튼 -->
                <div class="mt-2 text-right">
                    <b-button variant="success" size="sm" @click="downloadQuotationExcel" class="mr-2">
                        <i class="ri-file-excel-2-line mr-1"></i> 엑셀 다운로드
                    </b-button>
                    <b-button variant="danger" size="sm" @click="downloadQuotationPDF">
                        <i class="ri-file-pdf-line mr-1"></i> PDF 다운로드
                    </b-button>
                </div>

                <!-- 입금 안내 + 입금처리 버튼 (입금요청 건이 있을 때만 표시) -->
                <template v-if="quotationGroupItems.some(i => i.견적서_1688구매금액 && (i.processStatus || i.진행현황) === '입금요청')">
                <div class="mt-3 p-3 rounded text-center" style="background:#eaf2f8;color:#2f4858;border:1px solid #cfdde8">
                    <strong>입금 계좌: 국민은행 850101-00-116789 (주)쿠패스</strong>
                </div>
                <div class="mt-3 text-center" v-if="quotationGroupSelected.length > 0">
                    <b-button variant="success" size="lg" @click="paySelectedQuotationItems">
                        <i class="ri-money-dollar-circle-line mr-1"></i>
                        선택 {{ quotationGroupSelected.length }}건 입금완료처리 (₩{{ quotationGroupSelectedTotal.toLocaleString() }})
                    </b-button>
                </div>
                </template>
            </template>
            <div v-else class="text-center py-4 text-muted">
                견적서 정보가 없습니다.
            </div>
        </b-modal>

        <!-- 입금완료처리 모달 -->
        <b-modal v-model="showPaymentModal" size="md" title="입금완료처리" ok-title="입금완료" cancel-title="취소" @ok="submitPayment">
            <div class="form-group">
                <label>입금자명 <span class="text-danger">*</span></label>
                <input type="text" class="form-control" v-model="paymentInfo.입금자명" placeholder="입금자명을 입력하세요">
            </div>
            <div class="form-group">
                <label>입금액 <span class="text-danger">*</span></label>
                <input type="number" class="form-control" v-model="paymentInfo.입금액" placeholder="입금액을 입력하세요">
            </div>
            <hr>
            <p class="text-muted small">세금계산서 정보 (선택사항)</p>
            <div class="form-group">
                <label>사업자등록번호</label>
                <input type="text" class="form-control" v-model="paymentInfo.사업자등록번호" placeholder="사업자등록번호 (숫자만)">
            </div>
            <div class="form-group">
                <label>대표자명</label>
                <input type="text" class="form-control" v-model="paymentInfo.대표자명" placeholder="대표자명">
            </div>
            <div class="form-group">
                <label>이메일주소</label>
                <input type="email" class="form-control" v-model="paymentInfo.이메일주소" placeholder="세금계산서 수신 이메일">
            </div>
        </b-modal>

        <!-- 한국물류비 입력 모달 (화주용 - 동적 items) -->
        <b-modal
            v-model="showKoreaLogisticsModal"
            size="lg"
            :title="koreaLogisticsItem?.견적서_한국물류비 ? '한국물류비 수정' : '한국물류비 입력'"
            :ok-title="koreaLogisticsItem?.견적서_한국물류비 ? '수정' : '저장'"
            cancel-title="취소"
            @ok="submitKoreaLogistics">
            <template v-if="koreaLogisticsItem">
                <div class="mb-3 p-3 bg-light rounded">
                    <div class="row">
                        <div class="col-4"><strong>상품명:</strong> {{ koreaLogisticsItem.상품명 }}</div>
                        <div class="col-4"><strong>바코드:</strong> {{ koreaLogisticsItem.바코드 }}</div>
                        <div class="col-4"><strong>수량:</strong> {{ koreaLogisticsItem.입고수량 || koreaLogisticsItem.구매요청수량 }}</div>
                    </div>
                    <div class="row mt-2">
                        <div class="col-6"><strong>진행현황:</strong> {{ koreaLogisticsItem.processStatus || koreaLogisticsItem.진행현황 }}</div>
                    </div>
                </div>

                <div class="alert alert-info mb-3">
                    <strong>화주 단독통관</strong> - 관세사가 발급한 비용을 입력해주세요.
                </div>

                <!-- 동적 비용 항목 테이블 -->
                <table class="table table-sm table-bordered">
                    <thead class="thead-light">
                        <tr>
                            <th style="width:30%">항목명</th>
                            <th style="width:20%">단가 (원)</th>
                            <th style="width:15%">수량</th>
                            <th style="width:25%">금액 (원)</th>
                            <th style="width:10%"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, idx) in koreaLogisticsItems" :key="idx">
                            <td><input type="text" class="form-control form-control-sm" v-model="row.name" placeholder="항목명"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.unitPrice" @input="calcKoreaItemAmount(idx)"></td>
                            <td><input type="number" class="form-control form-control-sm" v-model.number="row.quantity" @input="calcKoreaItemAmount(idx)"></td>
                            <td class="text-right align-middle">₩{{ (row.amount || 0).toLocaleString() }}</td>
                            <td class="text-center align-middle">
                                <b-button size="sm" variant="outline-danger" @click="koreaLogisticsItems.splice(idx, 1)">✕</b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <b-button size="sm" variant="outline-primary" @click="koreaLogisticsItems.push({name:'', unitPrice:0, quantity:1, amount:0})">
                    + 항목 추가
                </b-button>

                <div class="form-group mt-3">
                    <label>메모</label>
                    <textarea class="form-control" v-model="koreaLogisticsForm.메모" rows="2" placeholder="메모 (선택)"></textarea>
                </div>

                <!-- 합계 -->
                <div class="alert alert-success mt-3">
                    <strong>총 금액</strong>
                    <div class="font-weight-bold text-primary mt-2" style="font-size: 1.5rem;">
                        ₩{{ calculateKoreaLogisticsTotal.toLocaleString() }}
                    </div>
                </div>
            </template>
        </b-modal>
        <!-- 변경 이력 조회 모달 -->
        <b-modal v-model="showProcessHistoryModal" size="md" title="진행현황 변경 이력" hide-footer scrollable>
            <div v-if="processHistoryLoading" class="text-center py-3">
                <b-spinner small></b-spinner> 로딩 중...
            </div>
            <div v-else-if="processHistoryList.length === 0" class="text-center text-muted py-3">
                변경 이력이 없습니다.
            </div>
            <div v-else>
                <div class="mb-2 text-right">
                    <small class="text-muted">현재 상태: </small>
                    <b-badge variant="primary">{{ processHistoryCurrentStatus }}</b-badge>
                </div>
                <div v-for="(h, idx) in processHistoryList" :key="idx"
                    class="d-flex align-items-start mb-2 p-2 border rounded" style="font-size: 0.85rem;">
                    <div class="mr-2 text-muted" style="min-width: 20px;">{{ processHistoryList.length - idx }}</div>
                    <div class="flex-grow-1">
                        <div>
                            <b-badge variant="secondary" class="mr-1">{{ h.fromStatus }}</b-badge>
                            →
                            <b-badge variant="success" class="ml-1">{{ h.toStatus }}</b-badge>
                        </div>
                        <div class="text-muted mt-1">
                            <small>{{ new Date(h.changedAt).toLocaleString('ko-KR') }} · {{ h.changedByName || '-' }}</small>
                        </div>
                        <div v-if="h.memo" class="text-info mt-1"><small>📝 {{ h.memo }}</small></div>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- 입고사진 모달 — 쿠패스 창고가 입고 때 핸드폰으로 찍은 사진 -->
        <b-modal v-model="showImportPhotoModal" size="lg" title="📷 입고사진" hide-footer scrollable>
            <div v-if="importPhotoItem">
                <div class="mb-2 p-2 bg-light rounded small">
                    <strong>{{ importPhotoItem.상품명 }}</strong>
                    <span v-if="importPhotoItem.바코드" class="ml-2">| {{ importPhotoItem.바코드 }}</span>
                </div>
                <div class="d-flex flex-wrap">
                    <a v-for="(ph, i) in (importPhotoItem.입고사진 || [])" :key="ph.url + i" :href="ph.url" target="_blank" class="mr-2 mb-2 text-center small text-muted">
                        <img :src="ph.url" style="width:140px;height:140px;object-fit:cover;border:1px solid #ddd;border-radius:4px;display:block" :alt="'입고사진'+(i+1)">
                        {{ { 입고사진: '상품·포장', 오류사진: '입고오류', 사이즈사진: '사이즈', 확인사진: '확인필요' }[ph.종류] || ph.종류 }}<template v-if="ph.이전입고"> · 이전 입고</template>
                    </a>
                </div>
            </div>
        </b-modal>

        <!-- 입고오류 상세 모달 -->
        <b-modal v-model="showErrorDetailModal" size="md" title="⚠️ 입고오류 상세" hide-footer scrollable>
            <div v-if="errorDetailItem">
                <div class="mb-3 p-2 bg-light rounded small">
                    <strong>{{ errorDetailItem.상품명 }}</strong>
                    <span v-if="errorDetailItem.바코드" class="ml-2">| {{ errorDetailItem.바코드 }}</span>
                    <span class="ml-2">| 수량: {{ errorDetailItem.구매요청수량 }}</span>
                </div>
                <div class="mb-2"><strong>오류유형:</strong> <b-badge variant="danger">{{ errorDetailItem.입고오류상세.오류유형 }}</b-badge></div>
                <div class="mb-2"><strong>오류내용:</strong> {{ errorDetailItem.입고오류상세.오류내용 || '-' }}</div>
                <div class="mb-2"><strong>오류상태:</strong> <b-badge :variant="errorDetailItem.입고오류상세.오류상태 === '접수' ? 'danger' : 'info'">{{ errorDetailItem.입고오류상세.오류상태 }}</b-badge></div>
                <div v-if="errorDetailItem.입고오류상세.이미지 && errorDetailItem.입고오류상세.이미지.length" class="mb-3">
                    <strong>오류 이미지:</strong>
                    <div class="d-flex flex-wrap mt-1">
                        <a v-for="(img, i) in errorDetailItem.입고오류상세.이미지" :key="i" :href="img" target="_blank" class="mr-2 mb-2">
                            <img :src="img" style="max-width:120px;max-height:120px;border:1px solid #ddd;border-radius:4px" :alt="'오류이미지'+(i+1)">
                        </a>
                    </div>
                </div>
                <div v-if="errorDetailItem.입고오류상세.반품정보 && errorDetailItem.입고오류상세.반품정보.수취인" class="mb-3 p-2 border rounded small">
                    <strong>반품정보:</strong><br>
                    수취인: {{ errorDetailItem.입고오류상세.반품정보.수취인 }}<br>
                    연락처: {{ errorDetailItem.입고오류상세.반품정보.연락처 }}<br>
                    주소: {{ errorDetailItem.입고오류상세.반품정보.주소 }}
                </div>
                <div v-if="errorDetailItem.입고오류상세.처리이력 && errorDetailItem.입고오류상세.처리이력.length" class="mt-3">
                    <strong class="small">처리이력</strong>
                    <div class="small text-muted mt-1" v-for="(h, i) in errorDetailItem.입고오류상세.처리이력" :key="i">
                        <b-badge variant="secondary" class="mr-1">{{ h.상태 }}</b-badge>
                        {{ new Date(h.처리일).toLocaleString('ko-KR') }}
                        <span v-if="h.처리자"> · {{ h.처리자 }}</span>
                        <span v-if="h.메모"> · {{ h.메모 }}</span>
                    </div>
                </div>
            </div>
        </b-modal>

        <!-- Page end  -->
        <!-- TawkToChat 컴포넌트 - test2 사용자에게만 표시 -->
        <TawkToChat v-if="$store.state.user && $store.state.user.companyid === 'test2'" />
    </div>
</template>
<script>
import * as XLSX from 'xlsx';
import axios from 'axios';
import _ from 'lodash'
import { validationMixin } from 'vuelidate'
import { required, integer } from 'vuelidate/lib/validators'
import CDataTable from "@/components/common/CDataTable";
import TawkToChat from "@/components/Chat/TawkToChat";
import reqVolatileMixin from '@/mixins/reqVolatileMixin'
import shipmentDistributionMixin from '@/mixins/shipmentDistributionMixin'
// import { conformsTo } from 'lodash';
// import { VueEditor } from 'vue2-editor'
export default {
    name: 'Reqpurchase',
    mixins: [validationMixin, reqVolatileMixin, shipmentDistributionMixin],
    validations: {
        purchaseno: { required },
        payment: { required, integer },
    },
    components: {
        //    VueEditor,
        CDataTable,
        TawkToChat
    },
    data() {
        return {
            headers: [
                { text: '요청일', value: '요청일', align: 'center', width: 100, isSlot: true },
                { text: '요청타입', value: 'reqtype', align: 'center', width: 100, isSlot: false },
                { text: '묶음배송', value: '묶음구성여부', align: 'center', width: 100, isSlot: true },
                { text: '진행현황', value: '진행현황', align: 'center', width: 100, isSlot: true },
                { text: '제품정보', value: '상품명', align: 'left', width: 400, isSlot: true },
                { text: '구매요청수량', value: '구매요청수량', align: 'center', width: 120, isSlot: false },
                { text: '판매구성수량', value: '판매구성수량', align: 'center', width: 120, isSlot: false },
                { text: '구매링크', value: '구매링크', align: 'center', width: 100, isSlot: true },
                { text: '옵션1_중국어', value: '옵션1_중국어', align: 'center', width: 130, isSlot: false },
                { text: '옵션2_중국어', value: '옵션2_중국어', align: 'center', width: 130, isSlot: false },
                { text: '견적서', value: '견적서', align: 'center', width: 80, isSlot: true },
                { text: 'Action', value: 'action', align: 'center', width: 150, isSlot: true }
            ],
            packageMethod: "auto",
            tableSelectedItem: [],
            obj: {},
            obj1: [],
            obj2: {},
            checkstock: true,
            exchangeRate: null, // 환율 정보
            integratedExchangeRate: 300, // 통합통관 환율 (기본값)

            savedbstatus: false,

            추가바코드: '',
            추가구매수량: '',
            구매링크: '',

            selectdate: 'today',
            startdate: this.getTodaywith(),
            enddate: this.getTodaywith(),
            selectoption: '요청일',
            SKUID: '',
            상품명: '',
            바코드: '',

            total: 0,
            // 🏪 1688구매 상태
            구매전: 0,
            협상중: 0,
            구매확인: 0,            // 레거시 호환용
            견적서대기: 0,          // 협상중/구매확인 중 아직 견적서가 안 나온 건수
            구매완료: 0,
            구매보류: 0,
            구매취소: 0,

            // 💰 입금 상태
            입금요청: 0,
            입금완료: 0,  // 레거시 유지
            중국물류입금요청: 0,
            한국물류입금요청: 0,

            // 📦 1688배송 상태
            배송중: 0,
            배송완료: 0,

            // 🏭 쿠패스 상태
            입고작업: 0,
            출고요청: 0,
            출고대기: 0,
            출고완료: 0,
            중국재고: 0,
            입고오류: 0,

            // 🚢 운송중 상태
            해외입고중: 0,
            국내입고중: 0,

            // 🏭 국내창고 상태 (화주 창고행)
            국내창고입고중: 0,
            국내창고입고완료: 0,  // 레거시 유지

            // 🛒 쿠팡센터 상태 (레거시 유지)
            쿠팡센터입고완료: 0,

            // 레거시 오류 (개별 카운트 → 입고오류로 통합)
            입고지연: 0,
            입고수량오류: 0,
            입고상품오류: 0,
            입고오류처리: 0,
            오류입고처리: 0,
            오류반품처리: 0,
            오류폐기처리: 0,
            오류입고대기: 0,
            반품폐기완료: 0,

            // 레거시
            발송전: 0,
            발송지연: 0,
            배송지연: 0,
            입고완료: 0,
            일괄삭제: 0,
            구매확정: 0,

            // 예치금 관련
            depositBalance: 0,
            showDepositHistoryModal: false,
            depositHistory: [],

            // 그룹 견적서 모달 관련
            showQuotationDetailModal: false,
            quotationGroupItems: [],      // 같은 화주주문번호 그룹 아이템들
            quotationGroupSelected: [],   // 체크된 아이템 (입금처리용)
            quotationGroupInfo: {},       // 그룹 헤더 정보 (화주주문번호, 통관타입 등)
            quotationCommonLogistics: null, // 그룹 공통물류비 데이터

            // 입금완료 모달 관련
            showPaymentModal: false,
            paymentInfo: {
                입금자명: '',
                입금액: 0,
                사업자등록번호: '',
                대표자명: '',
                이메일주소: ''
            },

            // 변경 이력 조회 모달 관련
            showProcessHistoryModal: false,
            processHistoryLoading: false,
            processHistoryList: [],
            processHistoryCurrentStatus: '',
            // 입고오류 상세 모달
            showErrorDetailModal: false,
            errorDetailItem: null,
            // 입고사진 모달
            showImportPhotoModal: false,
            importPhotoItem: null,

            // 한국물류비 입력 모달 관련 (화주용)
            showKoreaLogisticsModal: false,
            koreaLogisticsItem: null,
            koreaLogisticsForm: { 메모: '' },
            koreaLogisticsItems: [],

            showspinner: false,

            allcheckreqlists: false,
            reqlists: [],
            reqlistsinit: [],

            title: "로켓그로스 도매구매 및 직납 요청",
            desc1: "해당 메뉴는 (주)쿠패스가 해외 공급처로부터 상품을 직접 매입·통관(수입자)하여 사업자 회원님께 도매 공급 후 요청하신 지정지(센터/물류창고/매장 등)로 직납하는 기능입니다.",
            desc2: "현재 1688을 통한 공급이 가능합니다. (기타 소싱처는 문의) | 상품 등록 후 예치금 선입금 및 발주 확정 절차가 진행됩니다. | 발주 후 통관 및 납품 절차는 (주)쿠패스 명의로 진행됩니다.",
            desc3: "※ 본 기능은 사업자 전용 도매거래이며, 구매대행 서비스가 아닙니다. | 공급 및 정산은 공급가 + 부가가치세 10% 기준으로 처리됩니다. | 입력된 제품 정보는 세관 신고에 사용되므로 반드시 정확히 기재해 주세요. | 구매현황 및 기타문의는",

            showreqlist: false,
            showlist: true,

            checkbarcode: true,
            checktag: false,
            checkstamp: false,
            checksticker: false,

            reqtype: "로켓배송",
            showreqrocket: false,
            showreqjet: false,
            showreqgeneral: false,
            purchaseno: '',
            payment: '',
            reqcontent: '',
            reqcontentPurchase: '',
            isNotify: false,
            notifyData: null,

            allchecked: false,

            lists: [],
            downloadlists: [],
            currentindex: '',


            uploadstatus: 'excel file upload',
            showuploadspinner: false,
            cost: {
                poarrange: 0,
                exportpallet: 0,
                barcode: 0,
                sticker: 0,
                stamp: 0,
                tag: 0,
                default: 0,
            }
        }
    },
    computed: {
        /**
         * 한국물류비 총액 계산 (동적 items 합산)
         */
        calculateKoreaLogisticsTotal() {
            return this.koreaLogisticsItems.reduce((sum, item) => sum + (item.amount || 0), 0);
        },
        /**
         * 그룹 견적서 모달 - 선택 항목 KRW 합계
         */
        quotationGroupSelectedTotal() {
            return this.quotationGroupSelected.reduce((sum, item) => {
                return sum + (item.견적서_1688구매금액?.최종금액합계_KRW || 0);
            }, 0);
        },

        /**
         * 견적서 모달 아이템 (rowspan 정보 포함)
         */
        quotationGroupItemsProcessed() {
            if (!this.quotationGroupItems?.length) return [];
            const items = this.quotationGroupItems;
            const orderGroups = {};
            items.forEach((item, idx) => {
                const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                if (!orderGroups[orderId]) orderGroups[orderId] = [];
                orderGroups[orderId].push(idx);
            });

            // 공통물류비 배분 계산
            const commonTotal = this.quotationCommonLogistics?.총금액 || 0;
            let distributionMap = {};
            if (commonTotal > 0) {
                const allHaveVolume = items.every(i => ((i.sizeX || 0) * (i.sizeY || 0) * (i.sizeZ || 0)) > 0);
                const weights = items.map(i => {
                    const qty = i.구매요청수량 || 1;
                    const vol = (i.sizeX || 0) * (i.sizeY || 0) * (i.sizeZ || 0);
                    return allHaveVolume ? qty * vol : qty;
                });
                const totalWeight = weights.reduce((s, w) => s + w, 0);
                items.forEach((item, idx) => {
                    distributionMap[item._id] = totalWeight > 0 ? Math.round(commonTotal * weights[idx] / totalWeight) : 0;
                });
            }

            return items.map((item, idx) => {
                const orderId = item.주문정보?.['1688주문번호'] || 'unknown';
                const group = orderGroups[orderId];
                const isFirst = group[0] === idx;

                return {
                    ...item,
                    _isFirstInOrder: isFirst,
                    _orderRowspan: isFirst ? group.length : 0,
                    _중국물류비: item.견적서_중국물류비?.총금액 || 0,
                    _한국물류비: item.견적서_한국물류비?.총금액 || 0,
                    _공통배분: distributionMap[item._id] || 0
                };
            });
        }
    },
    methods: {
        // 구매전이 아닌 구매요청은 수량·구성을 못 바꾼다(2026-10-18 崔凡 #65). 새 요청(_id 없음)은 열려 있다. 서버도 같은 규칙으로 막는다
        qtyLocked(x) {
            return !!(x && x._id && (x.processStatus || x.진행현황 || '구매전') !== '구매전');
        },
        async fetchExchangeRate() {
            try {
                const response = await axios.post('/api/getExchangeRate', {});
                if (response.data.success && response.data.data) {
                    this.exchangeRate = response.data.data;
                    // 통합통관 환율이 있으면 설정
                    if (response.data.data.integratedRate) {
                        this.integratedExchangeRate = response.data.data.integratedRate;
                    }
                }
            } catch (error) {
                console.error('환율 정보 조회 오류:', error);
            }
        },
        getPlaceholder(key) {
            const placeholders = {
                '제품명': '예) 쿠팡 상품명, 옵션1',
                '수입원/판매원': '예) 쿠플러스',
                '제조원': '예) 중국OEM',
                '제조국': '예) 중국',
                '내용량': '예) 300ml',
                '원료명및성분명(재질)': '예) 도자기제',
                '상품유형': '예) 주방용품',
                '사용시주의사항': '예) 용도 이외에 사용금지',
                '사용기준': '예) 14세 이상'
            };
            return placeholders[key] || '정보를 입력해 주세요';
        },
        // 최소 주문수량 반환
        getMinOrderQuantity(list) {
            if (!list.item) return 2;
            return list.item?.minOrderQuantity || 2;
        },
        // 구매 가능 재고수량 반환
        getAvailableStock(list) {
            // console.log(list)
            if (!list.item || !list.item.productSaleInfo) return 0;

            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어
                )?.amountOnSale || 0);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                )?.amountOnSale || 0);
            }
            return stock;
        },
        // 구매요청수량 유효성 검증 및 자동 조정 (엔터키 입력 시)
        validateQuantity(list) {
            const minQuantity = this.getMinOrderQuantity(list);
            const maxQuantity = this.getAvailableStock(list);
            const currentQuantity = parseInt(list.구매요청수량);

            if (currentQuantity < minQuantity) {
                alert(`최소 주문수량(${minQuantity}개)보다 적습니다.`);
                // list.구매요청수량 = minQuantity;
            } else if (currentQuantity > maxQuantity) {
                alert(`구매 가능한 최대 수량(${maxQuantity}개)을 초과하였습니다.`);
                // list.구매요청수량 = maxQuantity;
            }
        },
        changeBarcode(item) {
            if (!item.요청내역.barcode) {
                alert('바코드라벨 미부착 시 반드시 원산지가 표시되어 있어야 합니다.')
                item.요청내역.sticker = true;
            } else {
                item.요청내역.sticker = false;
            }
        },
        changePackage(list) {
            if (this.packageMethod == 'opp') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'LDPE') {
                list.요청내역.opp = true;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'noPackage') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = false;
                return
            }
            if (this.packageMethod == 'auto') {
                list.요청내역.opp = false;
                list.요청내역.LDPE = false;
                list.요청내역.auto = true;
                return
            }
        },
        confirmBarcode(list) {
            if (list.바코드.includes('no') || list.바코드.includes('NO') || list.바코드.includes('No') || list.바코드.includes('노')) {
                if (list.묶음구성여부) {
                    alert('바코드 정보가 없는 경우 묶음구성 진행이 어렵습니다. 바코드를 먼저 생성해 주세요')
                    return
                }
            }
        },
        clickProductName(list) {
            if (list.상품명) {
                list.상품명 = ''
            }
        },
        todayModal() {
            const today = new Date().toISOString().split('T')[0];
            localStorage.setItem('modalClosedDate', today);
            this.isNotify = false;
        },
        productNameWith(list) {
            // if(confirm('변경된 한글표시사항 제품명에 따라 상품명도 변경하시겠습니까?')){
            list.상품명 = list.한글표시사항.제품명;
            // }
        },
        async copyReq(list) {
            var newObj = this.deepClone(list);
            if (newObj._id) delete newObj._id;
            if (newObj.상품매칭.옵션1_중국어.length > 0) {
                newObj.옵션1_중국어 = undefined;
            } else {
                newObj.옵션1_중국어 = '';
            }
            if (newObj.상품매칭.옵션2_중국어.length > 0) {
                newObj.옵션2_중국어 = undefined;
            } else {
                newObj.옵션2_중국어 = '';
            }
            newObj.상품명init = newObj.상품명
            newObj.옵션이미지 = undefined;
            newObj.매칭상태 = '매칭필요';
            // 진행단계/처리결과 휘발성 필드 일괄 초기화 (어드민 처리 잔존 차단)
            this.resetReqVolatileFields(newObj);
            newObj.요청내역 = newObj.요청내역 || {}
            if (!newObj.요청내역.destination) {
                newObj.요청내역.destination = 'coupang'
            }
            if (!newObj.요청내역.customsType) {
                newObj.요청내역.customsType = 'integrated'
            }
            if (!newObj.요청내역.reqcontentPurchase) {
                newObj.요청내역.reqcontentPurchase = ''
            }
            this.lists.push(newObj);
        },
        async copyRequest(list) {
            if (list._id) {
                delete list._id
            }
            let newObj = this.deepClone(list);
            this.resetReqVolatileFields(newObj);
            // this.reqinit(newObj);
            let result = await this.confirmreq(newObj);
            result.reqtype = '제트배송';
            result.요청내역 = result.요청내역 || {}
            newObj.요청내역 = newObj.요청내역 || {}
            if (!result.요청내역.destination) {
                result.요청내역.destination = 'coupang'
            }
            if (!newObj.요청내역.customsType) {
                newObj.요청내역.customsType = 'integrated'
            }
            if (!newObj.요청내역.reqcontentPurchase) {
                newObj.요청내역.reqcontentPurchase = ''
            }
            this.lists.push(result);
            alert('복사등록완료')
        },
        addProductName(list) {
            list.상품명 = list.상품명init;
        },
        getreqlists() {
            this.showlist = false;
            this.lists = [];
            axios.post('/api/reqpurchase/getreqlist', [])
                .then((res) => {
                    if (res.data.notifyData) {
                        const lastClosed = localStorage.getItem('modalClosedDate');
                        const today = new Date().toISOString().split('T')[0];

                        if (lastClosed !== today) {
                            this.isNotify = true;
                        }
                        this.notifyData = res.data.notifyData
                    }
                    if (res.data.lists || res.data.lists == []) {
                        res.data.lists.forEach(e => {
                            if (e && e.reqtype === '제트배송') {
                                e.요청내역 = e.요청내역 || {};
                                e.요청내역.destination = e.요청내역 && e.요청내역.destination ? e.요청내역.destination : 'coupang';
                                e.요청내역.customsType = e.요청내역 && e.요청내역.customsType ? e.요청내역.customsType : 'integrated';
                                e.요청내역.reqcontentPurchase = e.요청내역?.reqcontentPurchase || '';
                                this.lists.push(e)
                            }
                        })
                        this.showlist = true;
                    } else {
                        alert(res.data.요청결과)
                        this.showlist = true;
                    }
                })
                .catch(console.log)
        },
        savereqlist() {
            axios.post('/api/reqpurchase/savereqlist', this.lists)
                .then((res) => {
                    alert(res.data.요청결과);
                })
                .catch(console.log)
        },
        labelling(요청내역) {
            if (요청내역.barcode) {
                요청내역.한글표시사항 = true
            } else {
                요청내역.한글표시사항 = false
            }
        },
        // qadefault(요청내역){
        //     if(!요청내역.default){
        //         alert('기본검수/포장/포장자재가 불필요한 경우 해')
        //     }
        // },
        async savereq($event, list, index) {
            $event.preventDefault();

            // 1. 기본 유효성 검증 (기존 confirmlist 호출)
            const basicValidation = await this.confirmlist(list);
            if (!basicValidation) {
                return;
            }

            // 2. 추가적인 구매 관련 검증 (새로운 검증)
            const purchaseValidation = await this.validatePurchaseRequest(list);
            if (!purchaseValidation) {
                return;
            }

            list.요청사항 = '등록완료';
            console.log('저장list:',list)
            this.$bvModal.hide('modalreq' + index);
        },
        async validatePurchaseRequest(list) {
            // 구매링크가 없는 경우 검증 통과 (기본 confirmlist에서 처리)
            if (!list.구매링크) {
                return true;
            }

            // 재고 확인
            let stock = 0;
            if (!list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSaleInfo.amountOnSale);
            } else if (list.옵션1_중국어 && !list.옵션2_중국어) {
                stock = parseInt(list.item.productSkuInfos.find(f => f.skuAttributes[0].value == list.옵션1_중국어).amountOnSale);
            } else {
                stock = parseInt(list.item.productSkuInfos.find(f =>
                    f.skuAttributes[0].value == list.옵션1_중국어 &&
                    f.skuAttributes[1].value == list.옵션2_중국어
                ).amountOnSale);
            }

            // 최소 주문수량 체크
            const minOrderQuantity = list.item?.minOrderQuantity || 2;
            if (parseInt(list.구매요청수량) < minOrderQuantity) {
                alert(`구매요청수량이 최소 주문수량(${minOrderQuantity}개)보다 적습니다.`);
                // return false;
            }

            // 재고 수량 체크
            if (parseInt(list.구매요청수량) > stock) {
                alert(`주문수량(${list.구매요청수량}개)이 재고수량(${stock}개)을 초과합니다.`);
                // return false;
            }

            return true;
        },
        async saverequest(item) {
            const index = this.reqlists.findIndex(i => i._id === item._id);
            console.log(this.reqlists[index], this.reqlistsinit[index])
            // 한글표시사항 제품명은 상품명을 따라간다(등록 저장 때는 confirmlist 가 맞춘다).
            // 여기서 안 맞추면 「속옷건조대(등록전)」처럼 등록 전 임시 이름이 라벨에 남아
            // 입고 때 바코드 라벨의 상품명이 화면과 다르게 찍힌다
            const cur = this.reqlists[index];
            const init = this.reqlistsinit[index];
            if (cur && init && cur.한글표시사항 && cur.상품명 !== init.상품명) {
                cur.한글표시사항.제품명 = cur.상품명;
            }
            // 변경사항 확인
            const changes = this.findChanges(this.reqlists[index], this.reqlistsinit[index]);

            if (Object.keys(changes).length === 0) {
                alert('변경사항이 없습니다.')
                return;
            }

            if (this.reqlists[index].진행현황 !== '구매전') {
                alert('구매요청내역은 반드시 쿠패스 채널톡을 통해 변경내용을 알려주셔야 합니다.')
            }

            try {
                // 새로운 API를 사용하여 변경 내역 저장
                const changeResponse = await axios.post('/api/logis/savechange', {
                    requestId: item._id,
                    changes: changes,
                    changedBy: this.$store.state.user.email
                });

                if (changeResponse.data.success) {
                    // 요청 문서 업데이트 (preserveStatus=true로 진행현황 보호)
                    const res = await this.updatereqlist([item], true);
                    if (res) {
                        this.reqlistsinit[index] = this.deepClone(this.reqlists[index]);
                        this.$forceUpdate();
                        alert('변경 내역이 저장되었습니다.');
                    }
                } else {
                    alert(changeResponse.data.message || '변경 내역 저장 중 오류가 발생했습니다.');
                }
            } catch (error) {
                console.error('변경 내역 저장 중 오류:', error);
                alert('변경 내역 저장 중 오류가 발생했습니다.');
            }
        },

        findChanges(currentItem, initialItem) {
            const changes = {};

            // 재귀적으로 객체 비교
            const compareObjects = (current, initial, path = '') => {
                if (!current || !initial) return;

                Object.keys(current).forEach(key => {
                    const currentValue = current[key];
                    const initialValue = initial[key];
                    const currentPath = path ? `${path}.${key}` : key;

                    if (typeof currentValue === 'object' && !Array.isArray(currentValue)) {
                        // 객체인 경우 재귀적으로 비교
                        compareObjects(currentValue, initialValue, currentPath);
                    } else if (JSON.stringify(currentValue) !== JSON.stringify(initialValue)) {
                        // 값이 다른 경우 변경 이력에 추가
                        changes[currentPath] = {
                            변경전: initialValue,
                            변경후: currentValue
                        };
                    }
                });
            };

            compareObjects(currentItem, initialItem);
            return changes;
        },
        async updatereqlist(arr, preserveStatus = false) {
            if (arr.length == 1) {
                try {
                    // preserveStatus 플래그를 배열의 각 항목에 추가
                    const dataToSend = preserveStatus
                        ? arr.map(item => ({ ...item, preserveStatus: true }))
                        : arr;

                    const res = await axios.post('/api/reqpurchase/updatereqpurchase', dataToSend);
                    if (res.data.요청결과 === '변경완료') {
                        alert(res.data.요청결과);
                        return true;
                    } else {
                        alert(res.data.요청결과);
                        console.log(res.data);
                        return false;
                    }
                } catch (error) {
                    console.error(error);
                    return false;
                }
            } else {
                try {
                    // preserveStatus 플래그를 배열의 각 항목에 추가
                    const dataToSend = preserveStatus
                        ? this.reqlists.map(item => ({ ...item, preserveStatus: true }))
                        : this.reqlists;

                    const res = await axios.post('/api/reqpurchase/updatereqpurchase', dataToSend);
                    if (res.data.요청결과 === '변경완료') {
                        alert(res.data.요청결과);
                        return true;
                    } else {
                        alert(res.data.요청결과);
                        console.log(res.data);
                        return false;
                    }
                } catch (error) {
                    console.error(error);
                    return false;
                }
            }
        },
        usergrade() {
            // console.log(this.$store.state.user)
            if (this.$store.state.user.grade == 'general') {
                this.cost.poarrange = 100
                this.cost.exportpallet = 20000
                this.cost.barcode = 500
                this.cost.sticker = 300
                this.cost.stamp = 300
                this.cost.tag = 300
                this.cost.default = 300
                this.cost.store = 5000
            }
            if (this.$store.state.user.grade == 'vip') {
                this.cost.poarrange = 100;
                this.cost.exportpallet = 20000
                this.cost.barcode = 300
                this.cost.sticker = 200
                this.cost.stamp = 200
                this.cost.tag = 300
                this.cost.default = 200
                this.cost.store = 3000
            }
            if (this.$store.state.user.grade == 'vvip') {
                this.cost.poarrange = 100;
                this.cost.exportpallet = 20000
                this.cost.barcode = 300
                this.cost.sticker = 200
                this.cost.stamp = 200
                this.cost.tag = 300
                this.cost.default = 200
                this.cost.store = 0
            }
        },
        async addlists() {
            if (this.추가바코드 == '') {
                this.추가바코드 = "NOBARCODE"
            }
            // return
            // } else {
            this.showlist = false;
            var obj
            // if(this.$store.state.growthdb && !this.$store.state.growthdb.find(e => e.바코드 == this.추가바코드)){
            //     var obj = {
            //         checked : false,
            //         showspinner : false,
            //         // SKUID : '',
            //         바코드 : this.추가바코드,
            //         상품명 : '',
            //         상품명init : '',
            //         구매링크 : undefined,
            //         구매링크init : undefined,
            //         옵션1_중국어 : undefined,
            //         옵션2_중국어 : undefined,
            //         옵션이미지: undefined,
            //         매칭상태 : '매칭필요',
            //         상품매칭 : {
            //             옵션1_중국어 : [],
            //             옵션2_중국어 : [],
            //         },
            //         구매재고 : '',
            //         구매요청수량 : '',
            //         판매구성수량 : 1,
            //         묶음구성여부 : false,
            //         묶음구성수량 : '',
            //         신고영문명 : '',
            //         신고가격 : '',
            //         HSCODE : '',
            //         진행현황 : '구매전',
            //         재고동봉 : true,
            //         등록이미지 : '',
            //         요청사항 : '요청등록',
            //         reqtype : '제트배송',
            // sizeX : ob.sizeX ? ob.sizeX : '',
            //     sizeY : ob.sizeY ? ob.sizeY : '',
            //     sizeZ : ob.sizeZ ? ob.sizeZ : '',
            //     weight : ob.weight ? ob.weight : '',
            //         요청내역 : {
            //             default : true,
            //             poarrange : false,

            //             한글표시사항 : true,
            //             barcode : true,
            //             sticker : false,
            //             stamp : false,
            //             tag : false,
            //             reqcontent : '',
            //             opp : false,
            //             LDPE : false,
            //             airpacking : false,
            //             exportType : 'pallet',
            //         },
            //         한글표시사항 : {
            //             제품명 : '',
            //             '수입원/판매원' : '',
            //             제조원 : '',
            //             제조국 : '',
            //             내용량 : '',
            //             '원료명및성분명(재질)' : '',
            //             상품유형 : '',
            //             사용시주의사항 : '',
            //             사용기준 : '',
            //         },
            //         polists : [],
            //         selectpo : '',
            //     }
            //     this.lists.push(obj)
            // } else {
            //     if(this.$store.state.growthdb && this.$store.state.growthdb.find(e => e.바코드 == this.추가바코드)){
            //         var ob = this.$store.state.growthdb.find(e => e.바코드 == this.추가바코드);
            //         if(ob.요청내역){
            //             var 요청내역 = ob.요청내역
            //         } else {
            //             요청내역 = {
            //                 default : true,
            //                 poarrange : false,

            //                 boxnumber : '',
            //                 한글표시사항 : true,
            //                 barcode : true,
            //                 sticker : false,
            //                 stamp : false,
            //                 tag : false,
            //                 reqcontent : '',
            //                 opp : false,
            //                 LDPE : false,
            //                 airpacking : false,
            //                 exportType : 'pallet',
            //             }
            //         }
            //         obj = {
            //             checked : false,
            //             showspinner : false,
            //             // SKUID : ob['SKU ID'],
            //             바코드 : ob.바코드 ? ob.바코드 : '',
            //             상품명 : ob.상품명,
            //             상품명init : '',
            //             진행현황 : '구매전',
            //             구매링크 : ob.구매링크 ? ob.구매링크 : undefined,
            //             구매링크init : ob.구매링크 ? ob.구매링크 : undefined,
            //             옵션1_중국어 : ob.옵션1_중국어 ? ob.옵션1_중국어 : undefined,
            //             옵션2_중국어 : ob.옵션2_중국어 ? ob.옵션2_중국어 : undefined,
            //             옵션이미지: ob.옵션이미지 ? ob.옵션이미지 : undefined,
            //             매칭상태 : ob.매칭상태 ? ob.매칭상태 : '매칭필요',
            //             상품매칭 : {
            //                 옵션1_중국어 : [],
            //                 옵션2_중국어 : [],
            //             },
            //             구매재고 : '',
            //             구매요청수량 : '',
            //             판매구성수량: ob.판매구성수량 ? ob.판매구성수량 : 1,
            //             묶음구성여부 : ob.묶음구성여부 ? ob.묶음구성여부 : false,
            //             묶음구성수량 : ob.묶음구성수량 ? ob.묶음구성수량 : '',
            //             묶음대상바코드 : ob.묶음대상바코드 ? ob.묶음대상바코드 : '',
            //             신고영문명 : ob.신고영문명 ? ob.신고영문명 : '',
            //             신고가격 : ob['신고가격(USD)'] ? ob['신고가격(USD)'] : '',
            //             HSCODE : ob['HS-CODE'] ? ob['HS-CODE'] : '',
            //             재고동봉 : true,
            //             등록이미지 : ob.등록이미지,
            //             요청사항 : '요청등록',
            //             reqtype : '제트배송',
            //             sizeX : ob.sizeX ? ob.sizeX : '',
            //             sizeY : ob.sizeY ? ob.sizeY : '',
            //             sizeZ : ob.sizeZ ? ob.sizeZ : '',
            //             weight : ob.weight ? ob.weight : '',
            //             요청내역 : 요청내역,
            //             한글표시사항 : {
            //                 제품명 : ob.상품명,
            //                 '수입원/판매원' : ob['수입원/판매원'] ? ob['수입원/판매원'] : '',
            //                 제조원 : ob.제조원 ? ob.제조원 : '',
            //                 제조국 : ob.제조국 ? ob.제조국 : '',
            //                 내용량 : ob.내용량 ? ob.내용량 : '',
            //                 '원료명및성분명(재질)' : ob['원료명및성분명(재질)'] ? ob['원료명및성분명(재질)'] : '',
            //                 상품유형 : ob.상품유형 ? ob.상품유형 : '',
            //                 사용시주의사항 : ob.사용시주의사항 ? ob.사용시주의사항 : '',
            //                 사용기준 : ob.사용기준 ? ob.사용기준 : '',
            //             },
            //             polists : [],
            //             selectpo : '',
            //         }
            //         this.lists.push(obj)
            //     } else {
            obj = {
                checked: false,
                showspinner: false,
                // SKUID : '',
                바코드: this.추가바코드,
                상품명: '',
                상품명init: '',
                구매링크: undefined,
                구매링크init: undefined,
                옵션1_중국어: undefined,
                옵션2_중국어: undefined,
                옵션이미지: undefined,
                매칭상태: '매칭필요',
                상품매칭: {
                    옵션1_중국어: [],
                    옵션2_중국어: [],
                },
                구매재고: '',
                구매요청수량: '',
                판매구성수량: 1,
                묶음구성여부: false,
                묶음구성수량: '',
                묶음대상바코드: '',
                신고영문명: '',
                신고가격: 0,
                HSCODE: '',
                진행현황: '구매전',
                재고동봉: true,
                등록이미지: '',
                요청사항: '요청등록',
                reqtype: '제트배송',
                sizeX: '',
                sizeY: '',
                sizeZ: '',
                weight: '',
                요청내역: {
                    default: true,
                    poarrange: false,

                    한글표시사항: true,
                    barcode: true,
                    sticker: false,
                    sewing: false,
                    stamp: false,
                    tag: false,
                    reqcontent: '',
                    reqcontentPurchase: '',
                    opp: false,
                    LDPE: false,
                    airpacking: false,
                    exportType: 'box',
                    destination: 'coupang',
                    customsType: 'integrated',
                    masking: false,
                    auto: true,
                },
                한글표시사항: {
                    제품명: '',
                    '수입원/판매원': '',
                    제조원: '',
                    제조국: '',
                    내용량: '',
                    '원료명및성분명(재질)': '',
                    상품유형: '',
                    사용시주의사항: '',
                    사용기준: '',
                },
                polists: [],
                selectpo: '',
            }
            this.lists.push(obj)
            //     }
            // }

            // }
            // this.reqinit(this.lists[this.lists.length-1])
            this.추가바코드 = '';
            this.추가구매수량 = '';
            this.showlist = true;
        },
        polistchange(b, list) {
            list.발주수량 = b.sku수량;
            list.구매요청수량 = b.sku수량;
            list.selectpo = b.발주번호;
        },
        reqinit(obj) {
            // if(obj.SKUID != ''){
            //     var cloneobj = {};
            //     this.$store.state.polist.forEach(e => {
            //         if(!e.발주상태.includes('거래명세서') && !e.발주상태.includes('발주취소')){
            //             e.발주세부내역.forEach(ele => {
            //                 if(ele.SKUID == obj.SKUID){
            //                     cloneobj = this.deepClone(e);
            //                     cloneobj.sku수량 = parseInt(ele.확정수량);
            //                     obj.polists.push(this.deepClone(cloneobj))
            //                 }
            //             })
            //         }
            //     })
            // }
            if (obj.구매링크 && this.checkstock) {
                this.lists[this.lists.length - 1].showspinner = true;
                this.currentindex = this.lists.length - 1;
                this.sendmessage(obj.구매링크);
            } else {
                this.showlist = true;
            }
        },
        showtotal() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit;
                this.showreqlist = true;
            }, 10);
        },
        showa() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.진행현황 == '구매전');
                this.showreqlist = true;
            }, 10);
        },
        showb() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.진행현황 == '구매발송전');
                this.showreqlist = true;
            }, 10);
        },
        showc() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.진행현황 == '구매발송완료');
                this.showreqlist = true;
            }, 10);
        },
        showd() {
            this.showreqlist = false;
            setTimeout(() => {
                this.reqlists = this.reqlistsinit.filter(e => e.진행현황 == '입고완료');
                this.showreqlist = true;
            }, 10);
        },
        download() {
            var arr = [];
            if (_.isEmpty(this.tableSelectedItem)) {
                arr = this.reqlists
            } else {
                arr = this.tableSelectedItem
            }
            function getToday() {
                var date = new Date();
                var year = date.getFullYear();
                var month = ("0" + (1 + date.getMonth())).slice(-2);
                var day = ("0" + date.getDate()).slice(-2);

                return year + month + day;
            }
            var obj = {}
            var ar = []
            arr.forEach(e => {
                obj = {
                    요청일: this.getdate(e.요청일),
                    진행현황: e.진행현황,
                    등록이미지: e.등록이미지,
                    상품명: e.상품명,
                    'SKU ID': e.SKUID,
                    바코드: e.바코드,
                    구매요청수량: e.구매요청수량,
                    구매링크: e.구매링크,
                    옵션1_중국어: e.옵션1_중국어,
                    옵션2_중국어: e.옵션2_중국어,
                }
                ar.push(obj)
            })

            const workBook = XLSX.utils.book_new()
            const workSheet1 = XLSX.utils.json_to_sheet(ar)
            XLSX.utils.book_append_sheet(workBook, workSheet1, '구매대행요청내역')
            XLSX.writeFile(workBook, '구매대행요청내역' + '_' + getToday() + '.xlsx')
        },
        gettimestamp(date) {
            return new Date(date).getTime()
        },
        search() {
            this.showreqlist = false;
            this.reqlistsinit = [];
            this.reqlists = [];
            var start = this.gettimestamp(this.startdate)
            var end = this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24) - 1
            axios.post('/api/reqpurchase/getlists', { start: start, end: end, 상품명: this.상품명, 바코드: this.바코드 })
                .then((res) => {
                    this.$store.commit('reqpurchaseupdate', res.data.reqpurchase);
                    console.log(res.data.요청결과)

                    var arr = [];
                    res.data.reqpurchase.forEach(e => {
                        e.요청내역 = e.요청내역 || {};
                        if (e.reqtype === '제트배송') {
                            e.진행현황 = e.진행현황 ? e.진행현황 : "구매전";
                            e.checked = false;
                            e.요청내역.destination = e.요청내역.destination ? e.요청내역.destination : "coupang";
                            arr.push(this.deepClone(e))
                            this.reqlistsinit.push(this.deepClone(e))
                            this.reqlists.push(this.deepClone(e))
                        }
                        e.요청내역.reqcontentPurchase = e.요청내역?.reqcontentPurchase || '';
                    })
                    // 선적이 달린 건의 진행현황 수량 분포를 한 번에 받아둔다(정본 §5 Phase 2-17).
                    // 목록 단위로만 부른다 — 건별로 부르면 N+1 이다.
                    // 선적이 없으면 응답이 비고, 화면은 지금까지 쓰던 뱃지를 그대로 그린다.
                    this.loadShipmentDist(this.reqlistsinit)
                    console.log(arr)
                    // processStatus 우선 사용, 없으면 진행현황 사용 (레거시 호환)
                    const getStatus = (e) => e.processStatus || e.진행현황 || '구매전';

                    // 🏪 1688구매 상태
                    this.구매전 = arr.filter(e => getStatus(e) === '구매전').length;
                    this.협상중 = arr.filter(e => getStatus(e) === '협상중' || getStatus(e) === '구매확인').length;
                    this.구매확인 = this.협상중; // 레거시 호환
                    // 같은 모수(협상중+구매확인) 중 견적서가 아직 안 붙은 건수. 이미 받아온 목록에서만 센다.
                    this.견적서대기 = arr.filter(e => (getStatus(e) === '협상중' || getStatus(e) === '구매확인')
                        && !e.견적서_1688구매금액).length;
                    this.구매완료 = arr.filter(e => getStatus(e) === '구매완료').length;
                    this.구매보류 = arr.filter(e => getStatus(e) === '구매보류').length;
                    this.구매취소 = arr.filter(e => getStatus(e) === '구매취소').length;

                    // 💰 입금 상태
                    this.입금요청 = arr.filter(e => getStatus(e) === '입금요청').length;
                    this.입금완료 = arr.filter(e => getStatus(e) === '입금완료').length;  // 레거시 유지
                    // 중국물류/한국물류 입금요청 카운트 (paymentStatus 기반)
                    this.중국물류입금요청 = arr.filter(e => e.견적서_중국물류비?.paymentStatus === '입금요청').length;
                    this.한국물류입금요청 = arr.filter(e => e.견적서_한국물류비?.paymentStatus === '입금요청').length;

                    // 💳 예치금 잔액 조회
                    this.fetchDepositBalance();

                    // 📦 1688배송 상태
                    this.배송중 = arr.filter(e => getStatus(e) === '배송중' || getStatus(e) === '발송완료').length;
                    this.배송완료 = arr.filter(e => getStatus(e) === '배송완료').length;

                    // 🏭 쿠패스 상태
                    this.입고작업 = arr.filter(e => getStatus(e) === '입고작업').length;
                    this.출고요청 = arr.filter(e => getStatus(e) === '출고요청').length;
                    this.출고대기 = arr.filter(e => getStatus(e) === '출고대기').length;
                    this.출고완료 = arr.filter(e => getStatus(e) === '출고완료').length;
                    this.중국재고 = arr.filter(e => getStatus(e) === '중국재고').length;

                    // ⚠️ 입고오류 (기존 오류 상태 통합)
                    this.입고오류 = arr.filter(e => {
                        const status = getStatus(e);
                        return status === '입고오류' ||
                               status === '입고수량오류' ||
                               status === '입고상품오류' ||
                               status === '입고오류처리';
                    }).length;

                    // 🚢 쿠팡입고 상태
                    this.해외입고중 = arr.filter(e => getStatus(e) === '해외입고중').length;
                    this.국내입고중 = arr.filter(e => getStatus(e) === '국내입고중').length;

                    // 🏭 국내창고 상태 (화주 창고행)
                    this.국내창고입고중 = arr.filter(e => getStatus(e) === '국내창고입고중').length;
                    this.국내창고입고완료 = arr.filter(e => getStatus(e) === '국내창고입고완료').length;  // 레거시 유지

                    // 🛒 쿠팡센터 상태 (레거시 유지)
                    this.쿠팡센터입고완료 = arr.filter(e => getStatus(e) === '쿠팡센터입고완료').length;

                    // 레거시 호환 (대시보드에서 제거된 상태들)
                    this.발송전 = arr.filter(e => getStatus(e) === '발송전').length;
                    this.발송지연 = arr.filter(e => getStatus(e) === '발송지연').length;
                    this.배송지연 = arr.filter(e => getStatus(e) === '배송지연').length;
                    this.입고완료 = arr.filter(e => getStatus(e) === '입고완료').length;

                    // ⚠️ 레거시 오류 상태 (개별 카운트 유지, 대시보드에서는 입고오류로 통합 표시)
                    this.입고지연 = arr.filter(e => getStatus(e) === '입고지연').length;
                    this.입고수량오류 = arr.filter(e => getStatus(e) === '입고수량오류').length;
                    this.입고상품오류 = arr.filter(e => getStatus(e) === '입고상품오류').length;
                    this.입고오류처리 = arr.filter(e => getStatus(e) === '입고오류처리').length;
                    this.오류입고처리 = arr.filter(e => getStatus(e) === '오류입고처리').length;
                    this.오류반품처리 = arr.filter(e => getStatus(e) === '오류반품처리').length;
                    this.오류폐기처리 = arr.filter(e => getStatus(e) === '오류폐기처리').length;
                    this.오류입고대기 = arr.filter(e => getStatus(e) === '오류입고대기').length;
                    this.반품폐기완료 = arr.filter(e => getStatus(e) === '반품폐기완료').length;

                    this.total = arr.length;

                    this.showreqlist = true;
                })
                .catch(e => console.log('err821' + e))
        },
        getdate(timestamp) {
            var date = new Date(timestamp);
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        changedate() {
            var now
            var target
            if (this.selectdate == 'today') {
                this.startdate = this.getTodaywith();
                this.enddate = this.getTodaywith();
            } else {
                if (this.selectdate == 'week') {
                    now = new Date(this.getTodaywith());
                    target = now - 1000 * 60 * 60 * 24 * 7

                    this.startdate = this.getdate(target);
                    this.enddate = this.getTodaywith();
                } else {
                    if (this.selectdate == 'month') {
                        now = new Date(this.getTodaywith());
                        target = now - 1000 * 60 * 60 * 24 * 30
                        this.startdate = this.getdate(target);
                        this.enddate = this.getTodaywith();
                    }
                }
            }
        },
        allcheck() {
            if (this.allcheckreqlists) {
                this.reqlists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.reqlists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        regrequest(list, index) {
            if (!list.상품명) {
                alert('상품명을 먼저 입력해 주세요')
                return
            }
            this.$bvModal.show('modalreq' + index);
        },
        confirmlists(req) {
            var arr = [];
            if (this.lists.filter(e => e.checked).length == 0) {
                arr = this.lists
                this.lists.forEach(e => { e.checked = true })
            } else {
                arr = this.lists.filter(e => e.checked)
            }

            
            if (!req) {
                if (arr.filter(e => !e.상품명).length > 0) {
                    alert('상품명을 확인해 주세요')
                    return []
                }

                if (arr.filter(e => e.구매링크 === undefined).length > 0) {
                    alert('구매링크를 모두 입력해 주세요')
                    return []
                }
                if (arr.filter(e => e.옵션1_중국어 === undefined || e.옵션2_중국어 === undefined).length > 0) {
                    alert('돋보기를 눌러 구매할 옵션을 모두 매칭해 주세요.')
                    return []
                }
                if (arr.filter(e => e.요청사항 !== '등록완료').length > 0) {
                    alert('요청사항이 등록되지 않은 항목이 있습니다. \'요청등록\'버튼을 눌러 요청을 등록해 주세요.')
                    return []
                }
            }
            if (arr.filter(e => !e.요청내역.barcode && !e.요청내역.sticker && !e.요청내역.stamp && !e.요청내역.tag).length > 0) {
                if (!confirm('원산지 작업내용이 없는 경우 통관이 불가합니다. 상품에 이미 원산지작업이 되어 있습니까?')) {
                    return []
                }
            }
            if (arr.filter(e => !e.신고영문명).length > 0) {
                alert("요청내역 중 신고영문명을 작성해주세요. ex)여성신발 -> women's shoes ")
                return []
            }
            if (arr.filter(e => !e.HSCODE).length > 0) {
                alert("요청내역 중 HS-CODE를 작성해주세요. ex) 6303.92-0000 ")
                return []
            }
            if (arr.filter(e => e.HSCODE.length !== 12).length > 0) {
                alert("HS-CODE를 Full name으로 작성해주세요. ex) 6303.92-0000 ")
                return []
            }
            if (arr.filter(e => e.구매요청수량 == 0 || !e.구매요청수량).length > 0) {
                alert("구매요청수량이 작성안된 제품이 있습니다.")
                return []
            }
            if (arr.filter(e => parseInt(e.구매재고) < e.구매요청수량).length > 0) {
                if (!confirm("구매요청수량보다 구매할수 있는 재고가 적은 상품이 있습니다. 그래도 구매요청 하시겠습니까?")) {
                    return []
                }
            }

            // 구매상품ID별로 주문수량과 상품명들 체크
            const orderQuantityByProduct = {};
            arr.forEach(item => {
                if (!item.구매링크) return;
                const offerId = item.구매링크.slice(item.구매링크.search('offer/') + 6, item.구매링크.search('.html'));

                // 재고 확인 로직
                let stock = 0;

                // 옵션이 없는 경우
                if (!item.옵션1_중국어 && !item.옵션2_중국어) {
                    stock = parseInt(item.item.productSaleInfo.amountOnSale);
                }
                // 옵션이 1개인 경우
                else if (item.옵션1_중국어 && !item.옵션2_중국어) {
                    stock = parseInt(item.item.productSkuInfos.find(f => f.skuAttributes[0].value == item.옵션1_중국어).amountOnSale);
                }
                // 옵션이 2개인 경우
                else {
                    stock = parseInt(item.item.productSkuInfos.find(f => f.skuAttributes[0].value == item.옵션1_중국어 && f.skuAttributes[1].value == item.옵션2_중국어).amountOnSale);
                }

                if (!orderQuantityByProduct[offerId]) {
                    orderQuantityByProduct[offerId] = {
                        totalQuantity: 0,
                        minOrderQuantity: item.item?.minOrderQuantity || 2,
                        products: []
                    };
                }

                orderQuantityByProduct[offerId].totalQuantity += parseInt(item.구매요청수량 || 0);
                orderQuantityByProduct[offerId].products.push({
                    name: item.상품명,
                    quantity: item.구매요청수량,
                    stock: stock,
                    options: item.옵션1_중국어 && item.옵션2_중국어 ?
                        `${item.옵션1_중국어}, ${item.옵션2_중국어}` :
                        item.옵션1_중국어 || ''
                });
            });

            // 검증 실행
            for (const info of Object.values(orderQuantityByProduct)) {
                // 최소 주문수량 체크
                if (info.totalQuantity < info.minOrderQuantity) {
                    const productDetails = info.products
                        .map(p => `${p.name} (옵션: ${p.options}, 수량: ${p.quantity}개)`)
                        .join('\n');

                    alert(`다음 상품들의 총 주문수량(${info.totalQuantity}개)이 최소 주문수량(${info.minOrderQuantity}개)보다 적습니다:\n\n${productDetails}`);
                    // return [];
                }

                // 재고 수량 체크
                const outOfStockProducts = info.products.filter(p => parseInt(p.quantity) > parseInt(p.stock));
                if (outOfStockProducts.length > 0) {
                    const stockDetails = outOfStockProducts
                        .map(p => `${p.name}\n- 옵션: ${p.options}\n- 주문수량: ${p.quantity}개\n- 가용재고: ${p.stock}개`)
                        .join('\n\n');

                    alert(`다음 상품들의 주문수량이 재고수량을 초과합니다:\n\n${stockDetails}`);
                    // return [];
                }
            }

            return arr
        },
        confirmlist(list) {
            if (!list.바코드) {
                if (!confirm('바코드가 없는 경우 로켓그로스 출고가 불가능합니다.')) {
                    return false
                }
            }
            if (!list.신고영문명) {
                alert("요청내역 중 신고영문명을 작성해주세요. ex)여성신발 -> women's shoes ")
                return false
            }
            // if(!list.신고가격){
            //     alert("요청내역 중 신고가격을 USD로 환산하여 작성해주세요. ex) 2달러 -> 2 ")
            //     return false
            // }
            if (!list.HSCODE) {
                alert("요청내역 중 HS-CODE를 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.HSCODE.length !== 12) {
                alert("HS-CODE를 Full name으로 작성해주세요. ex) 6303.92-0000 ")
                return false
            }
            if (list.구매요청수량 == 0 || !list.구매요청수량) {
                alert("구매요청수량을 작성해 주세요.")
                return false
            }
            if (list.판매구성수량 == 0 || !list.판매구성수량) {
                alert("판매구성수량을 작성해 주세요.")
                return false
            }
            list.한글표시사항.제품명 = list.상품명;
            // 필수 텍스트 항목만 화이트리스트로 검사 (kc인증/식품용 등 boolean·선택 키가 추가돼도 오탐 안 나게)
            var 필수표시항목 = ['수입원/판매원', '제조원', '제조국', '내용량', '원료명및성분명(재질)', '상품유형', '사용시주의사항', '사용기준'];
            var 미입력 = 필수표시항목.filter(k => !list.한글표시사항[k]);
            if (list.요청내역.barcode && 미입력.length) {
                alert('한글표시사항을 모두 작성해 주세요\n(미입력: ' + 미입력.join(', ') + ')')
                return
            }
            return true
        },
        async requestpurchase() {
            var list = await this.confirmlists(false)
            if (list.length == 0) {
                alert('요청할 목록이 없습니다.')
                return
            }

            // 바코드라벨 = 한글표시사항 기본포함. 복사로 따라온 옛 한글표시사항:false 를 요청 시점에 맞춘다 (reqpurchaseV0 와 동일)
            list.forEach(e => {
                if (e.요청내역 && e.요청내역.barcode) e.요청내역.한글표시사항 = true;
            });

            await this.saveproductdb(list);

            var cnt = list.length;
            var arr = [];
            var obj = {};
            var now = Date.now();
            list.forEach(e => {
                obj = this.deepClone(e);
                this.resetReqVolatileFields(obj);   // 처리 결과/박스배정/분할 필드 제거 (구매대행요청 시 잔존 방지)
                obj.companyid = this.$store.state.user.companyid;
                obj.요청일 = now;
                obj.구매_id = '';
                arr.push(this.deepClone(obj));
            })
            if (confirm("총 " + cnt + "건을 구매대행 요청하시겠습니까?")) {
                axios.post('/api/reqpurchase/requestpurchase', arr)
                    .then((res) => {
                        this.$store.commit('reqpurchaseupdate', res.data.reqpurchase);
                        alert(res.data.요청결과)
                        var ar = this.lists.filter(e => !e.checked)
                        this.lists = ar;
                        // 구매요청 완료 후 서버 저장 목록도 동기화 (현재상태저장된 데이터에서도 제거)
                        axios.post('/api/reqpurchase/savereqlist', this.lists).catch(console.log)
                    })
                    .catch(console.log)
            }
        },
        async saveproductdb(list) {
            console.log(list)
            if (!confirm('현재 요청하신 정보를 상품DB에 저장하시겠습니까? (저장 이후에는 로켓그로스>상품관리에서 관련내역을 볼 수 있으며, 엑셀대량등록이 가능합니다.)')) {
                return
            }

            if (this.$store.state.growthdb.length == 0) {
                try {
                    // show 없이 전량 — 좁히면 판매장부가 물려받아 숨김 상품 매출이 사라진다(#407)
                    var result = await axios.post('/api/getGrowthDBV2');
                    this.$store.commit('growthdbupdate', result.data.growthdb);
                } catch (e) {
                    alert('로켓그로스 상품DB를 저장하기 전에 "로켓그로스 > 상품관리" 메뉴에서 상품DB 수집을 먼저 진행해 주세요.(쿠팡wing 로그인 필수)')
                    console.log(e)
                    return
                }
            }

            if (this.$store.state.growthdb.length == 0) {
                alert('로켓그로스 상품DB를 저장하기 전에 "로켓그로스 > 상품관리" 메뉴에서 상품DB 수집을 먼저 진행해 주세요.(쿠팡wing 로그인 필수)')
                return
            }

            console.log(this.$store.state.growthdb)
            var regArr = [];
            for (var e of list) {
                if (!regArr.includes(e.바코드)) {
                    regArr.push(e.바코드)
                    if (this.$store.state.growthdb.find(f => f.barcode == e.바코드)) {
                        var obj = this.deepClone(this.$store.state.growthdb.find(f => f.barcode == e.바코드));
                        obj.purchaseInfo = list.filter(ele => ele.바코드 == e.바코드)
                        obj.purchaseInfoReg = true;
                        obj.구매정보 = list.filter(ele => ele.바코드 == e.바코드)
                        obj.구매정보여부 = true;
                        var regObj = {
                            vendorItemId : obj.vendorItemId,
                            구매정보 : obj.구매정보,
                            매입정보 : obj.매입정보
                        }
                        try {
                            // console.log(obj)
                            var res = await axios.post('/api/purchasedb/save', regObj);
                            if (res.data.res !== 'success') {
                                alert('저장실패(2064) : ' + e.바코드 + " : " + res.data.alert)
                            } else {
                                console.log(e.바코드 + " : DB저장완료")
                                this.$store.commit('growthdbupdateOne', this.deepClone(obj));
                            }
                        } catch (e) {
                            alert('저장실패(2064) : ' + e)
                        }
                    }
                }
            }
        },
        deleteindexfromarray(array, index) {
            return array.slice(0, index).concat(array.slice(index + 1))
        },
        deleteitem(index) {
            this.lists = this.deleteindexfromarray(this.lists, index);
        },
        confirmexcelDownFunc() {
            if (this.reqtype == '로켓배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '제트배송') {
                this.excelDownFunc()
                return
            }
            if (this.reqtype == '일반LCL') {
                if (confirm('일반LCL에서 SKUID는 10000000 이하의 숫자로 임의로 기입하시면 됩니다.')) {
                    this.excelDownFunc()
                    return
                }
            }
        },
        modalreq(index) {
            return 'modalreq' + index;
        },
        reset(list) {
            list.상품명 = '';
            list.상품명init = '';
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            list.구매링크 = undefined;
            list.구매링크init = '';
        },
        rematching(list, index) {
            if (!list.구매링크) {
                alert('구매링크를 입력해 주세요')
                return
            }
            list.옵션1_중국어 = undefined;
            list.옵션2_중국어 = undefined;
            list.상품매칭.옵션1_중국어 = [];
            list.상품매칭.옵션2_중국어 = [];
            this.matchoption1(index, list.구매링크)
        },
        fileupload() {
            this.$refs.pdbupload.value = '';
            this.$refs.pdbupload.click();
        },
        option1matching(a, list) {
            // this.showlist = false;
            if (a.imageUrl) {
                // if(!list.등록이미지){
                list.등록이미지 = a.imageUrl;
                // }
                list.옵션이미지 = a.imageUrl;
            }
            list.옵션1_중국어 = a.name;


            // if(this.checkstock){
            if (list.옵션2_중국어 == '') {
                // var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                // list.구매재고 = parseInt(list.item.productSaleInfo.find(e => e.skuAttributes[0].옵션1_중국어 === list.옵션1_중국어).amountOnSale);
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            } else {
                if (list.옵션2_중국어 !== undefined) {
                    // properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
                    // var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
                    // list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
                    // list.구매sku = list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).sku_id;
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                            e.skuAttributes[1].value === list.옵션2_중국어) {
                            list.구매재고 = e.amountOnSale
                        }
                    })
                    if (list.구매재고 == 0) {
                        alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                    } else {
                        alert('구매 가능한 재고수량 : ' + list.구매재고)
                        list.매칭상태 = '매칭완료';
                    }
                } else {
                    list.상품매칭.옵션2_중국어 = []
                    list.item.productSkuInfos.forEach(e => {
                        if (e.skuAttributes[0].value === list.옵션1_중국어) {
                            list.상품매칭.옵션2_중국어.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    })
                }
            }
            // if(list.등록이미지 == '' && list.옵션이미지 == ''){
            //     list.등록이미지 = list.item.pic_url;
            //     list.옵션이미지 = list.item.pic_url;
            // }
            // this.showlist = true;
            // }
        },
        option2matching(a, list) {
            // this.showlist = false;
            if (a.imageUrl) {
                list.등록이미지 = a.imageUrl;
            }
            list.옵션2_중국어 = a.name;

            if (list.옵션1_중국어 !== undefined) {
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[0].value === list.옵션1_중국어 &&
                        e.skuAttributes[1].value === list.옵션2_중국어) {
                        list.구매재고 = e.amountOnSale
                    }
                })
                if (list.구매재고 == 0) {
                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                } else {
                    alert('구매 가능한 재고수량 : ' + list.구매재고)
                    list.매칭상태 = '매칭완료';
                }
            } else {
                list.상품매칭.옵션1_중국어 = []
                list.item.productSkuInfos.forEach(e => {
                    if (e.skuAttributes[1].value === list.옵션2_중국어) {
                        list.상품매칭.옵션1_중국어.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }
                })
            }

            // if(this.checkstock){

            // if(list.상품매칭.옵션1_중국어 && list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어)){
            //     var properties1 = list.상품매칭.옵션1_중국어.find(e => e.name == list.옵션1_중국어).properties;
            //     var properties2 = list.상품매칭.옵션2_중국어.find(e => e.name == list.옵션2_중국어).properties;
            //     list.구매재고 = parseInt(list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).quantity);
            //     list.구매sku = list.item.skus.sku.find(e => e.properties == properties1 + ";" + properties2).sku_id;
            //     if(list.구매재고 == 0){
            //         alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
            //     } else {
            //         alert('구매 가능한 재고수량 : ' + list.구매재고)
            //     }
            //     list.매칭상태 = '매칭완료'
            // }
            //
            // // }
            // if(list.등록이미지 == '' && list.옵션이미지 == ''){
            //     list.등록이미지 = list.item.pic_url;
            //     list.옵션이미지 = list.item.pic_url;
            // }
            // this.showlist = true;
            console.log(list)
        },
        sendmessage(url) {
            window.postMessage({ greeting: "importproductinfo", url: url }, "*",)
        },
        // async getProductInfo(구매링크){
        //     var productNo = 구매링크.slice(구매링크.search('offer/')+6,구매링크.search('.html'));
        //     console.log(productNo)
        //     try{
        //         var res = await axios.post('/api/reqpurchase/getProductInfo',[productNo])
        //         return res.data.result[0].item
        //     }catch(e){
        //         console.log('err821' + e);
        //         return false
        //     }
        // },
        async getProductInfo(구매링크) {
            var productNo = 구매링크.slice(구매링크.search('offer/') + 6, 구매링크.search('.html'));
            try {
                var res = await axios.post('/api/aiPage/getProductInfo', [{ productId: parseInt(productNo) }])
                return res
            } catch (e) {
                console.log('err821' + e);
                return false
            }
        },


        async confirmreq(obj) {
            console.log(obj)
            if (!obj.구매링크) {
                obj.showspinner = false;
                return obj
            }
            obj.구매링크init = obj.구매링크;
            obj.매칭상태 = '매칭필요'
            var item = await this.getProductInfo(obj.구매링크);
            item = item.data.result[0].result.result
            console.log(item)
            obj.item = item;

            let option1array = [];
            let option2array = [];

            if (item.productSkuInfos) {
                item.productSkuInfos.forEach((e) => {
                    if (!option1array.find(option => option.name === e.skuAttributes[0].value)) {
                        option1array.push({
                            name: e.skuAttributes[0].value,
                            imageUrl: e.skuAttributes[0].skuImageUrl ? e.skuAttributes[0].skuImageUrl : '',
                        })
                    }

                    if (e.skuAttributes[1]) {
                        if (!option2array.find(option => option.name === e.skuAttributes[1].value)) {
                            option2array.push({
                                name: e.skuAttributes[1].value,
                                imageUrl: e.skuAttributes[1].skuImageUrl ? e.skuAttributes[1].skuImageUrl : '',
                            })
                        }
                    } else {
                        option2array = []
                    }
                })
            }

            if (option1array.length === 0) {
                obj.상품매칭.옵션1_중국어 = [];
                obj.상품매칭.옵션2_중국어 = [];
                obj.옵션1_중국어 = '';
                obj.옵션2_중국어 = '';
                obj.구매재고 = item.productSaleInfo.amountOnSale;
                obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : item.productImage.images[0];
                obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : item.productImage.images[0];
                obj.매칭상태 = '매칭완료'
            } else {
                var imgUrl = '';
                if (option2array.length == 0) {
                    imgUrl = option1array.find(e => e.name == obj.옵션1_중국어) ? imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : "";
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어).amountOnSale;
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : imgUrl;
                        obj.매칭상태 = '매칭완료'
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = [];
                    obj.옵션2_중국어 = '';
                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                } else {
                    if (!option1array.find(e => e.name == obj.옵션1_중국어)) {
                        obj.옵션1_중국어 = undefined;
                        obj.옵션이미지 = undefined;
                        obj.구매재고 = 0;
                    } else {
                        obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : option1array.find(e => e.name == obj.옵션1_중국어).imageUrl;
                        if (!option2array.find(e => e.name == obj.옵션2_중국어)) {
                            obj.옵션2_중국어 = undefined;
                            obj.구매재고 = 0;
                        } else {
                            obj.구매재고 = item.productSkuInfos.find(f => f.skuAttributes[0].value == obj.옵션1_중국어 && f.skuAttributes[1].value == obj.옵션2_중국어)?.amountOnSale || 0;
                            imgUrl = option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : "");
                            obj.옵션이미지 = obj.옵션이미지 ? obj.옵션이미지 : (option1array.find(e => e.name == obj.옵션1_중국어).imageUrl ? option1array.find(e => e.name == obj.옵션1_중국어).imageUrl : (option2array.find(e => e.name == obj.옵션2_중국어).imageUrl ? option2array.find(e => e.name == obj.옵션2_중국어).imageUrl : ""));
                            if(obj.구매재고 == 0){
                                obj.매칭상태 = '매칭필요'
                                obj.옵션1_중국어 = undefined;
                                obj.옵션2_중국어 = undefined;
                            } else {
                                obj.매칭상태 = '매칭완료'
                            }
                        }
                    }
                    obj.상품매칭.옵션1_중국어 = option1array;
                    obj.상품매칭.옵션2_중국어 = option2array;
                    console.log(option1array)
                    console.log(option1array.find(e => e.name == obj.옵션1_중국어))
                    console.log(option2array)

                    obj.등록이미지 = obj.등록이미지 ? obj.등록이미지 : imgUrl;
                }

                if (!obj.등록이미지 && !option1array.find(e => e.imageUrl) && !option1array.find(e => e.imageUrl)) {
                    obj.등록이미지 = item.productImage.images[0];
                }
            }
            obj.showspinner = false;
            return obj
        },
        async matchoption1(index, 구매링크) {
            if (!구매링크.includes('1688.com')) {
                alert('올바른 구매링크를 입력해 주세요')
                this.lists[index].구매링크init = undefined;
                this.lists[index].구매링크 = undefined;
                return
            }
            this.lists[index].showspinner = true;
            this.lists[index].구매링크 = 구매링크;
            this.currentindex = index;
            // setTimeout(() => {this.sendmessage(구매링크);},1)
            var newObj = await this.confirmreq(this.lists[index]);
            // console.log(newObj)
            // this.showlist = false
            this.lists[index] = newObj;
            console.log(this.lists[this.currentindex])

            // axios.post('/api/reqpurchase/geturlinfo',{
            //     url : 구매링크
            // })
            // .then((res) => {
            //     if(res.data.요청결과 == 'success'){
            //         console.log(res.data.result)
            //         var obj = {}
            //         res.data.result.option1array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })
            //         res.data.result.option2array.forEach(e => {
            //             obj = {
            //                 image : e.imageUrl,
            //                 optionname : e.name,
            //             }
            //             list.상품매칭.옵션1_중국어.push(obj)
            //         })

            //     } else {
            //         alert('error777 :' + res.data.요청결과)
            //     }
            // })
            // .catch(console.log)
        },
        matchclass(a) {
            if (a == '매칭완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        reqclass(a) {
            if (a == '등록완료') {
                return 'badge badge-success';
            } else {
                return 'badge badge-warning';
            }
        },
        excelDownFunc() {
            var arr = [];
            var myHeader = ["바코드", "구매요청수량"];

            var dataWS = XLSX.utils.json_to_sheet(arr, { header: myHeader });

            const range = XLSX.utils.decode_range(dataWS['!ref']);
            range.e['c'] = myHeader.length - 1;
            dataWS['!ref'] = XLSX.utils.encode_range(range);

            var wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '구매대행요청양식');
            // 엑셀 파일을 내보낸다.
            XLSX.writeFile(wb, '구매대행요청양식.xlsx');
        },
        // SSE 알림 수신 후 서버에서 최신 데이터 갱신 (검색조건 유지)
        async refreshDataFromServer() {
            try {
                var start = this.gettimestamp(this.startdate);
                var end = this.gettimestamp(this.enddate) + (1000 * 60 * 60 * 24) - 1;
                const res = await axios.post('/api/reqpurchase/getlists', { start, end, 상품명: this.상품명, 바코드: this.바코드 });
                if (res.data.요청결과 === 'ok') {
                    this.reqlistsinit = [];
                    const arr = [];
                    res.data.reqpurchase.forEach(e => {
                        if (e.reqtype === '제트배송') {
                            e.진행현황 = e.진행현황 || '구매전';
                            e.checked = false;
                            e.요청내역.destination = e.요청내역.destination || 'coupang';
                            arr.push(this.deepClone(e));
                            this.reqlistsinit.push(this.deepClone(e));
                        }
                    });
                    this.loadShipmentDist(this.reqlistsinit);
                    // 상태 카운트 재계산
                    const getStatus = (e) => e.processStatus || e.진행현황 || '구매전';
                    this.입금요청 = arr.filter(e => getStatus(e) === '입금요청').length;
                    this.입금완료 = arr.filter(e => getStatus(e) === '입금완료').length;
                    this.total = arr.length;
                }
            } catch (e) {
                console.error('데이터 갱신 오류:', e);
            }
        },
        async filterByStatus(status) {
            // 입금요청 필터 시 SSE 알림이 있었다면 서버에서 최신 데이터 갱신
            if (status === '입금요청' && this.$store.state.sseNotifications.quotation_created > 0) {
                await this.refreshDataFromServer();
                this.$store.commit('sseClearNotification', 'quotation_created');
            }
            // processStatus 우선 사용, 없으면 진행현황 사용 (레거시 호환)
            const getStatus = (e) => e.processStatus || e.진행현황 || '구매전';
            this.reqlists = this.reqlistsinit.filter(e => getStatus(e) === status);
        },
        // 여러 상태값으로 필터링 (레거시 호환용)
        filterByStatusMultiple(statuses) {
            const getStatus = (e) => e.processStatus || e.진행현황 || '구매전';
            this.reqlists = this.reqlistsinit.filter(e => statuses.includes(getStatus(e)));
        },
        // 진행현황 뱃지 색상 반환
        getProcessStatusVariant(status) {
            const variants = {
                '구매전': 'secondary',
                '협상중': 'info',
                '구매확인': 'info',
                '입금요청': 'warning',
                '입금완료': 'primary',
                '구매완료': 'primary',
                '구매보류': 'warning',
                '구매취소': 'danger',
                '배송중': 'info',
                '배송완료': 'success',
                '입고작업': 'info',
                '출고요청': 'warning',
                '출고대기': 'primary',
                '출고완료': 'success',
                '중국재고': 'dark',
                '입고오류': 'danger',
                '해외입고중': 'info',
                '국내입고중': 'primary',
                '쿠팡센터입고완료': 'success',
                '국내창고입고중': 'info',
                '국내창고입고완료': 'success',
            };
            return variants[status] || 'secondary';
        },
        // 입고오류 상세 모달 열기
        openErrorDetailModal(item) {
            this.errorDetailItem = item;
            this.showErrorDetailModal = true;
        },
        // 입고사진 모달 열기
        openImportPhotoModal(item) {
            this.importPhotoItem = item;
            this.showImportPhotoModal = true;
        },
        // 진행현황 변경 이력 조회 모달 열기
        async openProcessHistoryModal(item) {
            if (!item || !item._id) {
                alert('이력을 조회할 수 없는 항목입니다.');
                return;
            }
            this.showProcessHistoryModal = true;
            this.processHistoryLoading = true;
            this.processHistoryList = [];
            this.processHistoryCurrentStatus = item.processStatus || item.진행현황 || '구매전';
            try {
                const response = await axios.post('/api/reqpurchase/getProcessHistory', {
                    _id: item._id
                });
                if (response.data.요청결과 === '성공') {
                    this.processHistoryList = response.data.processHistory || [];
                    this.processHistoryCurrentStatus = response.data.processStatus;
                }
            } catch (error) {
                console.error('이력 조회 오류:', error);
                alert('이력 조회 중 오류가 발생했습니다.');
            } finally {
                this.processHistoryLoading = false;
            }
        },
        // 물류비 입금요청 건 필터링 (paymentStatus 기반)
        filterByPaymentPending(type) {
            if (type === '중국물류') {
                this.reqlists = this.reqlistsinit.filter(e => e.견적서_중국물류비?.paymentStatus === '입금요청');
            } else if (type === '한국물류') {
                this.reqlists = this.reqlistsinit.filter(e => e.견적서_한국물류비?.paymentStatus === '입금요청');
            }
        },
        // 물류비 입금완료 처리 (화주 → 쿠패스)
        async completeLogisticsPayment(item, type) {
            const typeName = type === '중국물류비' ? '중국물류비' : '한국물류비';
            if (!confirm(`"${item.상품명}" ${typeName} 입금완료 처리하시겠습니까?`)) return;

            try {
                this.showspinner = true;
                const response = await axios.post('/api/quotation/completeLogisticsPayment', {
                    reqpurchaseIds: [item._id],
                    type
                });

                if (response.data.요청결과 === '성공') {
                    this.$bvToast.toast(`${typeName} 입금완료 처리되었습니다.`, {
                        title: '입금완료', variant: 'success', solid: true
                    });

                    // 로컬 데이터 업데이트
                    const fieldName = type === '중국물류비' ? '견적서_중국물류비' : '견적서_한국물류비';
                    if (item[fieldName]) item[fieldName].paymentStatus = '입금완료';
                    const initItem = this.reqlistsinit.find(i => i._id === item._id);
                    if (initItem?.[fieldName]) initItem[fieldName].paymentStatus = '입금완료';

                    // 대시보드 카운트 갱신
                    this.중국물류입금요청 = this.reqlistsinit.filter(e => e.견적서_중국물류비?.paymentStatus === '입금요청').length;
                    this.한국물류입금요청 = this.reqlistsinit.filter(e => e.견적서_한국물류비?.paymentStatus === '입금요청').length;
                    this.$forceUpdate();
                } else {
                    alert('입금완료 처리 실패: ' + (response.data.error?.errorMessage || '알 수 없는 오류'));
                }
            } catch (error) {
                console.error('물류비 입금완료 오류:', error);
                alert('입금완료 처리 중 오류: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },
        // 💳 예치금 잔액 조회
        async fetchDepositBalance() {
            try {
                const response = await axios.get('/api/deposit/getBalance/' + encodeURIComponent(this.$store.state.user.companyid));
                if (response.data.요청결과 === '성공') {
                    this.depositBalance = response.data.data?.잔액 || 0;
                }
            } catch (error) {
                console.error('예치금 잔액 조회 오류:', error);
            }
        },
        // 💳 예치금 내역 모달 열기
        async openDepositHistoryModal() {
            try {
                const response = await axios.get('/api/deposit/getHistory/' + encodeURIComponent(this.$store.state.user.companyid));
                if (response.data.요청결과 === '성공') {
                    this.depositHistory = response.data.data?.내역 || [];
                    this.depositBalance = response.data.data?.잔액 || 0;
                    this.showDepositHistoryModal = true;
                }
            } catch (error) {
                console.error('예치금 내역 조회 오류:', error);
                alert('예치금 내역 조회 실패');
            }
        },
        // 그룹 견적서 모달 열기 (같은 화주주문번호 그룹)
        async openQuotationDetailModal(item) {
            const 화주주문번호 = item.화주주문번호;
            if (!화주주문번호) {
                this.quotationGroupItems = [item];
            } else {
                this.quotationGroupItems = this.reqlistsinit.filter(i => i.화주주문번호 === 화주주문번호);
            }

            // 그룹 헤더 정보
            const q = item.견적서_1688구매금액;
            this.quotationGroupInfo = {
                화주주문번호: 화주주문번호 || '-',
                customsType: q?.customsType || 'integrated',
                적용환율: q?.적용환율 || 300
            };

            // 견적서 있고 입금요청 상태인 아이템만 선택 (기본값)
            this.quotationGroupSelected = this.quotationGroupItems.filter(i => i.견적서_1688구매금액 && (i.processStatus || i.진행현황) === '입금요청');

            // 공통물류비 데이터 조회
            this.quotationCommonLogistics = null;
            if (화주주문번호 && item.companyid) {
                try {
                    const res = await axios.get(`/api/quotation/getCommonLogistics/${encodeURIComponent(화주주문번호)}/${encodeURIComponent(item.companyid)}`);
                    if (res.data.요청결과 === '성공' && res.data.data) {
                        this.quotationCommonLogistics = res.data.data;
                    }
                } catch (e) { console.error('공통물류비 조회 오류:', e); }
            }

            this.showQuotationDetailModal = true;
        },

        // 그룹 견적서 전체 선택/해제 (입금완료 건 제외)
        toggleAllQuotationGroup(checked) {
            if (checked) {
                this.quotationGroupSelected = this.quotationGroupItems.filter(i => i.견적서_1688구매금액 && (i.processStatus || i.진행현황) === '입금요청');
            } else {
                this.quotationGroupSelected = [];
            }
        },

        // 그룹 견적서 개별 아이템 선택/해제
        toggleQuotationGroupItem(item, checked) {
            if (checked) {
                if (!this.quotationGroupSelected.some(s => s._id === item._id)) {
                    this.quotationGroupSelected.push(item);
                }
            } else {
                this.quotationGroupSelected = this.quotationGroupSelected.filter(s => s._id !== item._id);
            }
        },

        // 견적서 엑셀 다운로드
        downloadQuotationExcel() {
            if (!this.quotationGroupItems || this.quotationGroupItems.length === 0) return;

            const processed = this.quotationGroupItemsProcessed || [];
            const info = this.quotationGroupInfo || {};

            const data = processed.map(item => {
                return {
                    '상품명': item.상품명,
                    '옵션ID': item.SKUID || '',
                    '바코드': item.바코드 || '',
                    '수량': item.구매요청수량 || 1,
                    '부가세(KRW)': item.견적서_1688구매금액?.부가세 || '',
                    '총금액(KRW)': item.견적서_1688구매금액?.최종금액합계_KRW || '',
                    '중국물류비(KRW)': item._중국물류비 || '',
                    '공통배분(KRW)': item._공통배분 || '',
                    '한국물류비(KRW)': item._한국물류비 || ''
                };
            });

            // 합계 행
            const totalKRW = processed.reduce((s, i) => s + (i.견적서_1688구매금액?.최종금액합계_KRW || 0), 0);
            const total부가세 = processed.reduce((s, i) => s + (i.견적서_1688구매금액?.부가세 || 0), 0);
            const total중국물류비 = processed.reduce((s, i) => s + (i._중국물류비 || 0), 0);
            const total공통배분 = processed.reduce((s, i) => s + (i._공통배분 || 0), 0);
            const total한국물류비 = processed.reduce((s, i) => s + (i._한국물류비 || 0), 0);
            data.push({
                '상품명': '합계',
                '부가세(KRW)': total부가세,
                '총금액(KRW)': totalKRW,
                '중국물류비(KRW)': total중국물류비,
                '공통배분(KRW)': total공통배분,
                '한국물류비(KRW)': total한국물류비
            });

            // XLSX 다운로드
            const ws = XLSX.utils.json_to_sheet(data);
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, '견적서');
            const filename = `견적서_${info.화주주문번호 || 'unknown'}_${new Date().toISOString().slice(0,10)}.xlsx`;
            XLSX.writeFile(wb, filename);

            this.$bvToast.toast('엑셀 파일이 다운로드되었습니다.', { title: '다운로드 완료', variant: 'success', solid: true });
        },

        /**
         * 견적서 PDF 다운로드 (새 탭에서 인쇄)
         * - 상단 info 블록: 화주주문번호/통관방식/적용환율/요청일/사업자등록번호/대표자명/이메일 (세금계산서용)
         * - 18컬럼 데이터 테이블 (Excel과 동일)
         * - A4 가로 모드
         */
        downloadQuotationPDF() {
            if (!this.quotationGroupItems || this.quotationGroupItems.length === 0) return;

            const processed = this.quotationGroupItemsProcessed || [];
            const info = this.quotationGroupInfo || {};
            const firstItem = this.quotationGroupItems[0];
            const 통관타입 = info.customsType === 'integrated' ? '통합통관'
                : info.customsType === 'kupass' ? '쿠패스단독'
                : info.customsType === 'client' ? '화주단독'
                : info.customsType || '-';
            const 적용환율 = info.적용환율 || '-';
            const 요청일 = firstItem?.요청일 ? this.getdate(firstItem.요청일) : '-';

            let html = `
                <html><head><title>견적서</title>
                <style>
                    @page { size: A4 landscape; margin: 10mm; }
                    body { font-family: 'Malgun Gothic', sans-serif; padding: 15px; font-size: 10px; }
                    table { width: 100%; border-collapse: collapse; margin-top: 10px; }
                    th, td { border: 1px solid #333; padding: 4px 5px; text-align: center; }
                    th { background: #f0f0f0; }
                    .right { text-align: right; }
                    .header { margin-bottom: 10px; }
                    .info-table { border: none; margin-bottom: 8px; }
                    .info-table td { border: none; padding: 2px 10px 2px 0; text-align: left; font-size: 11px; }
                    h2 { margin: 0 0 8px 0; font-size: 18px; }
                </style>
                </head><body>
                <div class="header">
                    <h2>견적서 (报价单)</h2>
                    <table class="info-table">
                        <tr><td><strong>화주주문번호:</strong> ${info.화주주문번호 || '-'}</td><td><strong>통관방식:</strong> ${통관타입}</td><td><strong>적용환율:</strong> ${적용환율}원/元</td><td><strong>요청일:</strong> ${요청일}</td></tr>
                        <tr><td><strong>사업자등록번호:</strong> ${firstItem?.입금정보?.사업자등록번호 || '-'}</td><td><strong>대표자명:</strong> ${firstItem?.입금정보?.대표자명 || '-'}</td><td colspan="2"><strong>이메일:</strong> ${firstItem?.입금정보?.이메일주소 || '-'}</td></tr>
                    </table>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th rowspan="2">상품명</th><th rowspan="2">옵션ID</th><th rowspan="2">바코드</th><th rowspan="2">수량</th>
                            <th rowspan="2">부가세(KRW)</th><th rowspan="2">총금액(KRW)</th>
                            <th rowspan="2" style="background:#d4edda;">중국물류비</th><th rowspan="2" style="background:#cce5ff;">공통배분</th><th rowspan="2" style="background:#d4edda;">한국물류비</th>
                        </tr>
                    </thead>
                    <tbody>`;

            processed.forEach(item => {
                html += `<tr>
                    <td>${item.상품명 || '-'}</td>
                    <td>${item.SKUID || '-'}</td>
                    <td>${item.바코드 || '-'}</td>
                    <td>${item.구매요청수량 || 1}</td>
                    <td class="right">${item.견적서_1688구매금액 ? '₩' + (item.견적서_1688구매금액.부가세 || 0).toLocaleString() : '-'}</td>
                    <td class="right">${item.견적서_1688구매금액 ? '₩' + (item.견적서_1688구매금액.최종금액합계_KRW || 0).toLocaleString() : '-'}</td>
                    <td class="right" style="background:#f0fff0;">${item._중국물류비 ? '₩' + item._중국물류비.toLocaleString() : '-'}</td>
                    <td class="right" style="background:#f0f4ff;">${item._공통배분 ? '₩' + item._공통배분.toLocaleString() : '-'}</td>
                    <td class="right" style="background:#f0fff0;">${item._한국물류비 ? '₩' + item._한국물류비.toLocaleString() : '-'}</td>
                </tr>`;
            });

            const total부가세 = processed.reduce((s, i) => s + (i.견적서_1688구매금액?.부가세 || 0), 0);
            const totalKRW = processed.reduce((s, i) => s + (i.견적서_1688구매금액?.최종금액합계_KRW || 0), 0);
            const total중국 = processed.reduce((s, i) => s + (i._중국물류비 || 0), 0);
            const total공통 = processed.reduce((s, i) => s + (i._공통배분 || 0), 0);
            const total한국 = processed.reduce((s, i) => s + (i._한국물류비 || 0), 0);

            html += `</tbody>
                <tfoot><tr style="background:#ddd; font-weight:bold;">
                    <td colspan="4" class="right">합계</td>
                    <td class="right">₩${total부가세.toLocaleString()}</td>
                    <td class="right">₩${totalKRW.toLocaleString()}</td>
                    <td class="right">₩${total중국.toLocaleString()}</td>
                    <td class="right">₩${total공통.toLocaleString()}</td>
                    <td class="right">₩${total한국.toLocaleString()}</td>
                </tr></tfoot></table>
                <scr` + `ipt>window.print();</scr` + `ipt>
                </bo` + `dy></ht` + `ml>`;

            const printWindow = window.open('', '_blank');
            printWindow.document.write(html);
            printWindow.document.close();
        },

        // 선택한 견적서 아이템 입금완료처리
        paySelectedQuotationItems() {
            if (this.quotationGroupSelected.length === 0) {
                alert('입금완료 처리할 항목을 선택해주세요.');
                return;
            }
            // 기존 tableSelectedItem에 선택 항목 설정 후 입금 모달 열기
            this.tableSelectedItem = [...this.quotationGroupSelected];
            this.showQuotationDetailModal = false;
            this.$nextTick(() => {
                this.openPaymentModal();
            });
        },
        // 입금완료 모달 열기
        openPaymentModal() {
            if (this.tableSelectedItem.length === 0) {
                alert('입금완료 처리할 항목을 선택해주세요.');
                return;
            }

            // settings에서 이전 입금정보 가져오기 (있으면)
            const lastPaymentInfo = this.$store.state.settings[0]?.lastPaymentInfo;

            if (lastPaymentInfo) {
                this.paymentInfo = { ...lastPaymentInfo };
            } else {
                // 초기값 설정
                this.paymentInfo = {
                    입금자명: this.$store.state.user?.name || '',
                    입금액: this.calculateTotalAmount(),
                    사업자등록번호: '',
                    대표자명: this.$store.state.user?.name || '',
                    이메일주소: this.$store.state.user?.email || ''
                };
            }

            // 선택된 항목들의 총 금액 계산하여 입금액 초기값 설정
            this.paymentInfo.입금액 = this.calculateTotalAmount();

            this.showPaymentModal = true;
        },
        // 선택된 항목들의 총 금액 계산
        calculateTotalAmount() {
            let total = 0;
            this.tableSelectedItem.forEach(item => {
                // 견적서_1688구매금액.최종금액합계_KRW 사용
                const amount = item.견적서_1688구매금액?.최종금액합계_KRW || 0;
                total += parseFloat(amount) || 0;
            });
            return total;
        },
        // 입금완료 처리 제출
        async submitPayment(bvModalEvent) {
            // 유효성 검사
            if (!this.paymentInfo.입금자명 || !this.paymentInfo.입금액) {
                bvModalEvent.preventDefault();
                alert('입금자명과 입금액은 필수입니다.');
                return;
            }

            try {
                const itemIds = this.tableSelectedItem.map(item => item._id);

                const response = await axios.post('/api/reqpurchase/completePayment', {
                    items: itemIds,
                    paymentInfo: this.paymentInfo
                });

                if (response.data.요청결과 === '성공') {
                    // 로컬 데이터 업데이트 (processStatus + 진행현황 모두 업데이트)
                    this.tableSelectedItem.forEach(selectedItem => {
                        const index = this.reqlists.findIndex(e => e._id === selectedItem._id);
                        if (index !== -1) {
                            this.reqlists[index].processStatus = '입금완료';
                            this.reqlists[index].진행현황 = '입금완료';
                            this.reqlists[index].입금정보 = this.paymentInfo;
                        }
                        const initIndex = this.reqlistsinit.findIndex(e => e._id === selectedItem._id);
                        if (initIndex !== -1) {
                            this.reqlistsinit[initIndex].processStatus = '입금완료';
                            this.reqlistsinit[initIndex].진행현황 = '입금완료';
                            this.reqlistsinit[initIndex].입금정보 = this.paymentInfo;
                        }
                    });

                    // settings에 입금정보 저장 (vuex)
                    if (this.$store.state.settings[0]) {
                        this.$store.state.settings[0].lastPaymentInfo = { ...this.paymentInfo };
                    }

                    // 카운트 재계산 (processStatus 우선 사용)
                    const getStatus = (e) => e.processStatus || e.진행현황 || '구매전';
                    this.입금요청 = this.reqlistsinit.filter(e => getStatus(e) === '입금요청').length;
                    this.입금완료 = this.reqlistsinit.filter(e => getStatus(e) === '입금완료').length;

                    // 선택 해제
                    this.tableSelectedItem = [];

                    alert(`${response.data.modifiedCount}건의 입금완료 처리가 완료되었습니다.`);
                } else {
                    alert('입금완료 처리 실패: ' + (response.data.error || '알 수 없는 오류'));
                }
            } catch (error) {
                console.error('입금완료 처리 오류:', error);
                alert('입금완료 처리 중 오류가 발생했습니다.');
            }
        },
        // 한국물류비 입력 모달 열기 (화주용 - 동적 items + pre-populate)
        openKoreaLogisticsModal(item) {
            this.koreaLogisticsItem = item;
            this.koreaLogisticsForm = { 메모: '' };

            // 기존 견적서가 있으면 해당 items 로드 (재생성/수정)
            if (item.견적서_한국물류비?.items?.length) {
                this.koreaLogisticsItems = item.견적서_한국물류비.items.map(i => ({ ...i }));
                this.koreaLogisticsForm.메모 = item.견적서_한국물류비.메모 || '';
            } else {
                // 기본 항목 pre-populate (빈값 - 화주가 금액 입력)
                this.koreaLogisticsItems = [
                    { name: '관부가세', unitPrice: 0, quantity: 1, amount: 0 },
                    { name: '국내물류비', unitPrice: 0, quantity: 1, amount: 0 },
                    { name: '관세사비', unitPrice: 0, quantity: 1, amount: 0 }
                ];
            }

            this.showKoreaLogisticsModal = true;
        },

        // 동적 items 금액 자동 계산 (한국물류비)
        calcKoreaItemAmount(idx) {
            const row = this.koreaLogisticsItems[idx];
            row.amount = (row.unitPrice || 0) * (row.quantity || 0);
        },

        // 한국물류비 저장/수정 (화주용 - 동적 items)
        async submitKoreaLogistics(bvModalEvt) {
            bvModalEvt.preventDefault();

            if (!this.koreaLogisticsItem) {
                alert('대상 항목이 없습니다.');
                return;
            }

            const validItems = this.koreaLogisticsItems.filter(i => i.name && i.name.trim());
            if (validItems.length === 0) {
                alert('비용 항목을 1개 이상 입력해주세요.');
                return;
            }

            try {
                this.showspinner = true;

                const response = await axios.post('/api/quotation/createKoreaLogistics', {
                    reqpurchaseId: this.koreaLogisticsItem._id,
                    customsType: 'client', // 화주는 항상 화주단독통관
                    items: validItems,
                    메모: this.koreaLogisticsForm.메모
                });

                if (response.data.요청결과 === '성공') {
                    const isEdit = !!this.koreaLogisticsItem.견적서_한국물류비;
                    this.$bvToast.toast(`한국물류비가 ${isEdit ? '수정' : '저장'}되었습니다.`, {
                        title: `${isEdit ? '수정' : '저장'} 완료`,
                        variant: 'success',
                        solid: true
                    });

                    // 로컬 데이터 업데이트 (items 포함)
                    const updatedData = {
                        quotationId: response.data.quotation._id,
                        customsType: response.data.quotation.customsType,
                        items: response.data.quotation.items,
                        합계: response.data.quotation.합계,
                        총금액: response.data.quotation.총금액,
                        paymentStatus: response.data.quotation.paymentStatus,
                        생성일: response.data.quotation.생성일
                    };
                    this.koreaLogisticsItem.견적서_한국물류비 = updatedData;

                    const initIndex = this.reqlistsinit.findIndex(i => i._id === this.koreaLogisticsItem._id);
                    if (initIndex !== -1) {
                        this.reqlistsinit[initIndex].견적서_한국물류비 = updatedData;
                    }

                    this.$forceUpdate();
                    this.showKoreaLogisticsModal = false;
                    this.koreaLogisticsItem = null;
                } else {
                    alert('저장 실패: ' + (response.data.error?.errorMessage || '알 수 없는 오류'));
                }
            } catch (error) {
                console.error('한국물류비 저장 오류:', error);
                alert('저장 중 오류가 발생했습니다: ' + (error.response?.data?.error?.errorMessage || error.message));
            } finally {
                this.showspinner = false;
            }
        },
        async uploadfile(event) {
            var ob = {};
            // this.showlist = false;
            this.showuploadspinner = true;
            if (this.lists.length > 0 && !confirm('현재 구매요청 내역을 유지하시겠습니까?')) {
                this.lists = [];
            }
            if (this.$store.state.growthdb.length == 0) {
                var result = await axios.post('/api/getGrowthDBV2');
                this.$store.commit('growthdbupdate', result.data.growthdb);
            }

            // var 주문번호,판매처,배송단가,할인단가,운송장번호,주문날짜,주문상태;
            setTimeout(async () => {
                const file = event.target.files[0];
                let reader = new FileReader();
                reader.onload = async (e) => {
                    // let data = reader.result;
                    let data = e.target.result;
                    let workbook = XLSX.read(data, { type: 'binary' });
                    workbook.SheetNames.forEach(async (sheetName) => {
                        const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                        console.log(roa)
                        // this.uploadreqfile(roa);

                        if (!roa.find(e => this.$store.state.growthdb.find(ele => ele.barcode == e.바코드))) {
                            alert('상품DB를 먼저 등록해주세요')
                            this.showlist = true;
                            this.showuploadspinner = false;
                            return
                        } else {
                            for (var i = 0; i < roa.length; i++) {
                                var e = roa[i]
                                ob = this.$store.state.growthdb.find(ele => ele.barcode == e.바코드);
                                for (var j = 0; j < ob.구매정보.length; j++) {
                                    var f = ob.구매정보[j];
                                    this.uploadstatus = parseInt((i + 1) / roa.length * 100) + '% 업로드 중...(' + (j + 1) + "/" + ob.구매정보.length + ")";
                                    var conf = await this.confirmreq(f);
                                    this.resetReqVolatileFields(conf);
                                    conf.reqtype = '제트배송';
                                    conf.구매요청수량 = parseInt(e.구매요청수량);
                                    conf.요청내역 = conf.요청내역 || {};
                                    conf.요청내역.customsType = conf.요청내역.customsType ? conf.요청내역.customsType : 'integrated';
                                    conf.요청내역.destination = conf.요청내역.destination ? conf.요청내역.destination : 'coupang';
                                    conf.요청내역.reqcontentPurchase = conf.요청내역.reqcontentPurchase || '';
                                    this.lists.push(this.deepClone(conf))
                                }
                            }
                        }
                        // this.showlist = true;
                        this.showuploadspinner = false;
                    });
                };
                reader.readAsBinaryString(file);
            }, 10);
        },
        async uploadreqfile(req) {
            this.change = true;
            if (req.length == 0) {
                alert('구매요청수량이 없습니다.')
                return
            }
            console.log('req'.req)
            var 요청건수 = req.filter(e => parseInt(e.구매요청수량) > 0).length;
            var 요청수량 = req.reduce((pv, cv) => { return pv + parseInt(cv.구매요청수량) }, 0);
            if (confirm(요청건수 + '건(총수량:' + 요청수량 + '개)의 내역을 구매요청하시겠습니까?')) {
                var arr = [];
                var nosku = [];
                for (var i = 0; i < req.length; i++) {
                    var e = req[i];
                    console.log(e.바코드)
                    var obj = await this.addexcellists(e);
                    if (obj.nosku) {
                        nosku.push(e)
                    } else {
                        console.log(obj)
                        arr.push(this.deepClone(obj));
                    }
                }
                if (nosku.length > 0) {
                    var noskulist = ''
                    for (var j = 0; j < nosku.length; j++) {
                        if (j == nosku.length - 1) {
                            noskulist += nosku[j]
                        } else {
                            noskulist += nosku[j] + '\n'
                        }
                    }
                    alert('아래의 바코드는 SKU정보가 없어서 추가되지 않았습니다. SKU리스트 수집을 먼저 진행해 주세요. \n' + noskulist)
                } else {
                    await this.addreqlist(arr)
                }
                this.showuploadspinner = false;
                this.showlist = true;
                this.uploadstatus = '여기를 클릭해서 선택하거나, 엑셀파일을 끌어다 놓으세요.'
                this.$bvModal.hide('excelupload');
            }
        },
        async addreqlist(lists) {
            console.log(lists)
            try {
                // 데이터를 10개씩 청크로 나누어 처리
                const chunkSize = 10;
                const chunks = [];
                for (let i = 0; i < lists.length; i += chunkSize) {
                    chunks.push(lists.slice(i, i + chunkSize));
                }

                console.log(`총 ${lists.length}개 항목을 ${chunks.length}개 청크로 나누어 처리합니다.`);

                // 각 청크를 순차적으로 처리
                for (let i = 0; i < chunks.length; i++) {
                    console.log(`청크 ${i + 1}/${chunks.length} 처리 중... (${chunks[i].length}개 항목)`);

                    const res = await axios.post('/api/reqpurchase/addreqlist', chunks[i]);
                    console.log(`청크 ${i + 1} 완료:`, res);

                    // 각 요청 사이에 100ms 지연
                    if (i < chunks.length - 1) {
                        await new Promise(resolve => setTimeout(resolve, 100));
                    }
                }

                alert(lists.length + '건이 추가되었습니다.')
                this.getreqlists();
                this.$bvModal.hide('reqpurchase');
            } catch (e) {
                console.log(e)
                alert('추가실패');
            }
        },
        async addexcellists(e) {
            if (this.$store.state.growthdb && this.$store.state.growthdb.find(ele => ele.바코드 == e.바코드)) {
                var ob = this.$store.state.growthdb.find(ele => ele.바코드 == e.바코드)
                if (ob.상품매칭) {
                    var 상품매칭 = ob.상품매칭
                } else {
                    상품매칭 = {
                        옵션1_중국어: [],
                        옵션2_중국어: [],
                    }
                }
                if (ob.요청내역) {
                    var 요청내역 = ob.요청내역
                } else {
                    요청내역 = {
                        default: true,
                        poarrange: false,

                        한글표시사항: true,
                        barcode: true,
                        sticker: false,
                        sewing: false,
                        stamp: false,
                        tag: false,
                        reqcontent: '',
                        reqcontentPurchase:'',
                        opp: false,
                        LDPE: false,
                        airpacking: false,
                        exportType: 'box',
                        destination: 'coupang',
                        masking: false,
                        auto: true,
                    }
                }
                if (ob.한글표시사항) {
                    var 한글표시사항 = ob.한글표시사항;
                } else {
                    한글표시사항 = {
                        제품명: '',
                        '수입원/판매원': '',
                        제조원: '',
                        제조국: '',
                        내용량: '',
                        '원료명및성분명(재질)': '',
                        상품유형: '',
                        사용시주의사항: '',
                        사용기준: '',
                    }
                }
                var obj = {
                    checked: false,
                    showspinner: false,
                    // SKUID : ob['SKU ID'],
                    바코드: ob.바코드,
                    상품명: ob.상품명,
                    상품명init: ob.상품명,
                    구매링크: ob.구매링크 ? ob.구매링크 : undefined,
                    구매링크init: ob.구매링크 ? ob.구매링크 : undefined,
                    옵션1_중국어: ob.옵션1_중국어 ? ob.옵션1_중국어 : undefined,
                    옵션2_중국어: ob.옵션2_중국어 ? ob.옵션2_중국어 : undefined,
                    옵션이미지: ob.옵션이미지 ? ob.옵션이미지 : undefined,
                    매칭상태: ob.매칭상태 ? ob.매칭상태 : '매칭필요',
                    상품매칭: 상품매칭,
                    구매재고: '',
                    구매요청수량: e.구매요청수량 ? e.구매요청수량 : '',
                    판매구성수량: ob.판매구성수량 ? ob.판매구성수량 : 1,
                    묶음구성여부: ob.묶음구성여부 ? ob.묶음구성여부 : false,
                    묶음구성수량: ob.묶음구성수량 ? ob.묶음구성수량 : '',
                    묶음대상바코드: ob.묶음구성여부 ? ob.바코드 : '',
                    신고영문명: ob.신고영문명 ? ob.신고영문명 : '',
                    신고가격: 0,
                    HSCODE: ob.HSCODE ? ob.HSCODE : '',
                    진행현황: '구매전',
                    재고동봉: true,
                    등록이미지: ob.등록이미지 ? ob.등록이미지 : '',
                    요청사항: '요청등록',
                    reqtype: '제트배송',
                    sizeX: ob.sizeX ? ob.sizeX : '',
                    sizeY: ob.sizeY ? ob.sizeY : '',
                    sizeZ: ob.sizeZ ? ob.sizeZ : '',
                    weight: ob.weight ? ob.weight : '',
                    요청내역: 요청내역,
                    한글표시사항: 한글표시사항,
                    polists: [],
                    selectpo: '',
                }
                // this.reqinit(obj);
                var newObj = await this.confirmreq(obj);
                var foo = await this.confirmlist(newObj)
                if (foo) {
                    newObj.요청사항 = '등록완료';
                }
                return newObj
            } else {
                return { nosku: true }
            }
        },
        modalID(index) {
            // console.log(index);
            return 'modal' + index
        },
        downloadxlsx(lists) {
            if (lists.length > 0) {
                var createpo = [];
                var totalpo = [];
                //this.lists, setting값에 따라 createpo 업데이트
                var obj = {};
                var link
                var option1
                var option2
                lists.forEach(e => {
                    e.발주세부내역.forEach(ele => {
                        link = '';
                        option1 = '';
                        option2 = '';
                        this.$store.state.productdb.some(element => {
                            if (element.바코드 == ele.바코드) {
                                link = element.구매링크;
                                option1 = element.옵션1_중국어;
                                option2 = element.옵션2_중국어;
                                return (element.바코드 == ele.바코드)
                            }
                        })
                        if (ele.구매필요수량 > 0) {
                            if (link == '') {
                                alert('"' + ele.바코드 + '" 제품의 구매링크 정보가 없습니다.')
                            } else {
                                obj = {
                                    '订单号': e.발주번호,
                                    '商品名称': ele.상품명,
                                    '商品数量(件)': ele.구매필요수량,
                                    '商品规格1（如：颜色）': option1,
                                    '商品规格2（如：尺码）': option2,
                                    '收件人-姓名': this.CreatePo_수취인,
                                    '收件人-手机': this.CreatePo_연락처,
                                    '收件人-省': this.CreatePo_주소_성,
                                    '收件人-市': this.CreatePo_주소_시,
                                    '收件人-区': this.CreatePo_주소_구,
                                    '收件人-详细地址': this.CreatePo_상세주소,
                                    '收货地址（省/市/区/详细地址合并的收货地址）': '',
                                    '买家留言': ele.SKUID,
                                    '1688商品链接/1688商品id': ((link || '').match(/offer\/(\d+)/) || [])[1] || '',
                                    '分销or现货（默认或者填1走分销，0走现货）': 0,
                                }
                                totalpo.push(obj);
                            }
                        }
                    })
                })

                //1688id순으로 정렬 (중국내배송비최소화)
                totalpo.sort(function (a, b) {
                    if (a['1688商品链接/1688商品id'] < b['1688商品链接/1688商品id']) {
                        return -1;
                    }
                    if (a['1688商品链接/1688商品id'] > b['1688商品链接/1688商品id']) {
                        return 1;
                    }
                    return 0;
                })

                //주문번호 변경 (발주번호 --> timestamp0001)
                var matchpo = [];
                var matchobj = {};
                var ponum = '';

                var now = Date.now()
                var n = 0;
                totalpo.forEach((e, i) => {
                    matchobj = {};
                    if (i > 0) {
                        if (totalpo[i - 1]['1688商品链接/1688商品id'] != totalpo[i]['1688商品链接/1688商品id']) {
                            n++
                        }
                    }
                    ponum = now.toString() + (n + 1).toString().padStart(4, '0')
                    matchobj = {
                        쿠플러스주문번호: ponum,
                        발주번호: e['订单号'],
                        SKUID: e['买家留言'],
                        상품명: e['商品名称'],
                        구매수량: e['商品数量(件)'],
                        상품번호: e['1688商品链接/1688商品id'],
                        option1: e['商品规格1（如：颜色）'],
                        option2: e['商品规格2（如：尺码）']
                    };
                    matchpo.push(matchobj);
                    e['订单号'] = ponum;
                })
                //axios matchpo

                axios.post('/api/addpurchase/addmatchpo', matchpo)
                    .then((res) => {
                        this.$store.commit('matchpoupdate', res.data.matchpo);
                        alert(res.data.요청결과)
                    })
                    .catch(console.log)


                //1688po를 100개씩 잘라서 createpo array에 저장
                console.log(totalpo)
                var i
                var j
                var cnt = totalpo.length;

                for (j = 0; j < cnt; j++) {
                    if (totalpo.length < 100) {
                        createpo.push(totalpo)
                        break
                    }
                    for (i = 100; i > 0; i--) {
                        if (totalpo[i][['1688商品链接/1688商品id']] != totalpo[i - 1][['1688商品链接/1688商品id']]) {
                            console.log(totalpo.slice(0, i))
                            createpo.push(totalpo.slice(0, i))
                            totalpo = totalpo.slice(i, totalpo.length)
                            console.log(totalpo)
                            break
                        } else {
                            if (i == 1) {
                                createpo.push(totalpo.slice(0, 100))
                                totalpo = totalpo.slice(100, totalpo.length)
                            }
                        }
                    }
                }

                //test
                // const workBook = XLSX.utils.book_new()
                // const workSheet1 = XLSX.utils.json_to_sheet(totalpo)
                // const workSheet2 = XLSX.utils.json_to_sheet(matchpo)
                // XLSX.utils.book_append_sheet(workBook, workSheet1, '1688주문서')
                // XLSX.utils.book_append_sheet(workBook, workSheet2, 'matching')
                // XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '.xlsx')


                //다운로드
                for (i = 0; i < createpo.length; i++) {
                    const workBook = XLSX.utils.book_new()
                    const workSheet = XLSX.utils.json_to_sheet(createpo[i])
                    XLSX.utils.book_append_sheet(workBook, workSheet, '1688주문서')
                    XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '_' + i.toString() + '.xlsx')
                }
            } else {
                alert('생성할 주문서가 없습니다.')
            }
        },
        downloadtotal() {
            //this.lists를 1688주문서로 변환해서 다운로드
            this.downloadxlsx(this.lists);
        },
        downloadselect() {
            var selectlists = [];
            this.lists.forEach(e => {
                if (e.checked == true) {
                    selectlists.push(e)
                }
            })
            this.downloadxlsx(selectlists);
        },
        deepClone(obj) {
            if (obj === null || typeof obj !== "object") {
                return obj
            }

            const result = Array.isArray(obj) ? [] : {}

            for (let key of Object.keys(obj)) {
                result[key] = this.deepClone(obj[key])
            }

            return result
        },


        deletelist(item) {
            console.log(item)
            if (item.진행현황 === '구매전') {
                const index = this.reqlists.findIndex(i => i === item);
                var newarr = [];
                var delarr = [];
                this.reqlists.forEach((e, i) => {
                    if (i !== index) {
                        newarr.push(this.deepClone(e))
                    } else {
                        delarr.push(this.deepClone(e))
                    }
                })
                this.reqlists = newarr;
                if (confirm('삭제 후에는 복구가 불가능합니다. 그래도 삭제하시겠습니까?')) {
                    this.deletereqlists(delarr);
                }
            } else {
                alert('구매전인 상품만 삭제됩니다.')
            }
        },
        async deletereqlists(delarr) {
            axios.post('/api/reqpurchase/deletereqpurchase', delarr)
                .then((res) => {
                    if (res.data.요청결과 == '삭제완료') {
                        alert(res.data.요청결과)
                    } else {
                        alert(res.data.요청결과)
                        console.log(res.data)
                    }
                })
                .catch(console.log)
        },
        deletedetail(발주번호, SKUID) {
            var newarr = [];
            var newobj = {};
            this.lists.forEach(e => {
                if (e.발주번호 != 발주번호) {
                    newarr.push(e);
                } else {
                    newobj = this.deepClone(e);
                    newobj.발주세부내역 = [];
                    e.발주세부내역.forEach(ele => {
                        if (ele.SKUID != SKUID) {
                            newobj.발주세부내역.push(ele);
                        }
                    });
                    newarr.push(newobj);
                }
            })
            this.lists = newarr;
        },
        allchecklist(allchecked) {
            if (allchecked == true) {
                this.lists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.lists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        allcheckdetaillist(allcheckdetail) {
            if (allcheckdetail == true) {
                this.detaillists.forEach(e => {
                    e.checked = true;
                })
            } else {
                this.detaillists.forEach(e => {
                    e.checked = false;
                })
            }
        },
        getTodaywith() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + "-" + month + "-" + day;
        },
        getToday() {
            var date = new Date();
            var year = date.getFullYear();
            var month = ("0" + (1 + date.getMonth())).slice(-2);
            var day = ("0" + date.getDate()).slice(-2);

            return year + month + day;
        },
        timestamp(date) {
            //inputdate = "yyyy-mm-dd"
            return new Date(date).getTime() / 1000
        },
        downloadpo() {
            if (this.downloadlists.length > 0) {
                var createpo = [];
                var totalpo = this.downloadlists;


                //1688id순으로 정렬 (중국내배송비최소화)
                totalpo.sort(function (a, b) {
                    if (a['1688商品链接/1688商品id'] < b['1688商品链接/1688商品id']) {
                        return -1;
                    }
                    if (a['1688商品链接/1688商品id'] > b['1688商品链接/1688商品id']) {
                        return 1;
                    }
                    return 0;
                })
                //1688id순으로 정렬 (중국내배송비최소화)
                totalpo.sort(function (a, b) {
                    if (a.판매처 < b.판매처) {
                        return -1;
                    }
                    if (a.판매처 > b.판매처) {
                        return 1;
                    }
                    return 0;
                })


                //1688po를 100개씩 잘라서 createpo array에 저장
                console.log(totalpo)
                var i
                var j
                var cnt = totalpo.length;

                for (j = 0; j < cnt; j++) {
                    if (totalpo.length < 100) {
                        createpo.push(totalpo)
                        break
                    }
                    for (i = 100; i > 0; i--) {
                        if (totalpo[i][['1688商品链接/1688商品id']] != totalpo[i - 1][['1688商品链接/1688商品id']]) {
                            console.log(totalpo.slice(0, i))
                            createpo.push(totalpo.slice(0, i))
                            totalpo = totalpo.slice(i, totalpo.length)
                            console.log(totalpo)
                            break
                        } else {
                            if (i == 1) {
                                createpo.push(totalpo.slice(0, 100))
                                totalpo = totalpo.slice(100, totalpo.length)
                            }
                        }
                    }
                }

                //test
                // const workBook = XLSX.utils.book_new()
                // const workSheet1 = XLSX.utils.json_to_sheet(totalpo)
                // const workSheet2 = XLSX.utils.json_to_sheet(matchpo)
                // XLSX.utils.book_append_sheet(workBook, workSheet1, '1688주문서')
                // XLSX.utils.book_append_sheet(workBook, workSheet2, 'matching')
                // XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '.xlsx')


                //다운로드
                for (i = 0; i < createpo.length; i++) {
                    const workBook = XLSX.utils.book_new()
                    const workSheet = XLSX.utils.json_to_sheet(createpo[i])
                    XLSX.utils.book_append_sheet(workBook, workSheet, '1688주문서')
                    XLSX.writeFile(workBook, '1688주문서' + '_' + this.getToday() + '_' + i.toString() + '.xlsx')
                }
            } else {
                alert('생성할 주문서가 없습니다.')
            }
        },
        submit() {
            if (this.poinfocnt == 0) {
                this.$v.$touch()
                if (this.$v.$invalid) {
                    this.lists = [];
                    this.submitStatus = true
                    var obj = {};
                    var sobj = {};
                    var ssobj = {};
                    var robj = {};
                    var addobj = {};
                    var addcnt = 0;
                    var rstockcnt = 0;
                    var stockcnt = 0;
                    var sstockcnt = 0;
                    var elcnt = 0;
                    var existaddcnt = 0;
                    var arrangecnt = 0;
                    var notarrangecnt = 0;
                    var pstockcnt = 0;
                    //setting값에 따라 lists 업데이트

                    //날짜로 this.totallists를 추려서 저장
                    this.totallists = this.$store.state.polist.filter(e => this.timestamp(this.startdate) <= this.timestamp(e.발주일시.slice(0, 10)) && this.timestamp(this.enddate) >= this.timestamp(e.발주일시.slice(0, 10)));
                    //this.totallists에서 lists 추출
                    this.totallists.forEach(e => {
                        e.발주세부내역.forEach(ele => {
                            arrangecnt = 0;
                            notarrangecnt = 0;
                            pstockcnt = 0;
                            rstockcnt = 0;
                            if (this.$store.state.stock.length != 0) {
                                this.$store.state.stock.forEach(element => {
                                    if (element.바코드 == ele.바코드) {
                                        if (element.배치발주번호 == e.발주번호) {
                                            arrangecnt++
                                        } else {
                                            if (element.배치발주번호 == '') {
                                                if (element.Stockinfo == 'stock') {
                                                    if (parseInt(ele.확정수량) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0) {
                                                        notarrangecnt++
                                                    }
                                                } else {
                                                    if (element.Stockinfo == 'Pstock') {
                                                        pstockcnt++
                                                    } else {
                                                        if (element.Stockinfo == 'Rstock') {
                                                            if (parseInt(ele.확정수량) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0) {
                                                                rstockcnt++
                                                            }
                                                        }
                                                    }
                                                }
                                            }
                                        }
                                    }
                                })
                            }
                            ele.발주수량 = parseInt(ele.발주수량);
                            ele.입고수량 = parseInt(ele.입고수량);
                            if (isNaN(ele.입고수량)) {
                                ele.입고수량 = 0;
                            }
                            ele.확정수량 = parseInt(ele.확정수량);
                            ele.배치수량 = arrangecnt;
                            ele.미배치재고수량 = notarrangecnt;
                            ele.구매완료수량 = pstockcnt;
                            ele.회송예정수량 = rstockcnt;
                            ele.사입재고수량 = 0;
                            if (parseInt(ele.확정수량) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt > 0) {
                                this.$store.state.productdb.some(element => {
                                    if (ele.바코드 == element.바코드 && element.구매링크 == '사입') {
                                        ele.사입재고수량 = parseInt(ele.확정수량) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt;
                                        return (ele.바코드 == element.바코드 && element.구매링크 == '사입')
                                    }
                                })
                            }
                            ele.구매필요수량 = parseInt(ele.확정수량) - arrangecnt - notarrangecnt - pstockcnt - rstockcnt - ele.사입재고수량;
                        })
                    })



                    if (this.totallists.length == 0) {
                        this.showlist = false;
                        alert('생성할 리스트가 없습니다.')
                    } else {

                        this.totallists.forEach(e => {
                            addcnt = 0;
                            rstockcnt = 0;
                            stockcnt = 0;
                            sstockcnt = 0;

                            e.발주세부내역.forEach(element => {
                                existaddcnt = addcnt;
                                addcnt += parseInt(element.발주수량);
                                this.$store.state.productdb.some(el => {
                                    if (el.바코드 == element.바코드) {
                                        if (el.구매링크 == '사입') {
                                            sstockcnt += element.발주수량;
                                            ssobj = {
                                                checked: false,
                                                발주번호: e.발주번호,
                                                발주센터: e.발주센터,
                                                입고예정일: e.입고예정일,
                                                발주운송: e.발주운송,
                                                SKUID: element.SKUID,
                                                바코드: element.바코드,
                                                상품명: element.상품명,
                                                발주수량: element.발주수량,
                                                매입가: element.매입가,
                                                공급가액: element.공급가액,
                                                부가세액: element.부가세액,
                                            };
                                            this.sstocklists.push(ssobj);
                                            addcnt -= parseInt(element.발주수량);
                                        }
                                        return (el.바코드 == element.바코드)
                                    }
                                })
                                if (existaddcnt < addcnt) {
                                    this.$store.state.stock.some(ele => {
                                        if (ele.바코드 == element.바코드) {
                                            if (ele.stockinfo == 'stock') {
                                                stockcnt++
                                                if (this.stocklists.length > 0) {
                                                    elcnt = 0;
                                                    this.stocklists.forEach(el => {
                                                        if (el.발주번호 == e.발주번호 && el.바코드 == element.바코드) {
                                                            el.수량++
                                                            elcnt++
                                                        }
                                                    })
                                                    if (elcnt == 0) {
                                                        sobj = {
                                                            checked: false,
                                                            발주번호: e.발주번호,
                                                            발주센터: e.발주센터,
                                                            입고예정일: e.입고예정일,
                                                            발주운송: e.발주운송,
                                                            SKUID: element.SKUID,
                                                            바코드: element.바코드,
                                                            상품명: element.상품명,
                                                            발주수량: element.발주수량, //표에서 hide
                                                            매입가: element.매입가,
                                                            공급가액: element.공급가액,
                                                            부가세액: element.부가세액,

                                                            재고박스번호: ele.재고박스번호, //표에서 show
                                                            재고파렛트번호: ele.재고파렛트번호, //표에서 show
                                                            수량: 1, //표에서 show
                                                        };
                                                        this.stocklists.push(sobj);
                                                    }
                                                } else {
                                                    sobj = {
                                                        checked: false,
                                                        발주번호: e.발주번호,
                                                        발주센터: e.발주센터,
                                                        입고예정일: e.입고예정일,
                                                        발주운송: e.발주운송,
                                                        SKUID: element.SKUID,
                                                        바코드: element.바코드,
                                                        상품명: element.상품명,
                                                        발주수량: element.발주수량, //표에서 hide
                                                        매입가: element.매입가,
                                                        공급가액: element.공급가액,
                                                        부가세액: element.부가세액,

                                                        재고박스번호: ele.재고박스번호, //표에서 show
                                                        재고파렛트번호: ele.재고파렛트번호, //표에서 show
                                                        수량: 1, //표에서 show
                                                    };
                                                    this.stocklists.push(sobj);
                                                }

                                                addcnt--
                                                return (addcnt == existaddcnt)
                                            } else {
                                                if (ele.stockinfo == 'Rstock') {
                                                    rstockcnt++
                                                    if (this.rstocklists.length > 0) {
                                                        elcnt = 0;
                                                        this.rstocklists.forEach(el => {
                                                            if (el.발주번호 == e.발주번호 && el.바코드 == element.바코드) {
                                                                el.수량++
                                                                elcnt++
                                                            }
                                                        })
                                                        if (elcnt == 0) {
                                                            robj = {
                                                                checked: false,
                                                                발주번호: e.발주번호,
                                                                발주센터: e.발주센터,
                                                                입고예정일: e.입고예정일,
                                                                발주운송: e.발주운송,
                                                                SKUID: element.SKUID,
                                                                바코드: element.바코드,
                                                                상품명: element.상품명,
                                                                발주수량: element.발주수량, //표에서 hide
                                                                매입가: element.매입가,
                                                                공급가액: element.공급가액,
                                                                부가세액: element.부가세액,

                                                                수량: 1 //표에서 show
                                                            };
                                                            this.rstocklists.push(robj);
                                                        }
                                                    } else {
                                                        robj = {
                                                            checked: false,
                                                            발주번호: e.발주번호,
                                                            발주센터: e.발주센터,
                                                            입고예정일: e.입고예정일,
                                                            발주운송: e.발주운송,
                                                            SKUID: element.SKUID,
                                                            바코드: element.바코드,
                                                            상품명: element.상품명,
                                                            발주수량: element.발주수량, //표에서 hide
                                                            매입가: element.매입가,
                                                            공급가액: element.공급가액,
                                                            부가세액: element.부가세액,

                                                            수량: 1 //표에서 show
                                                        };
                                                        this.rstocklists.push(robj);
                                                    }

                                                    addcnt--
                                                    return (addcnt == existaddcnt)
                                                }
                                            }
                                        }
                                    });
                                }
                                if (addcnt > 0) {
                                    addobj = {
                                        checked: false,
                                        발주번호: e.발주번호,
                                        발주센터: e.발주센터,
                                        입고예정일: e.입고예정일,
                                        발주운송: e.발주운송,
                                        SKUID: element.SKUID,
                                        바코드: element.바코드,
                                        상품명: element.상품명,
                                        발주수량: element.발주수량,
                                        매입가: element.매입가,
                                        공급가액: element.공급가액,
                                        부가세액: element.부가세액,

                                        수량: addcnt,
                                    }
                                    this.addlists.push(addobj);
                                }
                            })

                            obj = {
                                checked: false,
                                발주번호: e.발주번호,
                                발주일시: e.발주일시,
                                입고예정일: e.입고예정일,
                                전체수량: e.발주수량,
                                구매필요수량: addcnt,
                                재고수량: stockcnt,
                                사입재고수량: sstockcnt,
                                회송재고수량: rstockcnt,
                                발주세부내역: e.발주세부내역
                            }
                            this.lists.push(obj);
                            this.showlist = true;
                        })

                        //리스트
                        //발주번호 - 전체수량 x개, 필요수량 x개, 회송재고 x개, 재고 x개, 사입재고 x개, 구매링크 필요수 x개 (상품DB 업데이트 필요))
                    }
                } else {
                    this.submitStatus = false;
                    alert('주문서 생성 실패')
                }
            } else {
                alert('1688주문서를 생성하려면 Products > 상품DB등록 메뉴에서 ' + this.poinfocnt + '개의 상품DB에 대한 구매정보(구매링크,중국어옵션명)를 업데이트 해주세요')
            }
        },
        savesetting() {
            var payload = {
                companyid: this.$store.state.user.companyid,
                CreatePo_수취인: this.CreatePo_수취인,
                CreatePo_연락처: this.CreatePo_연락처,
                CreatePo_주소_성: this.CreatePo_주소_성,
                CreatePo_주소_시: this.CreatePo_주소_시,
                CreatePo_주소_구: this.CreatePo_주소_구,
                CreatePo_상세주소: this.CreatePo_상세주소,
                CreatePo_주문번호: this.CreatePo_주문번호,
                CreatePo_발주기준일: this.CreatePo_발주기준일
            };

            this.$store.commit('settingsupdate', payload)
            axios.post('/api/addpurchase/addsettings', payload)
                .then((res) => { alert(res.data.요청결과) })
        }
    },
    beforeDestroy() {
        window.removeEventListener('message', this.messageEventHandler);
    },
    mounted() {
        this.messageEventHandler = async (event) => {
            if (event.data.res && event.data.res === 'importpurchaseinfo') {
                console.log(event.data);
                console.log(event.data.result[0].result);
                console.log(this.lists)
                console.log(this.currentindex)
                console.log(this.lists[this.currentindex])
                if (event.data.result[0].result) {
                    if (event.data.result[0].result.option1array.length == 0) {
                        this.lists[this.currentindex].상품매칭.옵션1_중국어 = [];
                        this.lists[this.currentindex].옵션1_중국어 = '';
                        this.lists[this.currentindex].매칭상태 = '매칭완료';
                    } else {
                        this.lists[this.currentindex].상품매칭.옵션1_중국어 = event.data.result[0].result.option1array;
                    }
                    if (event.data.result[0].result.option2array.length == 0) {
                        this.lists[this.currentindex].상품매칭.옵션2_중국어 = [];
                        this.lists[this.currentindex].옵션2_중국어 = '';
                    } else {
                        this.lists[this.currentindex].상품매칭.옵션2_중국어 = event.data.result[0].result.option2array;
                    }

                    this.lists[this.currentindex].구매링크 = this.lists[this.currentindex].구매링크init;
                    this.lists[this.currentindex].showspinner = false;


                    if (this.checkstock && Object.keys(event.data.result[0].result.info).length > 0) {
                        // console.log(this.lists[this.currentindex].구매링크)
                        var obj = event.data.result[0].result.info.obj;
                        var obj1 = event.data.result[0].result.info.obj1;
                        var obj2 = event.data.result[0].result.info.obj2;
                        this.obj1 = obj1;
                        this.obj2 = obj2;
                        this.obj = obj;
                        if (obj1) {
                            // console.log(this.lists[this.currentindex].구매링크)
                            if (obj1.length == 0) {
                                if (Object.keys(event.data.result[0].result.info.obj).length > 0) {
                                    var stockqty = event.data.result[0].result.info.obj?.globalData?.orderParamModel?.orderParam?.canBookedAmount;
                                    if (stockqty == 0) {
                                        alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                                    } else {
                                        alert('구매 가능한 재고수량 : ' + stockqty)
                                    }
                                    this.lists[this.currentindex].등록이미지 = event.data.result[0].result.info.obj?.globalData?.images[0]?.fullPathImageURI;
                                }
                            } else {
                                if (this.lists[this.currentindex]?.구매링크 !== undefined && this.lists[this.currentindex]?.옵션1_중국어 !== undefined && this.lists[this.currentindex]?.옵션2_중국어 !== undefined) {
                                    if (obj1.length == 1) {
                                        var name = obj1[0].value.find(e => e.name.includes(this.lists[this.currentindex].옵션1_중국어)).name;
                                        stockqty = obj2[name]?.canBookCount;
                                        if (stockqty == 0) {
                                            alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                                        } else {
                                            alert('구매 가능한 재고수량 : ' + stockqty)
                                        }
                                        if (this.lists[this.currentindex].등록이미지 == '') {
                                            this.lists[this.currentindex].등록이미지 = event.data.result[0].result.info.obj?.globalData?.images[0]?.fullPathImageURI;
                                        }
                                    } else {
                                        if (!obj1[0].value.find(e => e.name.includes(this.lists[this.currentindex].옵션1_중국어))) {
                                            alert('해당 링크에 "' + this.lists[this.currentindex].옵션1_중국어 + '" 옵션명이 존재하지 않습니다.')
                                            this.lists[this.currentindex].옵션1_중국어 = undefined;
                                        } else {
                                            var name1 = obj1[0].value.find(e => e.name.includes(this.lists[this.currentindex].옵션1_중국어)).name;
                                            if (!obj1[1].value.find(e => e.name.includes(this.lists[this.currentindex].옵션2_중국어))) {
                                                alert('해당 링크에 "' + this.lists[this.currentindex].옵션2_중국어 + '" 옵션명이 존재하지 않습니다.')
                                                this.lists[this.currentindex].옵션2_중국어 = undefined;
                                            } else {
                                                var name2 = obj1[1].value.find(e => e.name.includes(this.lists[this.currentindex].옵션2_중국어)).name;
                                                name = name1 + "&gt;" + name2;
                                                stockqty = obj2[name]?.canBookCount;
                                                if (stockqty == 0) {
                                                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                                                } else {
                                                    alert('구매 가능한 재고수량 : ' + stockqty)
                                                }
                                                if (this.lists[this.currentindex].등록이미지 == '') {
                                                    this.lists[this.currentindex].등록이미지 = event.data.result[0].result.info.obj?.globalData?.images[0]?.fullPathImageURI;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            if (Object.keys(event.data.result[0].result.info.obj).length > 0) {
                                stockqty = event.data.result[0].result.info.obj?.globalData?.orderParamModel?.orderParam?.canBookedAmount;
                                if (stockqty == 0) {
                                    alert('구매 가능한 재고수량이 없습니다. 판매자에게 확인해 주세요.')
                                } else {
                                    alert('구매 가능한 재고수량 : ' + stockqty)
                                }
                                this.lists[this.currentindex].등록이미지 = event.data.result[0].result.info.obj?.globalData?.images[0]?.fullPathImageURI;
                            }
                        }
                        this.currentindex = '';
                    }
                    if (this.lists[this.currentindex].구매링크) {
                        if (this.lists[this.currentindex].옵션1_중국어) {
                            if (this.lists[this.currentindex].옵션2_중국어) {
                                this.lists[this.currentindex].매칭상태 = '매칭완료'
                            } else {
                                if (this.lists[this.currentindex].상품매칭.옵션2_중국어.length > 0) {
                                    this.lists[this.currentindex].매칭상태 = '매칭필요'
                                } else {
                                    this.lists[this.currentindex].매칭상태 = '매칭완료'
                                }
                            }
                        } else {
                            if (this.lists[this.currentindex].상품매칭.옵션1_중국어.length > 0) {
                                this.lists[this.currentindex].매칭상태 = '매칭필요'
                            } else {
                                this.lists[this.currentindex].매칭상태 = '매칭완료'
                            }
                        }
                    }
                    this.showlist = true;
                } else {
                    alert('유효하지 않은 구매링크 입니다.')
                }

            }
        }
        window.addEventListener('message', this.messageEventHandler);
        this.$nextTick(function () {
            this.getreqlists();
            this.usergrade();
            this.fetchExchangeRate();
        })
    }
}
</script>
<style scoped>
::v-deep .quotation-modal-90 {
    max-width: 90vw !important;
    width: 90vw !important;
    margin: 5vh auto !important;
}
::v-deep .quotation-modal-90 .modal-content {
    max-height: 90vh;
    overflow-y: auto;
}
::v-deep .my-dropdown-class {
    transform: translate3d(0px, -30px, 0px) !important;
    max-height: 150px;
    width: 400px;
    z-index: 9999;
    overflow-y: auto;
}

::v-deep #modal-scrollable .modal-dialog {
    max-width: 90%;
    position: absolute;

    margin: auto;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
}

#quill-container {
    height: 50px;
}

#quill-container .ql-editor {
    min-height: unset;
}


.reqpo-action-button {
    width: 30px;
    height: 30px;
    display: flex;
    justify-content: center;
    align-items: center;
}

.reqpo-status {
    width: 100%;
    border: 3px solid #cccccc;
    display: flex;
    justify-content: space-between;
}

.reqpo-status-area {
    width: 30%;
    padding: 6px 20px;
}

.reqpo-status-header {
    border-bottom: 1px solid #ccced2;
    text-align: center;
    margin-bottom: 12px;
}

.reqpo-status-tit {
    margin-bottom: 4px;
}

.reqpo-status-txt {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0px;
    line-height: 1.4;
}

.reqpo-status-txt a {
    cursor: pointer;
}

.reqpo-status-txt span {
    font-weight: bold;
}

.reqpo-purchase-request-form {
    padding: 1rem;
}

.reqpo-form-section {
    background: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    margin-bottom: 1.5rem;
}

.reqpo-section-title {
    font-size: 1rem;
    font-weight: 600;
    color: #495057;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
    border-bottom: 2px solid #dee2e6;
}

.reqpo-input-wrapper {
    margin-bottom: 1rem;
}

.reqpo-stock-info {
    font-size: 0.9rem;
    color: #6c757d;
}

.reqpo-info-label {
    color: #495057;
}

.reqpo-info-value {
    font-weight: 500;
    color: #212529;
}

.reqpo-separator {
    margin: 0 0.5rem;
    color: #adb5bd;
}

.reqpo-custom-radio-card {
    padding: 1rem;
    border: 1px solid #dee2e6;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.2s ease;
}

.reqpo-custom-radio-card:hover {
    background: #e9ecef;
}

.reqpo-custom-radio-card.active {
    background: #e9ecef;
    border-color: #0d6efd;
}

.reqpo-card-title {
    font-weight: 600;
    margin-bottom: 0.5rem;
}

.reqpo-card-desc {
    font-size: 0.85rem;
    color: #6c757d;
}

.reqpo-warning-box {
    background: #fff3cd;
    border: 1px solid #ffeeba;
    border-radius: 6px;
    padding: 1rem;
}

.reqpo-warning-text {
    color: #dc3545;
    font-size: 0.85rem;
    margin-top: 0.25rem;
}

.reqpo-option-group {
    border-bottom: 1px solid #dee2e6;
    padding-bottom: 1rem;
    margin-bottom: 1rem;
}

.reqpo-option-title {
    font-weight: 500;
    color: #495057;
    font-size: 0.9rem;
}

.reqpo-text-muted {
    font-size: 0.85rem;
}
</style>
